/*
 * @Author: yusha
 * @Date: 2024-04-19 14:04:48
 * @LastEditors: yusha
 * @LastEditTime: 2024-08-13 11:08:20
 * @Description:
 */
export default {
  清算后扣除: '実費（清算後）',
  未清算: '未清算',
  已经清算: '清算完了',
  结算状态: '清算状況',

  //   未结算: '未清算',
  //   结算中: '清算中',
  //   已结算: '清算完了',

  部分清算: '一部清算済み',
  扣费明细: '費用明細',
  实际扣除: '実費',
  待生成: '注文精算待ち',
  '已退押金/押金': '返金済額 / 総額',
  合计费用: '合計費用',
  '当商品状态更改为“已检”和“已取消”，则会清算指定的商品金额，订单的所有商品状态更改为“已清算”，则订单清算完成': '商品のステータスが「検品済み」または「キャンセル済み」に変更されると、その金額が清算されます（預かり金を返金し、実際の費用のみ差し引きます）。全商品の状態が「清算済み」になれば、注文は清算完了とみなされます',
  //   ------------------------------------
  实物图片: '実物写真',
  简易检品: '詳細検品（表のみ）',
  详细检品: '詳細検品（表＋裏側）',
  开扣眼: 'ボタンホール開け',
  缝布标: '布タグ縫い付け',
  缝水洗标: '洗濯タグ縫い付け',
  '去原标（水洗标、布标、吊牌）': '元タグ取り外し（洗濯タグ、布タグ、吊り札）',
  首饰台纸: 'アクセサリー用台紙付け替え',
  检针服务: '検針作業',
  熨烫: 'アイロンがけ',
  除味: '脱臭作業',
  '感谢卡（检品时放在每件商品内）':
    'サンクスカード入れ（検品際に各商品に入れ）',
  '丝带包装（检品时放在每件商品内）': 'リボン包装（検品際に各商品に入れ）',
  '雪梨纸包装（检品时放在每件商品内）': '薄葉紙包装（検品際に各商品に入れ）',
  穿吊牌: '吊り札掛け（糸ロックス）',
  通电检查: '通電検査',
  '刮刮卡（检品时放在每件商品内）':
    'スクラッチカード入れ（検品際に各商品に入れ）',
  '优惠券（检品时放在每件商品内）':
    'クーポンカート入れ（検品際に各商品に入れ）',
  '保证卡（检品时放在每件商品内）': '保証カート入れ（検品際に各商品に入れ）',
  说明书: '取扱説明書入れ',
  普通OPP袋: '（普通OPP袋）替え',
  定制OPP袋: '（自社ブランドOPP袋）替え',
  特殊收纳袋: '特殊収納袋替え',
  '其他物料放置（检品时放在每件商品内）':
    '他の付属品入れ（検品際に各商品に入れ）',
  尺寸测量服务: '商品採寸',
  气泡膜: 'プチプチ梱包',
  商品缠绕膜服务: 'ストレッチフィルム梱包',
  商品缓冲垫服务: 'クッション梱包',
  剪原标: '元タグ取り外し',
  剪布标: '布タグ取り外し',
  剪水洗标: '洗濯タグ取り外し',
  剪吊牌: '吊り札取り外し',
  '尺寸变更(缝尺码标)': 'サイズ変更（サイズタグ縫い付け）',
  '尺寸变更(尺码贴)': 'サイズ変更（サイズシール表記）',
  宽松检品: 'ゆるい検品（表のみ）',
  圧縮袋梱包: '圧縮袋梱包',
  新商品服务: '新商品確認（商品撮影＋商品採寸）',
  '感谢卡（发货时放在每个包裹里）':
    'サンクスカード入れ（梱包際に各パッケージに入れ）',
  '丝带包装（发货时放在每个包裹里）':
    'リボン包装（梱包際に各パッケージに入れ）',
  装箱服务: '段ボール梱包作業',
  贴标: 'Amazonラベル貼る',
  贴标2: 'ラベル貼り付け',
  打托盘: 'パレット梱包',
  '雪梨纸包装（发货时放在每个包裹里）':
    '薄葉紙包装（梱包際に各パッケージに入れ）',
  '刮刮卡（发货时放在每个包裹里）':
    'スクラッチカード入れ（梱包際に各パッケージに入れ）',
  '优惠券（发货时放在每个包裹里）':
    'クーポンカート入れ（梱包際に各パッケージに入れ）',
  '保证卡（发货时放在每个包裹里）':
    '保証カート入れ（梱包際に各パッケージに入れ）',
  '其他物料放置（发货时放在每个包裹里）':
    '他の付属品入れ（梱包際に各パッケージに入れ）',
  '发货袋-普通快递袋': '普通発送袋',
  商品打木架: '木枠梱包',
  贴箱唛: '箱ラベル',
  // 异常订单
  商品问题原因: '連絡理由',
  商品数量: '数量',
  请选择处理方式: '対応方法を選択',
  只可选择一种: '1つだけ選択可能',
  更换颜色: 'カラー変更',
  取消商品: 'キャンセル',
  换个链接: '商品URL変更',
  平台商品SKU: 'THE CKB SKU',
  'THE CKB订单编号': 'THE CKB注文番号',
  申请售后时间: '申請日時',
  售后进度: '対応ステータス',
  售后原因: '申請理由',
  导出订单: 'ダウンロード',
  重新发起: '再申請',
  撤销: 'キャンセル',
  申请售后: 'アフター補償申請',
  撤销售后: 'アフター補償申請の取り消し',
  申请时间: '申請日時',
  取消进度: '取消ステータス',
  '该操作，会将已发起售后商品信息撤销，请确认是否撤销该商品售后？':
    '【ご確認下さい】 申請済のアフター補償申請を取り消すと、当該商品では再度受領後返金を申請出来ません。申請を取り消しますか',
  撤销商品不可再次发起撤销: '撤销商品不可再次发起撤销',
  请选择售后原因: '申請理由',
  详细说明: '詳細',
  申请售后数量: '申請数量',
  售后退款金额: '返金額',
  '点击上传图片（最多上传5张）(只能上传jpg/png文件，且不超过10M)':
    '画像のアップロード（最大5枚まで。形式:jpg/png 10M以内））',
  '点击上传图片（最多上传5张）(只能上传jpg/png文件，且不超过10000kb)':
    '画像のアップロード（最大5枚まで。形式:jpg/png 10000kb以内））',
  撤销成功: 'アフター補償申請　提出取消',
  问题处理: '対応指示 選択',
  问题处理2: '異常注文履歴',
  售后: 'アフター補償申請',
  申请取消: 'キャンセル申請',
  商品取消履历: 'キャンセル履歴',
  待处理: '対応待ち',
  业务处理中: '業務側審査中',
  财务处理中: '経理側審査中',
  已退款: '返金済み',
  已拒绝: '拒否済み',
  已拒绝2: '支払拒否',
  已拒绝4: '却下済',
  '重新发起（处理中）': '再申請（審査中）',
  已撤销: '取消済み',
  次品: '返品不可不良品',
  次品2: '不良品',
  相异品: '相違品',
  数量不足: '数量不足',
  处理中: '処理中',
  保留库存: '在庫保管',
  取消成功: 'キャンセル済',
  商品信息: '商品情報',
  '商品信息(CM)': '商品情報(CM)',
  问题生成时间: '連絡日',
  处理方式: '対応ステータス',
  取消数量: 'キャンセル数',
  退款金额: '返金額',
  申请售后件数: '申請数量',
  拒绝原因: '理由',
  拒绝原因2: '拒否する理由',
  退款总金额: '返金総額',
  退款说明: '明細',
  不可优先发货: '不可',
  '可优先发货(订单下部分商品已全部上架)': '優先発送可（検品済商品）',
  未处理: '未対応',
  已处理: '対応済み',
  '商品与运输方式不匹配，THE CKB为您推荐了更合适的运输方式，需要您进行确认':
    'THE CKBより配送会社の変更提案あり指定配送会社で、配送不可（未取扱商品あり） OR 別配送会社で良条件ありご確認下さい',
  待确认运输方式: '配送会社変更（確認待ち）',
  原运输方式: '指定配送会社',
  建议运输方式: '推奨配送会社',
  使用新运输方式: '推奨配送会社に変更',
  使用原运输方式: '指定配送会社で発送',
  按照建议运输方式发货: '推奨配送会社に変更',
  批量处理: '選択項目を一括変更',
  国际料金表: '国際料金表',
  保持原运输方式发货: '指定配送会社で発送',
  整单确认: '発送依頼書単位',
  按SKU确认: 'sku単位',
  '如果此单使用多种运输方式，提交后将会拆分成多个国际发货单子单':
    'ご注意下さい！2つ以上の配送会社利用の場合、国際発送依頼書が複数に分割されます',
  此国际发货单已取消发货: '該当発送依頼書のキャンセル完了',
  '成功，此国际发货单将按照建议运输方式发货': '推奨配送会社に変更完了',
  '成功，此国际发货单将保持原运输方式发货':
    '配送会社の変更なし（指定配送会社）',
  '此单包含X种运输方式，生成了Y个国际发货单':
    '<span style="color:var(--fcolor)">X</span>種類の配送会社利用により、国際発送依頼書が<span style="color:var(--fcolor)">Y</span>個に分割されました',
  // 我的订单
  商品sku: '商品sku',
  组合附加项: 'セット組オプション',
  下单组合数: 'セット組注文数',
  组合完成数: 'セット組完了数',
  '服务费（元）': '手数料（元）',
  组合状态: '対応ステータス',
  商品画像: '商品画像',
  本单质检上架数: '良品数',
  转结落单库存数: '残在庫利用数',
  组合落单库存处理情况: '本注文残在庫',
  国家: '国',
  都道府県: '都道府県',
  序号: 'No.',
  商品单价: '商品単価',
  '总价（RMB）': '合計額（RMB）',
  总价2: '合計額',
  商品状态: 'ステータス',
  详情费用: '費用明細',
  代买手续费: '代行手数料',
  入库手续费: '入庫手数料',
  质检手续费: '検品手数料',
  发货手续费: '発送手数料',
  发货单号: '発送依頼番号',
  生成时间: '作成日時',
  国际运单号: '追跡番号',
  重量g: '重量（g）',
  是否发货: '配送状況',
  发货时间: '発送日時',
  商品番号: '商品番号',
  其他费用: 'その他',
  费用类型: '種類',
  费用明细: '費用明細',
  时间: '日時',
  地址详情: '詳細住所',
  客户订单编号: 'お客様注文番号',
  下单时间: '注文日時',
  详情地址: '詳細住所',
  编辑地址: '住所を編集',
  取消并退款: '返金済み',
  已上架: '検品済み',
  检品中: '検品中',
  异常: '異常',
  国内运输中: '国内運送中',
  已发货: '完了',
  已采购: '買付完了',
  采购中: '買付対応中',
  已入库: '入庫済み',
  待采购: '買付待ち',
  查看: '詳細',
  发货单详情: '発送詳細',
  未发货: '出荷待ち',
  编辑收货地址: 'お届け先編集',
  费用详情: '費用明細',
  请确认取消信息: 'キャンセル情報',
  '确认是否取消？': 'ご注意ください',
  合: '合',
  订单编号: 'お客様注文番号',
  等待审核: '審査待ち',
  下单成功: '発注完了',
  订单来源: '発注元',
  订单类型: '注文種類',
  国际物流信息详情: '国際配送情報',
  业务类型: '仕入れ元',
  取消结果: 'キャンセル状況',
  所有订单: '全て',
  待付款: '支払い待ち',
  可发货: '発送待ち',
  部分发货: '一部発送待ち',
  已完成: '完了',
  已完成2: '支払完了',
  物流公司: '運送会社',
  国际物流单号: '国際配送番号',
  发货数量: '配送数量',
  是否合单: '発送状態',
  Base: 'Base',
  Shopify: 'Shopify',
  Stores: 'STORES',
  Amazon: 'Amazon',
  直发订单: '直送注文',
  囤货订单: '在庫保管注文',
  可优先发货: '可',
  未组合: '対応待ち',
  组合中: '対応中',
  组合完成: '対応完了',
  取消组合: 'キャンセル',
  日志: '操作ログ',
  详情: '詳細',
  优先发货: '分納発送',
  去支付: 'お支払いへ',
  是否去支付: 'お支払いへ',
  国际物流单号信息: '国際配送依頼番号',
  商品日志详情: '操作ログ',
  支付成功: 'お支払い完了',
  结束时间: '締め切り日',
  商品搜索: '商品検索',
  下单日: '注文日',
  发货日: '発送日',
  客户商品信息: 'お客様商品情報',
  客户商品SKU: 'お客様商品SKU',
  客户商品名称: '商品名',
  客户商品规格: 'お客様商品規格',
  客户商品图片: '商品画像',
  采购商品SKU: 'THE CKB SKU',
  采购商品信息: 'THE CKB商品情報',
  采购商品名称: 'THE CKB商品名',
  采购商品规格: 'THE CKB商品規格',
  采购商品图片: 'THE CKB商品画像',
  商品采购渠道: '仕入れ元',
  商品状态变更日志: 'ステータス変更履歴',
  操作记录: '操作ログ',
  变更时间: '変更日時',
  '已上架（已清算）': '検品済',

  // 授权店铺
  '你授权的xxx店铺取消授权后，店铺订单和商品将不再同步，是否继续取消？': `API連携解除により、xxxデータは読み込み不可になります。
      API連携を解除しますか`,
  是: '連携解除',
  否: 'キャンセル',
  解绑成功: '解除完了',
  店铺名: '店舗名',
  创建时间: '作成日時',
  状态: '状態',
  店铺钱包可用余额: '残高',
  店铺账号: 'アカウント情報',
  api权限: '権限',
  店铺管理: '店舗管理',
  授权店铺管理: '店舗管理',
  添加新店铺: '店舗追加',
  激活子账号: '子アカウント作成',
  配置店铺: '店舗設定',
  开启自动同步下单: '自動発注',
  取消授权: '連携解除',
  创建成功: '紐付け完了',
  创建成功2: '保存しました',
  修改成功: '変更完了',
  店铺修改成功: '店舗情報 変更完了',
  物流配置修改成功: '変更が成功しました',
  // 我的钱包
  水洗标制作: '洗濯タグ作成',
  日本配送公司: '運送会社',
  国际发货单号: '国際配送依頼番号',
  偏远地区附加费: '遠方輸送手数料',
  偏远地区附加费退回: '遠方輸送手数料返金',
  '出账 / 入账': '出入金',
  余额: '残高',
  明细: '明細',
  流水号: '受付番号',
  日期: '作成日時',
  可用余额: '利用可能残高',
  直行发货单号: 'THE CKB発送依頼番号',
  出账: '出金',
  入账: '入金',
  充值: 'チャージする',
  转账: '振替する',
  表格导出: 'ダウンロード',
  的钱包: '口座一覧',
  主账号钱包: '親アカウント口座一覧',
  我的店铺钱包: '口座一覧',
  冻结金额: 'お預かり金額',
  未入账金额: 'チャージ申請中（審査待ち）',
  查询: '検索',
  收据下载: '入金領収書ダウンロード',
  银行名: '振込銀行名',
  金额: '振込金額',
  币种: '貨幣種類',
  上传凭证: 'クリックしてアップロード',
  '振込金額(日本円)': '振込金額(日本円)',
  公司名称: '会社名',
  店铺主页入口: 'ホームページ',
  姓氏: '氏',
  名字: '名',
  邮箱地址: 'メールアドレス',
  国际: '国籍',
  存入金额: '振込金額',
  '加载完成！': '読込み完了!',
  '充值成功！': 'チャージ完了!',
  充值成功: 'チャージ完了',
  收款账号: '振替先口座情報',
  最多可转账金额: '振替可能額',
  '商品sku/店铺商品sku/海外仓sku': '商品sku/お客様商品sku/日本倉庫SKU(FNSKU)',
  店铺商品sku: 'お客様商品sku',
  选择地址: '住所選択',
  输入的手机号位数不正确: '正しい電話番号を入力して下さい',
  区町村不能为空: '区町村不能为空',
  最少3个文字以上: '3文字以上を入力して下さい',
  请输入正确的邮编: '正しい郵便番号を入力して下さい',
  地址添加成功: '新住所の追加完了',
  'sku/平台商品信息': 'sku/商品情報',
  库存数量: '良品数',
  客户商品sku: 'お客様SKU',
  海外仓sku: '日本倉庫SKU',
  店铺名称: '店舗名',
  需要填写清关地址: 'Importer住所を入力してください',
  选择清关地址: 'Importer住所を選択',
  添加清关地址: 'Importer住所を追加',
  补货批次标题: '納品タイトル',
  箱唛上传: '箱ラベル',
  物流方式: '運送会社',
  kg: 'kg',
  计算: '計算',
  预估物流价: '参考送料',
  '注意：您可以在此输入预计的重量 大致估算出物流价格，货品发出前将根据实际扣除物流费用，请确保您的账户余额充足，余额不足无法扣款将影响您的发货进度。':
    '【ご注意下さい】 送料は概算費用になります。実発送重量に基づき、確定した国際送料を口座引落し致します。',
  填写: '入力',
  移除: '削除',
  请选择商品: '商品を選択してください',
  '区町村-详细地址': '区町村ー詳細住所',
  国际发货标题不能为空: '※必須項目です',
  必填: '※必須項目です',
  必填2: '必須項目です',
  物流方式不能为空: '※必須項目です',
  保存成功: '保存完了',
  '文件大小不超过50m；支持格式doc;excel;pdf;': `形式：doc、excel、pdf
      容量：50Ｍ以内`,
  箱唛上传不能为空: '※必須項目です',
  拣货中: 'ピッキング作業中',
  打标中: 'ラベル貼り付け中',
  打包中: '梱包中',
  打包完成: '梱包完了',
  标题: '納品タイトル',
  运单号: '追跡番号',
  大件fba: '大口配送（FBA）',
  大件普通: '大口配送（FBA以外）',
  小件: '小口配送',
  次品退货: '不良品返品',
  异常退货: '異常品返品',
  仓库调拨: '倉庫調達中',
  创建补货计划: 'Amazon納品プランを作成',
  'Amazon sku': 'Amazon sku',
  sku: 'sku',
  补货批次号: 'Amazon納品番号',
  国际运费号: '追跡番号',
  运输方式: '輸送方法',
  合计总额: '合計額',
  AMAZON商品名称: 'Amazon商品名',
  计划发货数量: '配送予定数',
  基本详情: '配送情報',
  发货重量: '総重量（梱包後の重量）',
  计费重量: 'THE CKB請求重量',
  国际发货状态: '配送状況',
  '收货仓/地址': '納品先',
  配送件数: '配送件数',
  箱数: '箱数',
  装箱清单: '納品書',
  装箱清单2: 'パッキングリスト',
  商品内容: '商品詳細',
  创建国际发货: '国際配送依頼',
  // oem
  寻源表: '見積依頼書',
  寻源种类: '商品品類',
  类别: 'プラン',
  X类: 'X類',
  类别注明: 'サービス内容',
  产品名称: '商品名',
  参考图片: '参考画像',
  提供项: '参考情報',
  是否提供: '提供済',
  具体内容: '詳細',
  参考链接: '参考URL',
  样衣: 'サンプル',
  物流单号: '追跡番号',
  需要改动的地方: '変更したいところ',
  '描述内容(材质，设计，颜色，尺寸等)':
    'デザイン説明（生地、デザイン、カラー、サイズ等）',
  附件: '添付ファイル',
  式样书: '仕様書',
  '附件(包含产品的色卡、尺寸、特殊工艺、面料信息等)':
    '添付ファイル（商品のカラー、サイズ、デザイン、生地などの情報をご入力ください）',
  面料: '生地',
  需求描述: '変更したいところの説明',
  面料信息: '生地詳細',
  色卡信息: 'カラー',
  Logo: 'Logo',
  '详细说明(颜色、尺寸、位置、工艺等)':
    '説明（カラー、サイズ、ロゴのプリント位置）',
  辅料种类: '資材種類',
  'THE CKB预选方案选择': 'THE CKBの推薦方案を選択',
  分类: 'カテゴリ',
  选择方案: '詳細',
  定制补充部分: 'お客様ご要望',
  文字描述: '説明',
  材质方案: '生地方案',
  款式方案: 'デザイン方案',
  尺寸方案: 'サイズ方案',
  颜色方案: 'カラー方案',
  款式描述: 'デザイン詳細',
  材质描述: 'サイズ詳細',
  尺寸描述: '尺寸描述',
  颜色描述: 'カラー詳細',
  设计图或参考图片: '画像',
  产品信息: '商品詳細',
  具体尺码信息: 'サイズガイド',
  对应关系: '詳細',
  自己提供: 'サイズガイドを提出する',
  尺码表: 'サイズガイド',
  参考链接尺寸: '商品ページの寸法を参考',
  'THE CKB提供': 'THE CKB提案',
  其他补充: '備考',
  下单需求: '注文情報',
  期望价格: '希望価格',
  期望交期: '希望納期',
  期望起订量范围: '希望ロット数',
  侧重点: '重視すること',
  品质: '品質',
  交期: '納期',
  Logo需求情况: 'ロゴ詳細を述べてください',
  需要: 'はい',
  不需要: 'いいえ',
  '工厂、资质要求': '指定工場、許可証に関するご要望',
  特殊需求: 'その他のご要望',
  服装: 'アパレル',
  杂货: '雑貨',
  辅料: '資材',
  内容: '詳細',
  备注说明: '備考',
  操作人: 'ユーザー',
  报价信息: '見積書',
  是否加Logo: 'Logo入り',
  是否为特殊面料: '特殊生地',
  次品处理方式: '不良品処理',
  风险: 'リスク',
  打样费: 'サンプル代',
  打样时间: 'サンプル納期',
  天: '日',
  时: '時間',
  分: '分',
  秒: '秒',
  最小起订量: '最低ロット数',
  单尺码: 'ワンサイズ',
  多尺码: '複数サイズ',
  商品数量区间: '商品数',
  阶梯价格: '価格',
  报价有效期: '見積書有効期間',
  国际运费说明:
    '※商品より工場から弊社倉庫までへの国内配送料が発生する場合があります。配送料が発生する場合、残高より費用をお引き落としいたします。',
  全部订单: '注文リスト一覧',
  未发布: '未提出',
  等待报价: '見積待ち',
  已报价: '見積確認',
  寻源成功: '見積完了',
  报价失效: '見積書有効期間切れ',
  已取消: 'キャンセル済',
  已取消2: '支払取消',
  重新发布: '再提出',
  再次买入单号: '再購入番号',
  类型: '品類',
  申请表: '申請リスト',
  商品名: '商品名',
  查看明细: '詳細',
  发起时间: '作成日時',
  寻源单编号: '見積書依頼書番号',
  查看详情: '詳細',
  拒绝备注: '備考',
  是否确认编辑: '再編集しますか',
  是否确认发布寻源单: '発注',
  发布: '提出',
  是否确认取消待发布寻源单: 'キャンセルしますか',
  是否确定下样品单: 'サンプル発注しますか',
  下样品单: 'サンプル発注',
  是否确定下大货单: '量産をしますか',
  下大货单: '量産',
  是否确认申请退款: '返金しますか',
  申请退款: '返金リクエスト',
  报价过期: '見積書有効期間切れ',
  是否确认申请复购: '見積有効期間が切れました、最新の見積を依頼しますか',
  复购申请: '再購入',
  是否确认重新编辑: '再編集しますか',
  重新编辑: '編集',
  重新编辑2: '再編集する',
  操作日志: '操作ログ',
  发布成功: '提出完了',
  退款成功: '返金完了',
  已提交申请复购: '已提交申请复购',
  复购申请中: '見積依頼中',
  复购已拒绝: '拒否済み',
  复购已报价: '見積確認中',
  //
  关联异常: '紐付けエラー',
  待关联: '紐付け待ち',
  售卖价格: 'お客様販売価格',
  关联状态: 'SKU紐付け',
  已关联SKU数量: 'SKU紐付け済',
  采购商品名: 'THE CKB商品名',
  采购价格: '仕入れ価格',
  采购商品图: 'THE CKB商品画像',
  '该店铺未授权同步数据功能，授权后可绑定商品，享受自动下单功能。':
    'API未連携，API連携により注文自動処理可能',
  '因采购链接发生变动，请重新绑定':
    '仕入れ先URL変更済，再度仕入れ先紐付け処理をして下さい',
  编辑关联: '紐付け変更',
  番号保存成功: '保存完了',
  组合商品SKU: 'セット組番号',
  组合在库状态: '残在庫',
  '单价（元）': '単価（元）',
  '待组合库存数量（截止时间）': '単品残在庫数(組合せ期限)',
  组合商品管理: 'セット組商品一覧',
  扩大加购: 'カートに追加',
  完结: '単品として管理',
  加购: 'カートに追加',
  附加项修改成功: 'オプションの変更が完了しました',
  添加成功: '追加完了',
  完结成功: '単品商品管理に変更完了',
  存在待组合: '残在庫あり',
  不存在待组合: '残在庫なし',
  找相似: '類似商品(THE CKB)',
  断开: '解除',
  店铺商品sku解绑成功: '紐付けを解除しました',
  选定: '選択',
  已连接其他SKU: '紐付け済み',
  断开原有链接: '紐付けを解除する',
  请选择采购商品sku: 'THE CKB商品を選択してください',
  请选择店铺商品sku: 'お客様商品を選択してください',
  请选择商品附加项: '商品オプションを選択してください',
  店铺商品sku绑定成功: 'THE CKB商品と紐付けが完了しました',
  '同步商品进行中，请等待1-3分钟': '商品取り込み中です。1〜3分間お待ちください',
  同步成功: '取込みが完了しました',
  '10-20元': '10-20元',
  '20-30元': '20-30元',
  '30-50元': '30-50元',
  '50-100元': '50-100元',
  '100-150元': '100-150元',
  '200-300元': '200-300元',
  '300元以上': '300元以上',
  选择要链接的商品: '仕入れ元商品を選択',
  选择要链接商品的SKU: 'SKUと紐付け',
  自动同步采购订单: '発注情報を自動取込み',
  '同步已授权的店铺内商品，并进行绑定':
    '店舗商品情報を取込み、仕入れURLと紐付け',
  搜索青蛙商品: '商品を検索する',
  商品链接或商品名: 'URL、商品名、THE CKB SKUで検索して注文',
  类目筛选: 'カテゴリー',
  价格筛选: '価格',
  采购商品: '仕入れ元',
  店铺商品: 'お客様商品',
  重新选择商品: '仕入れ元再設定',
  创建关联: 'SKU紐付け',
  系统查询到您有辅料未添加到附加项配置: 'オプションに資材を関連されてません',
  平均单价: '平均単価',
  锁定: '利用予定',
  可用: '利用可能在庫',
  待处理次品: '不良品（返品不可）',
  辅料图片: '画像',
  辅料名称: '資材名',
  关联附加项: 'オプション紐付け',
  辅料规格: '規格',
  辅料skuid: '資材SKU',
  待入库: '入庫待ち',
  次品图: '画像',
  说明: '詳細',
  说明2: 'ご注意',
  丢弃: '廃棄',
  转为正常商品: '良品として入庫',
  我的商品库存: '商品在庫管理',
  我的物料: '資材在庫管理',
  未关联附加项: '未紐付け',
  '未关联附加项的辅料，将不会再订单商品中自动使用': `オプション適用 未設定資材あり
      注文時のオプションで資材利用不可`,
  配置附加项: 'オプション紐付け',
  辅料绑定提醒: '資材のオプション適用を設定して下さい',
  '物料名/sku': '商品名/SKU',
  已有关联附加项: '紐付け済',
  未有关联附加项: '未紐付け',
  可用库存数量筛选: '在庫数',
  至: '-',
  清空: 'クリア',
  批量加入购物车: '一括でカートに追加',
  '关闭自动续费后，您的会员将于':
    '会員費自動支払いの解除より、現会員クラスの利用が ',
  到期请前往paypal平台关闭自动续费:
    'Paypal公式サイトにてご自身で自動支払いの設定を解除して下さい',
  '到期是否现在关闭？': 'に終了します',
  '恭喜！！！已为您开启自动续费，记得保持余额充足':
    '会員費の自動引き落としをONにしました',
  支付方式: 'お支払い方法',
  购买明细: 'お支払い明細',
  会员信息: '会員プラン',
  原价: '通常購入価格',
  优惠金额: 'おまとめ割引',
  ヶ月: 'ヶ月',
  有效期: '有効期間',
  总计: '合計',
  立即支付: 'お支払いへ',
  立即支付2: '即時支払',
  '购买会员到期后我们会为您自动续费，您可在工作台-会员管理中关闭自动续费服务':
    '有効期限失効前に会員費を口座から自動引落し可能。自動引落設定の解除は、会員情報ページから変更可能',
  月会员办理: '会員プラン',
  每月: '月',
  选择办理会员周期: '利用期間',
  请联系主账号更改会员等级: '親アカウントのみ変更可能',
  去充值: '資金チャージへ',
  去充值2: 'チャージ画面へ',
  您的账户余额不足: '口座残高不足',
  确认支付: 'お支払いへ',
  '立即购买（自动续费）': 'お支払いへ',
  '购买后新会员等级立即生效，原有等级作废，如有疑问请联系客服':
    '即時で変更後会員プラン適用可能',
  请选择会员套餐: '会員プランを選択',
  自动续费中: '会員費自動引き落とし',
  开通自动续费: '会員費自動支払い ON',
  到期: '終了日',
  关闭成功: '会員費自動支払い OFF 変更完了',
  // 我的消息
  我的消息: 'メッセージ',
  全部已读: '全て既読',
  已读: '既読',
  '未读/已读': '未読/既読',
  // 表单
  姓名: '氏名',
  请输入姓名: '依頼主を入力してください',
  手机号: '電話番号',
  请输入手机号: '電話番号を入力',
  请输入市区町村: '市区町村を入力してください',
  请输入详细地址: '詳細住所を入力してください',
  请输入邮编: '郵便番号を入力してください',
  请输入邮箱: 'メースアドレス',
  '你的子账号没有修改权限，请联系主账号管理者修改你的密码':
    'サブアカウントでの情報修正は出来ません。メインアカウトからご対応下さい',
  无效内容: '無効値',
  无效的地址: '住所が無効です',
  收件人姓名不能为空: '※必須項目です',
  市不能为空: '※必須項目です',
  添加地址: '保存',
  // 确认框
  确定删除该商品: '選択中の商品を削除しますか？',
  确定不再显示该商品: 'この商品を非表示にしますか？',
  确定清空购物车: '選択された商品を削除しますか？',
  确定删除此配置: 'この設定内容を削除しますか？',
  确定删除此地址: 'この住所を削除しますか？',
  '当前页面的修改内容未保存，是否离开':
    '変更は保存されていません　他のページに移行しますか',
  // 消息框
  请至少选择一个配置类目: '少なくとも1つのカテゴリーを選択してください',
  请将收货人信息填写完整后提交订单: 'お届け先情報の入力が必要です',
  '单笔订单价值不得超过XX元，请调整商品数量':
    '注文上限額超過，D2C直送の注文合計額上限は、XX元/回　です',
  添加附加项模板成功: 'ディフォルトオプションを追加しました',
  修改附加项模板成功: 'ディフォルトオプションの変更が完了しました',
  修改邮箱成功: 'メールアドレスの変更が完了しました',
  // 登录
  登录: 'ログイン',
  请登录: 'ログイン',
  请先登录: 'ログイン',
  密码登录: 'ユーザー名でログイン',
  邮箱验证登录: 'メールアドレスログイン',
  获取验证码: '認証コードを送信',
  忘记密码: 'パスワードを忘れた方',
  '没有账号?去注册会员': '新規会員登録',
  '用户名或邮箱不正确，请重新输入1-10位用户名或邮箱': `ユーザー名入力誤り。
      ユーザー名は、1~18以内の半角英数文字で設定して下さい`,
  '输入的密码格式不正确，密码由6-32位字母或数字组成':
    'パスワード入力誤り。パスワードは、6~32文字以内の半角英数で設定して下さい',
  '邮箱格式不正确，请重新输入': 'メールアドレスは正しくありません',
  '验证码格式不正确，请重新输入':
    '認証コードは無効です。正しい認証コードを入力してください。',
  '验证码正在发送，请注意查收':
    '認証コードの送信が進行中です。受信箱をご確認ください',
  '密码不正确，请重新输入': 'パスワード入力誤り。',
  '用户名或密码不正确，请重新输入': 'ユーザー名入力誤り。',
  '邮箱或验证码错误，请重新输入':
    '認証コード無効。再度認証コードを送付し、正しい認証番号を入力して下さい',
  密码不能为空: 'パスワードを入力してください',
  用户名不能为空: '※必須項目です',
  输入用户名: 'ユーザー名を入力',
  输入密码: 'パスワードを入力',
  输入邮箱: 'メールアドレスを入力',
  输入验证码: '認証コードをご入力ください',
  找回密码: 'パスワードお忘れの場合',
  重设密码: 'パスワード再設定',
  注册邮箱: 'メールアドレス',
  邮箱验证码: '認証コード',
  新密码设置: '新しいパスワード',
  再次确认新密码: '新しいパスワード(確認用)',
  密码修改成功: `パスワード再設定が完了しました。
    ただいま再設定したログインパスワードでログインしてください`,
  '密码修改成功，请重新登录': 'パスワード再設定が完了しました。\nただいま再設定したログインパスワードでログインしてください',
  提交: '確定',
  提交_: '提出',
  // 注册
  注册: '新規登録',
  免费注册: '新規登録',
  '已有会员，': '',
  立即登录: 'ログイン',
  请选择适合你的业务类型: '仕入れ方法を選択して下さい',
  适合想要进货到日本仓库的用户: '日本倉庫へ納品（大口配送）',
  适合想要从中国直发商品到末端客户的用户: 'エンドユーザーへ直送（小口配送）',
  // 占行
  立即进入: 'ホームページへ',
  用户名: 'ユーザー名',
  联系人姓名: '氏名',
  密码: 'パスワード',
  再次确认密码: 'パスワード（確認用）',
  性别: '性別',
  先生: '男性',
  女士: '女性',
  邮箱: 'メールアドレス',
  验证码: '認証コード',
  联系电话: '電話番号',
  已发送: '送信済',
  '已发送{X}S': '{X}S 認証コードを再送信',
  该用户名已被注册: `このユーザー名は既に使用されています
    別のユーザー名を入力してください`,
  '用户名不可用，请重新设置1-18位用户名不支持标点符号': `ユーザー名入力誤り。
      ユーザー名は、1~18以内の文字で設定して下さい`,
  '用户名不可用，请重新设置1-18位(特殊字符和标点符号不能使用)':
    'ユーザー名は、1~18以内の文字で設定して下さい（特殊文字、記号入力不可）',
  联系人姓名不能为空: '※必須項目です',
  '格式不正确，请输入真实姓名，包括假名和文字及英文':
    '氏名の形式が正しくありません。氏名は漢字・ひらがな・カタカナカナと英字のみを使用してください',
  '输入的密码格式不正确，请设置6-32位字母或数字，区分大小写':
    'パスワードが正しくありません。6〜32文字の半角英数字で入力してください。',
  两次密码不一致: 'パスワード不一致',
  邮箱已被注册:
    'メールアドレス変更要。入力メールアドレスは既に利用されています',
  无效的手机号码: '有効な電話番号を入力して下さい',
  请确认您的手机号码为10到11位数字:
    'お電話番号を10桁または11桁の半角数字で入力してください',
  请设置用户名: 'ユーザー名を入力',
  '你的名字是？': '氏名',
  设置你的登陆密码: 'パスワードを入力',
  请再次输入您的密码: 'パスワード(確認用）を入力',
  '请输入您的手机号码（选填）': '(任意）電話番号を入力',
  '请输入你的Chatwork ID （选填）': 'Chatwork ID (任意）',
  '请输入你的Skype （选填）': 'Skype (任意）',
  注册并登录: '新規登録',
  同意以下条款: 'プライバシーポリシーへの同意が必要です',
  '已有账号，马上登录': 'すでにアカウントをお持ちの方　ログイン',
  返回首页: 'ホームページへ',
  默认业务类型: 'デフォルト仕入れ方法',
  新密码: '新しいパスワード',
  原密码: '現ログインパスワード',
  旧密码重置密码: 'ログインパスワードを用いて変更',
  邮箱重置密码: 'メールアドレスを用いて変更',
  请输入原密码: '現ログインパスワード',
  请输入新密码: '新しいパスワード',
  输入Aucfan的注册邮箱: 'aucfan.comの登録メールアドレスを入力',
  输入Aucfan的注册邮箱提示:
    '入力頂いた情報をもとに会員無料体験が \n 付与されるため、必ず入力して下さい',
  // 提现
  提现渠道: '引出先',
  银行名称: '受取銀行',
  银行名称3: 'お客様の振込元銀行名',
  支店名: '支店番号',
  口座类别: '口座種類',
  银行账号: '銀行口座',
  银行账号3: '振込元銀行口座番号',
  收款人名称: '受取人名',
  '提现金额（RMB）': '返金金額（RMB）',
  汇率: '為替レート',
  费率: '料率',
  可提现金额: '返金可能額',
  提现手续费: '引出し手数料',
  '提现金额（JPY）': '返金金額（JPY）',
  提现原因: '引出し原因',
  电子邮件地址: 'メールアドレス',
  银行卡: '銀行口座',
  普通: '普通',
  发送: '发送',
  请选择提现渠道: '引出先',
  请输入银行名称: '振込銀行名',
  请输入支店名: '支店番号',
  请选择口座类别: '口座種類',
  请输入银行账号: '銀行口座',
  请输入收款人名称: '受取人名を入力',
  请输入提现金额: '引出し金額を入力',
  请输入验证码: '４桁の認証コードを入力',
  请输入提现原因: '引出し理由を入力',
  请输入邮箱验证码: '認証コード',
  // Bar
  个人中心: 'マイページ',
  帮助: 'ヘルプ',
  客服: 'サービス',
  历史订单: '注文履歴',
  我的库存: '在庫管理',
  用户信息: 'ユーザー情報',
  OEM寻源单: 'OEMにしてメニュー化',
  OEM发起寻源: 'OEM見積依頼',
  同步的订单: '注文管理(API発注)',
  插件安装: 'KAERUツール',
  购买会员等级: '会員ランク',
  我的店铺: '店舗管理',
  我的钱包: '口座一覧',
  登录账户管理: '会員情報管理',
  授权店铺: '店舗連携',
  异常订单: '異常注文',
  购物车: 'カート',
  搜索: '検索',
  最近加入的商品: '最近追加した商品',
  选择你经常使用的功能: 'トップメニューの構成を調整する',
  最多可选择X个: '最大X個まで選択してください',
  请选择你经常使用的类目: 'よく使われるカテゴリーを選択してください',
  // 用户
  '欢迎来到THE CKB': 'ようこそ THE CKBシステムへ',
  会员等级: '会員ランク',
  切换账号: 'アカウント切り替え',
  我的订单: '注文履歴',
  账号设置: 'アカウント設定',
  我的收藏: 'お気に入り',
  登录账号管理: '会員情報管理',
  我收藏的商品和店铺: 'お気に入り商品/店舗',
  我买过的商品和店铺: '購入済 商品/店舗',
  我看过的商品和店铺: '閲覧履歴',
  关联商品: '紐付け変更',
  退出登录: 'ログアウト',
  当前账号已退出: 'ログアウトしました',
  修改邮箱: 'メールアドレスを変更',
  新邮箱地址: '新しいメールアドレス',
  注销子账号: '子アカウントを削除',
  用户信息更新成功: '更新完了',
  邮箱修改成功: 'メールアドレスを変更しました',
  目前您还没有创建店铺: '子アカウント作成完了',
  快速创建: '店舗追加',
  店铺追加: '店舗追加',
  切换B2B囤货业务: 'B2B（有在庫）システムへ',
  切换D2C代发业务: 'D2C（無在庫）システムへ',
  店铺采购管理: '仕入れ設定',
  我的地址: '受取住所',
  // 用户配置项
  店铺平台: 'サイト',
  店铺配置: '注文関連設定',
  登录信息: '登録情報',
  修改密码: 'パスワードを変更する',
  采购配置: '仕入れ設定',
  附加项配置: 'オプション設定',
  国际物流配置: '国際配送設定',
  您能接受的采购价格上涨: '購入単価上限',
  次品付费重购: '不良品対応設定',
  接受次品重拍: '再買付',
  $接受次品重拍文案$:
    '『商品再買付』を指定すると、各商品につきX回まで無料で再買付対応可能です。\nX回以上は毎回既存品買付手数料が発生します（最大再買付回数は3回）。\n自動再買付回数が上限（3回）に達する場合の対応方式は\n「異常注文設定」により設定可能です。 「市場直買付」の再仕入れは、回数無制限で無料です。',
  $次品退货退款文案D2C$:
    '『買付キャンセル』を指定すると、不良品が発生次第返品返金処理を行い、自動的に商品の再買付をキャンセルさせて頂きます。',
  '接受次品重拍，有助于我们更好的为您完成C端订单':
    'D2C会員様は『再買付』を推奨します',
  次品退货退款: '買付キャンセル',
  $次品退货退款文案$:
    '『買付キャンセル』を指定すると、不良品が発生次第返品返金処理を行い、自動的に商品の再買付をキャンセルさせて頂きます。',
  '采购商品时，没有指定类目附加项时，使用全部附加项，两者不重复':
    'カートから発注場合は、カテゴリ毎のデフォルトオプション設定がなければ、全商品に適用済のデフォルトオプションを利用します',
  '当您订单下有该类目商品时，我们将默认为您添加以下附加服务':
    'カートから発注場合は、カテゴリ毎のデフォルトオプション設定済であれば、該当カテゴリの注文商品オプションは自動設定可能です',
  水洗标信息配置: '洗濯タグ設定',
  配置品牌专属水洗标: '洗濯表示タグーデザイン指定',
  打开全部: '編集',
  去配置: '資材紐付け設定へ',
  使用类目: '指定カテゴリー',
  类目失效: '利用不可のカテゴリー',
  搜索地址: '住所検索',
  选择物流公司: '運送会社',
  请选择物流公司: '運送会社を選択してください',
  国际面单主设定: '依頼主設定',
  国际面单依赖主设定: '依頼主設定',
  联系方式: 'お問い合わせ先',
  发货附加项: '発送時オプション',
  添加新地址: '新しい住所を追加',
  会社编号: '法人番号',
  日文收货地址: '日本語の場合',
  英文收货地址: '英語の場合',
  修改地址: '住所を変更',
  // 附加项
  一键自动配置: 'THE CKBお勧め',
  一键配置: 'THE CKBお勧め',
  我的类目: 'カテゴリー',
  选择您要配置的类目: 'カテゴリーを選択-検索',
  选择商品附加服务: 'オプション',
  选择发货附加服务: '発送用オプションを選択',
  选择我的物料: '資材を選択',
  附加项: 'オプション',
  附加项详情: 'オプション',
  辅料sku: '資材SKU',
  辅料名: '資材名',
  预计在库数: '有効在庫数',
  去补货: '在庫補充',
  编辑国际物流附加项: '発送用オプション設定',
  // 首页头部
  我的频道: 'MYチャンネル',
  市场购: '市場直買付',
  透明购: 'ECサイト買付',
  D2C无仓库代发: 'D2C（無在庫）',
  B2B仓库囤货: 'B2B（有在庫）',
  采购平台: '仕入れサイト',
  类目: 'カテゴリー',
  中国语入力: '中国語入力',
  日本语入力: '日本語入力',
  详细检索: 'こだわり条件',
  去登录: '会員様ログイン',
  // 搜索
  'THE CKB': 'THE CKB',
  1688: '1688',
  TaoBao: 'タオバオ',
  Tmall: 'Tmall',
  搜款网: 'VVIC',
  网商园: 'WSY',
  全部类目: '全てのカテゴリー',
  搜索范围: 'ECサイト',
  搜索关键词: 'キーワード',
  重置条件: 'クリア',
  搜索历史: '検索履歴',
  热门推荐词: '人気キーワード',
  // 搜索列表
  采购渠道: '仕入れルート',
  采购市场: '仕入れ元',
  关联我的商品: 'SKU紐付け',
  // 商详
  商品详情: '商品詳細',
  商品来源: '仕入れ元',
  加入收藏夹: 'お気に入りに追加',
  取消收藏: 'お気に入り商品から削除',
  商品金额: '商品代金',
  已选清单: '選択した商品',
  手续费总额: '手数料',
  国际运费: '国際送料',
  国际运费退款: '国際送料返金',
  附加项费用: 'オプション費用',
  单价预估成本: '仕入れコスト（概算）',
  请选择附加项: 'オプション紐付け',
  请选择附加项2: '商品オプションをご選択下さい',
  单品预估成本价: '計算単価',
  相似商品: '類似商品',
  相似店铺: '類似店舗',
  加入购物车: 'カートに追加',
  传输到我的店铺: '自社サイトへ一括登録',
  下载商品图: '商品画像をダウンロード',
  关联到我的店铺商品: 'SKU紐付け',
  X件可售: '在庫数X件',
  商品添加至购物车: 'カート追加完了',
  该商品无法下载商品图: 'この商品は商品図をダウンロードできません',
  商品图下载成功: 'ダウンロード完了',
  '部分图片读取失败，请按需手动下载，正在开启自动下载': `一部の画像が読み取れませんでした
      必要に応じて手動でダウンロードしてください
      自動ダウンロードが有効になっています。`,
  购买数量: '購入数',
  // 子账号店铺
  创建子账号: '子アカウント作成',
  创建店铺: '店舗作成',
  开店平台: 'サイト',
  平台名: 'サイト',
  店铺品牌名: '店舗名/ブランド',
  店铺URL地址: '店舗URL',
  店铺URL: '店舗URL',
  店铺密钥: '店铺密钥',
  创建并授权店铺数据: '创建并授权店铺数据',
  请输入店铺所在的平台名称: 'サイト名を入力してください（任意）',
  请输入店铺或品牌名: '店舗名を入力',
  请输入店铺访问链接: '店舗URLを入力',
  如需授权店铺API请阅读并同意: 'API利用規約に同意します',

  店铺地址不正确: '店舗URLが不正',
  创建店铺成功: '店舗作成完了',
  修改店铺成功: '店舗変更完了',
  店铺授权成功: 'API連携済',
  修改店铺信息: '店舗情報を変更',
  授权状态: '連携状況',
  保存店铺: '保存',
  未授权: '未連携',
  已授权: 'API連携済',
  应用密钥: 'API連携用secret',
  应用ID: 'API連携用ID',
  // 类目
  站外搜索: '外部サイト検索',
  // 市场购
  中国档口七日爆款: '売れ筋ランキング（7日間）',
  推荐档口: 'おすすめ店舗',
  进入店铺: 'もっと見る',
  // 我的频道
  我收藏的店铺: 'お気に入り店舗',
  我看过的店铺: 'チェック済店舗',
  我买过的店铺: '購入済店舗',
  '担当推荐店铺（含档口）': 'スタッフ推薦店舗（市場店舗含む）',
  '推荐店铺（含档口）': '推薦店舗(市場直買付店舗含む）',
  我看过的商品: '閲覧履歴',
  我买过的商品: '購入済商品',
  我收藏的商品: 'お気に入り商品',
  担当推荐商品: 'スタッフ推薦商品',
  猜你喜欢的商品: '推薦商品',
  // 平台频道
  平台频道: 'KAERUチャンネル',
  去购买: '商品を購入へ',
  去选品: '詳細へ',
  去看看: '詳細へ',
  主题市场: 'テーママーケット',
  猜你喜欢的店铺: 'おすすめ店舗',
  品类市场: 'カテゴリー',
  市场: '市場',

  // 青蛙频道
  青蛙频道: 'KAERU MEDIA',
  更多最新文章: 'もっと見る',
  采购相关: '仕入れについて',
  物流相关: '物流について',
  优惠相关: 'キャンペーンについて',
  OME相关: 'OEMについて',
  他社合作相关: '他社業務提携について',
  热门文章: '人気記事',
  档案: 'カテゴリ',
  // 文章
  上一篇: '前へ',
  下一篇: '次へ',
  // 购物车
  采购到库存: '在庫保有',
  C端直发: 'エンドユーザー直送',
  选择店铺: '店舗選択',
  请选择店铺: '店舗を選択してください',
  检索平台: 'ECサイト',
  价格浮动百分比: '購入単価上限率',
  '原有的商品缺货时，我们会帮你查找新的采购链接，所以请告诉我您能接受的采购价格区间变动':
    '指定ショップで買付できない場合、設定された単価上限を目安に別ショップを検索します，初回設定値を、買付時のデフォルト値に設定します　，変更は、情報設定ページで編集して下さい',
  创建组合商品: 'セット組商品を作成',
  确认并支付: 'お支払いへ',
  收件人: '受取人',
  都道府县: '都道府県',
  市区町村: '市区町村',
  市: '市',
  区町村: '区町村',
  详细地址: '詳細住所',
  邮编: '郵便番号',
  自定义订单编号: 'お客様注文番号',
  购买店铺: '店舗名',
  购买类型: '注文種類',
  收件人不能为空: '※必須項目です',
  联系电话不能为空: '※必須項目です',
  都道府县不能为空: '※必須項目です',
  详细地址不能为空: '※必須項目です',
  邮编不能为空: '※必須項目です',
  商品预估价格: '商品代金（概算）',
  商品预估附加项价格: 'オプション費（概算）',
  订单预估总价: '合計額（概算）',
  当前余额: '残高',
  提交订单: '提出',
  '提示：此金额为预估报价，您下单后，该部分金额将会被冻结。等到该订单采购处理全部完成后，我们会自动解冻这部分金额，并按照实际产生的金额进行扣费。实际扣费详情您可以后续在资金明细页面或订单详情页面查看。':
    '発注依頼時に、表示の概算費用をお預かりします。注文商品が検品完了次第、お預かり金は全額返金し正式費用を精算します',
  // 组合
  组合商品名称不能为空: '※必須項目です',
  组合商品名称: 'セット組商品名',
  组合商品规格: 'セット組規格',
  商品图片: '商品画像',
  商品规格: '商品のプロパティ',
  单组数量: '単品数量',
  保存并加入购物车: '保存してカートに追加',
  组合商品附加项: 'セット組オプション',
  选择附加项: 'オプション編集',
  组合详情: 'セット組み内訳',
  组合图片: 'メイン画像',
  组合: 'セット組商品',
  // 通用
  全部: '全て',
  返回: '戻る',
  其他: 'その他',
  平台: 'サイト',
  变更: '変更',
  全选: '全て選択',
  商品名称: '商品名',
  规格: '規格',
  商品属性: '商品のプロパティ',
  在库数量: '在庫数',
  '可用库存/采购数量': '良品数/購入数',
  '使用库存/采购数量': '在庫利用数/購入数',
  下单数量: '数量',
  起订量: 'ロット数',
  起订量件: 'ロット数(件)',
  单价: '単価',
  单价元: '単価(元)',
  总价元: '合計額(元)',
  版费元: '版费(元)',
  小计: '小計',
  商品附加项: '商品オプション',
  商品附加项费用: 'オプション費用',
  操作: '操作',
  编辑: '編集',
  修改: '編集',
  合计: '点数',
  支付: '支付',
  账号: 'アカウント',
  工作台: 'マイページ',
  OEM: 'OEM',
  意见反馈: 'ご意見',
  提示: '【ご注意下さい】',
  提示2: 'ご確認下さい',
  提示3: 'ご注意ください',
  创建: '作成',
  确定: '確定',
  确认: '確定',
  保存: '保存',
  同意: '同意',
  取消: 'キャンセル',
  撤回: 'キャンセル',
  删除: '削除',
  元: '元',
  円: '円',
  件: '件',
  价格区间: '価格帯',
  风格: 'スタイル',
  颜色: '生地のカラー',
  颜色2: '色',
  尺码: 'サイズ',
  其他条件: '他の条件',
  综合: 'おすすめ',
  综合排序: 'デフォルト順',
  价格: '価格',
  成交额: '販売実績',
  信用: 'レビュー評価順',
  销量: '人気順',
  数量: '数量',
  排序: '並べ替え',
  自定义: '価格帯',
  去结算: 'ご注文手続きへ',
  查看更多: 'もっと見る',
  默认: 'デフォルト',
  '上传中...': '商品データ同期中...',
  '已发送验证码请求，请勿重复发送请求':
    '認証コードのリクエストはすでに送信されています。重複してリクエストを送信しないでください',
  离开: 'キャンセル',
  注意: 'ご注意',
  注意2: 'ご注意下さい',
  无: '無',
  暂无: '無し',
  选填: '選択肢',
  批量删除: '一括削除',
  公司名: '会社名',
  收货地址: 'お届け先',
  清关地址: 'Importer住所',
  设为默认: '既定の住所（デフォルト）に設定',
  姓名En: '氏名（英語）',
  都道府县En: '都道府県（英語）',
  市区町村En: '市区町村（英語）',
  详细地址En: '詳細住所（英語）',
  添加商品: '商品を追加',
  购物车商品: 'カート',
  我的商品: '発注履歴',
  图片: '画像',
  商品类型: '注文種類',
  至少选一个: '少なくとも1つを選択してください',
  重置: 'リセット',
  '商品名称/SKU': '商品名/SKU',
  加入组合: '追加',
  普通商品: '既製品',
  OEM商品: 'OEM商品',
  组合商品: 'セット組',
  购物车为空: 'カートに商品はありません',
  上传图片: '画像をアップロード',
  // 长文字说明
  '仅支持已授权店铺上传商品，该店铺未授权': `商品をアップロードできません
      この店舗は未連携で、商品をアップロードできません`,
  '当您采购的商品价格出现变化时，或不能采购时我们将为您寻找其他相同的商品，所以请告诉我您能接受的价格变动幅度。':
    '購入単価上限を入力して下さい。指定ショップで買付できない場合、設定された単価上限を目安に別ショップを検索します',
  '当商品出现问题时，我们将为您免费重新换货X次。超过X次每次Y元，最多不超过Z次。当不勾选时，每次出现次品时，我们都会询问您的意见，在进行处理，会影响您的购买效率。': `『商品交換』を指定すると、各商品につきX回まで無料で交換対応可能です
      X回以上はY元/回の交換手数料が発生します（最大交換回数はZ回）
      『返品返金』を指定すると、不良品が発生次第、自動でショップへ返品・商品代金を返金可能です
      未指定の場合は、不良品が発生次第、都度対応方法を確認します
      対応ご指示があるまで商品は待機状態が継続し配送遅延にもつながるため、事前の対応指定を推奨します`,
  // OEM问题
  创建寻源单: '見積依頼',
  寻源单列表: '見積依頼管理',
  复购申请列表: '見積再購入',
  待接单: '受理待ち',
  待报价: '見積待ち',
  待商榷: '相談待ち',
  寻源失败: '返金済み',
  发布时间: '依頼日',
  起始日: '開始日',
  结束日: '終了日',
  寻源单详情: '依頼書',
  订单状态: '注文状況',
  下一步: '次へ',
  拒绝: '拒否する',
  拒绝2: '支払拒否',
  确定下样品单: 'サンプル発注しますか',
  确定下大货单: '量産をしますか',
  评价: '評価',
  有: 'ある',
  没有: '無し',
  取消寻源单: 'キャンセル',
  确认下单: '発注',
  确认重新编辑: '再編集しますか',
  确认申请退款: '返金しますか',
  确认申请复购: '見積有効期間が切れました、最新の見積を依頼しますか',
  '发布此寻源单需要收取XXX元服务费，请问是否确定发布':
    'XXX元対応料金がかかり、見積依頼を提出しますか？',
  '发布此寻源单无需收费，请问是否确定发布':
    '無料サービス、見積依頼を提出しますか？',
  示例: '例',
  以上没有我需要的: 'その他',
  '您想要一个什么类型的商品？': '商品品類を選択して下さい',
  '请问你要做什么辅料？': 'ご希望の資材を選択して下さい',
  请填写您需要的辅料: '資材を選択してください',
  文件上传: 'ファイルをアップロード',
  '请问你有自己的方案吗？': '自分の計画をご用意してますか？',
  '我有自己的想法，请THE CKB根据我的要求帮我生产':
    '自分のアイデアがあり、それに応えて生産してください',
  '我没有自己的想法，希望THE CKB帮我推荐方案':
    '自分のアイデアがない、THE CKBから計画書を提案してください',
  '我有自己的想法，但是我也想看一下THE CKB的推荐方案':
    '自分のアイデアがありますが、THE CKBからの推薦方案も参考希望です',
  请详细表述并上传您需要定制的辅料设计图或参考图片:
    'ご希望の内容詳細を入力してください',
  请详细描述您需要定制的款式信息: 'ご希望のデザイン詳細を述べてください',
  请详细描述您需要定制的材质信息: 'ご希望の生地詳細を述べてください',
  请详细描述您需要定制的尺寸信息: 'ご希望のサイズを述べてください',
  请查看我们的款式推荐方案: 'THE CKBのデザイン推薦方案をご覧ください',
  请查看我们的材质推荐方案: 'THE CKBの生地推薦方案をご覧ください',
  请查看我们的尺寸推荐方案: 'THE CKBのサイズ推薦方案をご覧ください',
  请查看我们的颜色推荐方案: 'THE CKBのカラー推薦方案をご覧ください',
  请选择Logo印刷方案: 'ロゴ印刷方案をご選択ください',
  价格和起订量: '価額と最低注文数',
  总价: '合計金額',
  版费: '金型費用',
  选择色卡: 'カラーチャート選択',
  搜索色号: 'カラーチャート番号検索',
  色号或色卡名称: 'カラーチャット番号',
  请至少选择一种色卡: '1点以上のカラーチャートをお選びください',
  已选色卡: 'カラーチャート選択済み',
  //
  '请问你对本次杂货OEM的初步需求是怎样的？':
    '今回の雑貨OEMについてご要望はどうなさいますか？',
  '根据图片或样品，帮我生产出一模一样的产品。（包含加Logo）':
    '画像やサンプルに応じて、商品生地 ＋ デザインが一致する商品を生産してください。',
  '在既成品的基础上，我有一些改良的需求 。（包括颜色、材质、 功能、尺寸、设计等的改良）':
    '既製品から変更を行い商品を生産してください。（カラー、素材、サイズ、デザインなどの改善）',
  '既无参考图片也无式样书的情况，无法发起寻源，请联系对应担当提供制作式样书服务':
    '弊社の担当者にご連絡ください。\n弊社でのOEM生産に必要な仕様書のご提供が必要となるため、詳細を担当からご案内します。',
  '请问您是否有样品可邮寄？': '御社からサンプルを郵送できますか？',
  '请问您需要附加Logo吗？': 'ロゴをプリントしますか？',
  请完善Logo信息: 'ロゴデザインを提供してください',
  '请对logo颜色、尺寸、工艺、位置做说明':
    'ロゴのカラー、サイズ、プリント位置をご説明ください。',
  '请问您对本次寻源的工厂或产品资质有特殊要求吗？':
    '見積依頼工場、許可証に関するご要望がありますか？',
  资质要求: '許可証に関するご要望',
  请上传您的参考链接或图片: '参考URL或は参考画像をアップロード',
  '请问您是否有式样书？': '仕様書がありますか？',
  '我需要定制全新的产品，目前市场上没有既成品可参考。':
    'オリジナル商品を生産したいです。既製品がありません。',
  请上传式样书: '仕様書をアップロード',
  '式样书必须包含产品的色卡、尺寸、特殊工艺、面料信息等':
    '（仕様書）必ず商品のカラーチャート、サイズ、 生地などの情報をご入力ください',
  '使用THE CKB帮助您制作式样书': 'THE CKBに仕様書作成を依頼する',
  '由于信息不足，THE CKB暂时无法为您提供寻源服务':
    '情報不備のため、しばらく見積依頼サービスを提供しかねます。',
  请详细说明您需要改动的地方: '変更したいところを説明してください。',
  '如果需要改动的点已经在式样书中完全展现，可以略过，否则可做补充说明':
    '変更したいところを既に仕様書に表記された場合は、入力なしで問題ございません',
  补充说明: '補充説明',
  上传文件: 'ファイルをアップロード',
  请完善信息: 'サンプルを下記の住所に送ってください',
  请问您是否可以提供样衣邮寄: '御社からサンプルを郵送できますか？',
  我有样衣: 'サンプルがあります。',
  我没有样衣: 'サンプルがありません。',
  'THE CKB地址': 'THE CKB住所',
  请填写物流单号: '追跡番号をご記入ください。',
  //
  '请问你对本次服装OEM的初步需求是怎样的？':
    'ご要望のOEM商品生産パターンを選択して下さい',
  '只需要生产出和图片或链接看起来一样的产品，对面料没有任何要求，且不需要有任何设计上的改动。':
    '商品画像または商品URLのデザインのみ一致する商品を生産したい。\n対応スピードを最優先し、商品生地の指定なし。',
  '风险告知：A的情况，此选项不寄实物样品给客户，只通过样衣图片在线上进行确认。此选项优点为出样快，缺点为THE CKB只保证成衣外观和客户提供的图片接近一致无法保证和原链接衣服材质保持一致。请知悉！': `他プランに比べ、スピード最優先で対応するプランです。
      商品デザインが一致する事を重視し、サンプル確認も実物ではなく画像で確認いただきます。
      商品はデザインの一致のみを保証し、生地や質感の保証は致しかねますのでご留意ください。
      ※サイズ、生地指定がある場合は、BまたはCプランを選択してください。`,
  '我有样衣，希望THE CKB帮我生产出和样衣一模一样的衣服。':
    '商品サンプルがあり、生地、サイズなどサンプルと同一の商品を生産したい。',
  '我有样衣，但我对设计/面料/尺寸等，有希望改动的地方。':
    '商品サンプルがあり、デザイン、生地、サイズなどを変更して生産したい。',
  '我只有参考图片或链接，且我有需要改动的地方或我对面料有拘泥。':
    '商品サンプルがなく、商品画像または商品URLのみあり。デザイン、生地、サイズなど変更要望あり。',
  '此种情况您需要尽可能提供一件样衣到THE CKB作为参考，或者您需要提供详细的式样书，如果您没有式样书，可以联系THE CKB使用式样书制作服务':
    '参考となるサンプル品又は仕様書をご提出ください。仕様書がない場合には、弊社に仕様書の作成依頼も可能です。',
  '我没有样衣或参考图片/链接，但我有式样书，希望THE CKB根据式样书帮我进行生产。':
    '商品の仕様書のみあり（サンプルや参考画像、商品URLなし）。仕様書に沿った商品生産を行いたい。',
  '既无参考图片也无式样书的情况，无法发起寻源，请联系对应担当提供制作式样书服务；式样书必须包含产品的色卡、尺寸、特殊工艺、面料信息等':
    '弊社の担当者にご連絡ください。\n弊社でのOEM生産に必要な仕様書のご提供が必要となるため、詳細を担当からご案内します。',
  请填写你想定制产品的基本信息: '予定する本発注に関する情報を入力してください',
  请填写产品名称: '商品名をご入力ください',
  请至少填写一条完整的产品信息: '情報不足ので見積書依頼できません',
  产品信息说明:
    '商品のサイズ分類を記載してください。サイズが複数ある場合は、行追加しサイズを入力してください。例 M,L,XL,30cm＊40cm＊20cm　など',
  '不知道，但是我可以邮寄面料样布，希望THE CKB帮我找到和样布一样的面料':
    '生地のサンプルが発送可能です',
  '请问你是否知道面料具体信息？': '生地情報のご説明',
  '知道，我可以提供面料信息和具体的色卡信息': '生地情報と色を入力する',
  '不知道，希望THE CKB帮我找到和样衣或参考图片一样的面料': 'サンプルに参考する',
  '不知道，希望THE CKB可以根据我的需求，给我推荐合适的面料': 'THE CKB提案',
  请提供具体的色卡信息: '希望の生地情報（素材、カラー）を入力してください',
  请描述一下您对面料的需求: '生地をご指定ください',
  '请大致描述一下希望布料的外观或功能上的需求，如:弹性好，柔软等':
    '生地の説明をしてください、例えば： 弾力性に優れたやわらかい生地',
  上传面料图片: '生地の画像をインポートする',
  '请大致描述一下希望改动哪些方面,如:材质、设计、颜色、尺寸等':
    '変更したいところを説明してください、例えば：生地、カラー、サイズ、デザインの変更など',
  '请问你能够提供尺码的具体尺寸吗？':
    '商品の詳しいサイズガイドをご提出できますか',
  '我有尺码对应的尺寸数值。': 'サイズ情報を入力',
  '根据服装生产标准，尺寸相差 1-3cm 都属于正常现象，不作为不良品判断，请知悉':
    'アパレル見積生産は、サイズに1-3cmの誤差がある場合がございます、不良品とは扱いませんので、予めご了承ください',
  '我没有数值，请参考链接尺寸。': '商品ページの寸法を参考',
  '我没有数值，请THE CKB提供。': 'THE CKB提案',
  请提供尺码的具体尺寸: '商品の詳細サイズをご入力ください',
  尺码模板: 'テンプレートファイル',
  模板下载: 'テンプレートダウンロード',
  模板下载2: 'テンプレートをダウンロード',
  上传模板: 'インポートする',
  '请先下载对应模板，填写完成后上传':
    'テンプレートファイルをダウンロードして、詳細の情報を入力してからインポートしてください',
  请输入产品的下单需求: '注文情報を入力して下さい',
  'THE CKB的报价与希望起订量和价格是否匹配，是我们判定是否为您寻源成功的判断依据。请您客观的填写。如果您的希望和市场行情差异过大，我们会之后先联系您，提出修改建议，再开始为您寻源报价。':
    'ご入力いただいた希望ロット数と希望価格により工場を探しますが、ご要望が実際の市場の相場と外れてる場合は、実際の相場により見積を出します',
  寻源备注: '備考',
  '如果您对本次寻源还有其他特殊需求，请在以下输入您的需求':
    '見積依頼に何かご要望があれば遠慮なくご入力ください',
  已成功创建寻源单: '見積書依頼済',
  创建寻源单说明:
    'まだ、対応開始されていません。管理画面で内容確認の上、依頼提出をお願いします',
  '式样书(例)': '仕様書（例）',
  棉100: '綿100%',
  可多选: '複数選択可能',
  尺码信息: 'サイズ',
  是否需要加logo: 'ロゴ刻印、プリントする場合、ロゴ資料を提出',
  期望交期时间: '希望納期',
  期望最低起订量: '希望ロット数',
  关闭: '閉める',
  关闭2: '閉じる',
  客户补充部分: 'お客様ご要望',
  附加说明: '説明',
  您可以点击此处: '仕様書を依頼する',
  产品图片: '商品画像',
  产品规格: '商品規格',
  备注: '備考',
  附加费选项: '商品オプション',
  订单标题: '注文タイトル',
  品牌: 'ブランド名',
  总计数量: '合計数量',
  '总计(折扣前RMB)': '合計（割引前）',
  '总计(折扣后RMB)': '合計（割引後）',
  估计金额: '見積金額',
  购物车数量不能小于X: '最低追加数量（X）を満たしません',
  普通订单: '既製品注文',
  组合商品订单: '組合せ商品',
  OEM订单: '見積商品',
  //
  报价已过期: '見積書の有効期間が切れました',
  复购申请编号: '見積更新依頼',
  申请状态: 'ステータス',
  //
  请填写: 'をご入力ください',
  请上传: 'をアップロード',
  请至少选择一种色卡或上传图片:
    '少なくとも、1つカラーチャートを選んでください。カラーチャートがない場合、写真をアップロードしでください',
  链接和图片必须填一个: 'リンク、あるいは写真をご入力ください',
  请提供面料材质和色卡信息: '布地の材質とカラーチャートの情報をご提供ください',
  请填写具体的面料材质信息: '布地の材質の情報をご提供ください',
  '我没有数值，请参考样衣尺寸。': 'サンプルの寸法を参考',
  '以上为参考报价，具体报价需要以最终报价为准 ':
    'あくまでも参考の見積なので、実際の見積は実際の条件に従うものとします',
  该订单不支持修改属性: '該当商品の規格を修正できません',
  请至少选择或上传一种色卡: '1点以上のカラーチャートをお選びください',
  请填写款式说明: 'ご希望のデザイン詳細を述べてください',
  请填写材质详细说明: 'ご希望の生地詳細を述べてください',
  请填写尺寸详细说明: 'ご希望のサイズを述べてください',
  请上传Logo: 'ブランドlogoをアップロードしてください',
  请上传尺码表: 'サイズをアップロードしてください',
  请填写期望价格: '希望価格を入力してください',
  请填写期望最低起订量: '最低ロット数を入力してください',
  请选择期望交期时间: '希望納期を入力してください',
  重新创建寻源单: '見積更新依頼',
  查看寻源单列表: '作成完了の見積依頼は「未提出」ページにてご確認ください',
  请输入您想要的详细信息: '予定する本発注に関する情報を入力してください',
  'THE CKB的款式推荐方案': 'THE CKBのデザイン推薦方案をご覧ください',
  'THE CKB的材质推荐方案': 'THE CKBの生地推薦方案をご覧ください',
  'THE CKB的尺寸推荐方案': 'THE CKBのサイズ推薦方案をご覧ください',
  印刷方案: 'ロゴ印刷方案をご選択ください',
  请输入您的订单信息: 'ご希望を入力してください',
  规格及起订量: '価額と最低注文数',
  '棉100%': '綿100%',
  '上次寻源未完成，是否继续':
    '作成完了してない見積依頼があり、引き続き操作しますか？',
  重新寻源: '再見積依頼',
  店铺不存在: 'この店舗が見つかりませんでした',
  没有更多了: 'これは全部です',
  暂无平台: 'プラットフォームはまだありません',
  输入FAQs关键词: 'キーワードを入力',
  收藏商品: 'お気に入り商品',
  收藏店铺: 'お気に入り店舗に追加',
  多为我推荐此类型商品: 'おすすめ商品に設定',
  多为我推荐此类型店铺: 'おすすめ店舗に設定',
  不再推荐此商品: 'おすすめ商品から除外',
  不再推荐此店铺: 'おすすめ店舗から除外',
  商品收藏成功: 'お気に入り商品に追加しました',
  店铺收藏成功: 'お気に入り店舗に追加しました',
  '感谢反馈，我们将为你推荐更加准确的商品': `フィードバックを頂きありがとうございました。
      これからより多く関連商品をお勧めいたします。`,
  '感谢反馈，我们将为你推荐更加准确的店铺': `フィードバックを頂きありがとうございました。
      これからより多く関連店舗をお勧めいたします。`,
  注销账号: 'アカウント削除',
  提现: '引出し',
  '您的账号中存在以下未处理完结事件，不能注销。': `アカウント削除不可
      処理中の項目があるため、アカウント削除は出来ません`,
  账户余额X元: '残高X元',
  提现申请: '引出し申請',
  X笔采购订单: '注文数：X',
  X条充值任务未完成: 'Xご入金（確認中）',
  批量编辑附加项: '一括オプションを編集',
  工厂直营: 'THE CKB厳選',
  组合商品不能再组合: 'セット組対応済 重複したセット組は作成不可',
  OEM样品单不能组合: '組み合わせ商品は再組み合わせできません',
  '订单已生成，请随时关注订单动态':
    '注文完了。注文状況から進捗をご確認下さい　',
  '5s后跳转订单详情': '5秒後に注文状況画面に遷移します',
  '15s后跳转订单详情': '15秒後に注文状況画面に遷移します',
  '系统检查到，您未安装采购扩展程序，现在安装采购更方便直接在1688，天猫，淘宝官网THE直达商品可以添加到采购系统购物车中。现在马上安装': `ツール利用で、中国主要サイトから直接、THE CKBシステムでの商品買付可能
      商品買付がとっても便利になります！
      すぐに【補助ツール(KAERUツール)】を追加する`,
  包邮: '中国国内送料無料',
  赠送退货运费险: '中国国内返品送料保険提供',
  新品: '最新商品',
  正品保障: '正規品',
  公益宝贝: '寄付つき商品',
  '7+天内退货': '7日以内理由によらず返品対応可能',
  折扣: 'sale',
  搭配满减: '条件満たすと値引き',
  满就减: '条件満たすと値引き',
  货到付款: '代金引換',
  '48小时内发货': '48時間以内出荷',
  实力商家: '優良店舗',
  超级工厂: '優良サプライヤー',
  加工定制: 'オリジナル生産',
  人气: '売れている順',
  访问令牌: 'アクセストークン',
  请填写正确的访问令牌: '正しいアクセスコードを入力してください',
  组合商品规格不能为空: '必須項目。セット組規格を入力してください',
  选择一张图片作为组合商品主图: '1つ画像を選択してください',
  查看组合列表: 'セット組一覧を確認',
  当前购物车共X种商品: 'カート内の商品数：X点',
  X件商品已添加至购物车: 'X点　カート追加完了',
  'X件商品已添加至(一口价)购物车': 'X点の商品がカート（日本円価格商品）に追加しました',
  '库存过低不能下单，请调整发货量或及时补充库存':
    '在庫が少なすぎて注文できません。発送数を調整するかまたは在庫を補充してください',
  回到首页: 'トップページに戻る',
  同步商品: '店舗商品取込',
  fnsku: 'FNSKU',
  asin: 'ASIN',
  '请输入Amazon sku': 'Amazon sku を入力してください',
  '请搜索需要绑定的Amazon sku': 'Amazon sku を入力してください',
  '请搜索需要绑定的CROSS MALL sku': 'CROSS MALL sku を入力してください',
  附加项未配置箱唛: '箱ラベルのオプションを追加してください',
  附加项未配置贴标签: '商品ラベルのオプションを追加してください',
  '海外仓sku(fnsku)': '日本倉庫SKU(FNSKU)',
  补货数量: '発送数',
  未提出: '未提出',
  已提出: '提出済',
  已作废: '廃棄対応済',
  'FNSKU/ASIN': 'FNSKU/ASIN',
  '商品名称/Amazon sku': '商品名/Amazon SKU',
  '品名/平台sku': '商品名/THE CKB SKU',
  计划发货量: '配送件数',
  是否确认提出: '提出してよろしいでしょうか',
  是否确认取消: 'キャンセルしてよろしいでしょうか',
  作废成功: 'キャンセルしました',
  提交成功: '提出しました',
  提交成功2:
    'チャージ申請しました<br/><div style="margin-top:2px;">チャージ金額は審査完了後反映されます しばらくお待ち下さい</div>',
  国际发货单标题: '納品タイトル',
  发货状态: 'ステータス',
  发货类型: '配送種類',
  批量加购: '一括再購入',
  '点击完结 单品可以转普通商品库存':
    '点击完结 単品商品としての在庫保管に変更可能',
  '存在待组商品 请尽快加购组合。': '存在待组商品 请尽快加购组合。',
  物流信息: 'お届け先情報',
  国际单号回传后不可修改: '再編集不可 出荷済',
  收件人邮箱: 'メールアドレス',
  选择订单时间: '注文日時を選択',
  订单付款日期区间: 'お支払い日時',
  未下单: '未発注',
  已下单: '発注済',
  店铺订单号: 'お客様注文番号',
  订单时间: '注文日時',
  采购状态: 'ステータス',
  订单金额: '合計額',
  收货信息: 'お届け先',
  商品图: '画像',
  '商品名/sku': '商品名/SKU',
  采购链接sku: 'THE CKB SKU',
  同步订单数据: '注文取込み',
  一键下单: '発注',
  '编辑物流/地址': '住所を編集',
  是否删除: '削除してよろしいでしょうか',
  发货附加项编辑成功: '発送用オプション　編集完了',
  编辑成功: '編集完了',
  留在此页: 'OK',
  开始时间: '開始日時',
  质检中: '検品',
  待发货: '発送待ち',
  '当前申请取消的商品，存在多个商品状态，确认取消后：':
    'キャンセル処理を実行すると、',
  '“X”状态商品，申请取消成功后，系统将自动取消商品的采购与发货，冻结金额在订单结算后返回至可用余额内。':
    '“X”状態の商品は商品の買付と発送を停止しお預かり金を全額返金します',
  '“X”状态，申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。':
    '“X”状態の商品は商品の発送を停止し在庫保管します',
  '请确认是否申请取消？': 'キャンセルを実行しますか',
  '“X”状态商品，系统将自动取消商品的采购，冻结金额在订单结算后返回至可用余额内；':
    '“X”状態の商品キャンセルは、商品の買付と発送を停止しお預かり金を全額返金します',
  '“X”状态商品，不可申请取消（系统将自动忽略）':
    '“X”状態の商品はキャンセル出来ません',
  '当前申请取消的商品，商品状态均为“X”状态,': '“X”状態の商品キャンセル',
  '申请取消成功后，系统将自动取消商品的采购与发货，冻结金额在订单结算后返回至可用余额内。':
    'キャンセル処理を実行すると、商品の買付と発送を停止しお預かり金を全額返金します',
  '当前申请取消的商品，商品状态均为“X”状态，不可申请取消！':
    '“X”状態の商品はキャンセル出来ません',
  '当前申请取消的商品，商品状态均为“X”状态，申请取消成功后，系统将自动取消商品的采购，冻结金额在订单结算后返回至可用余额内':
    '“X”状態の商品キャンセルは、商品の買付を停止しお預かり金を全額返金します',
  再次下单: '再購入',
  组合信息: 'セット組情報',
  结算中心查看明细: '口座一覧から明細を確認',
  费用名称: '種類',
  '结算总价（元）': '合計額（元）',
  问题联络: '問題連絡',
  冻结: 'お預かり金',
  解冻: 'お預かり金返金',
  结算: 'ご注文手続きへ',
  重拍冻结: 'お預かり金（交換）',
  销售单价: '単価',
  结算数量: '数量',
  结算总价: '合計金額',
  点击上传凭证: 'クリックしてアップロード',
  みずほ銀行: 'みずほ銀行',
  商品代金结算: '商品代金',
  国内运费: '中国国内送料',
  国际物流费用: '国際送料',
  国际物流费用退回: '国際送料返金',
  国际运费重量差补扣: '国際送料差額分返金',
  国际运费附加项补扣: '国際送料追加請求総額',
  销毁费补扣: '廃棄手数料',
  偏远地区费补扣: '遠方輸送手数料',
  仓储费补扣: '物流倉庫保管費',
  超长超重费补扣: 'オーバーサイズ料金',
  关税补扣: '関税',
  改派费补扣: '配達先変更手数料',
  特殊处理费补扣: '特別対応費用',
  扣件费补扣: '配送ストップ手数料',
  退件费补扣: '返送手数料',
  冻结总价: '買付仮払金額総額',
  解冻总价: '合計額',
  重拍冻结商品代金: 'お預かり金（不良品自動再発注）',
  冻结商品代金: '買付仮払金額',
  解冻商品代金: 'お預かり金返金',
  冻结总数量: '購入総数',
  解冻总数量: '総数',
  手续费: '代行手数料',
  次品重买总次数: '不良品交換回数',
  纸箱总数量: '箱数',
  装箱总数量: '発送数',
  气泡膜总数量: 'プチプチ総数',
  托盘总数量: 'パレット総数',
  箱子总数量: '箱数',
  结算总数量: '総数',
  我的默认附加项: 'デフォルトオプション設定（全商品）',
  我的类目附加项: 'デフォルトオプション設定（商品カテゴリー毎に設定）',
  商品总金额: '合計金額',
  发货单: 'パッキングリスト',
  箱: '箱',
  钱包: '口座一覧',
  收藏: 'お気に入り',
  记录: '記録',
  足迹: '閲覧履歴',
  浏览记录: '閲覧履歴',
  购买记录: '購入履歴',
  没有可优先发货的商品: '分納発送可能な商品はありません',
  是否确认优先发货: '【ご確認下さい】この商品を分納発送しますか',
  优先发货成功: '分納発送設定しました',
  没有可申请取消的商品: 'キャンセル可能な商品がありません',
  是否确认删除: '【ご確認下さい】削除してもよろしいでしょうか',
  搜索商品: '商品を検索',
  '您将要删除X条商品数据，删除后将无法恢复':
    '【ご確認下さい】選択した●件商品データを削除すると、元に戻すことはできません。商品を削除しますか',
  请输入商品名: '商品名を入力してください',
  选择收货地址: 'お届け先を選択してください',
  国际发货标题: '納品タイトル',
  是否确定加购大货: '【ご確認下さい】この商品を量産しますか',
  加购大货: '量産する',
  确定加购样品: 'サンプル発注',
  加购样品: 'サンプル発注',
  库存还有X件商品或辅料: 'X件の商品（資材）の在庫があります',
  去处理: '詳細',
  '账号注销后我们将不再保存您的任何账号信息，是否注销？':
    '【ご確認下さい】アカウント削除すると、THE CKBシステムの全情報が削除され元に戻すことが出来ませんアカウントを削除しますか',
  直行台: '会員センター',
  账户概览: '会員センター',
  同步订单: '注文管理（API発注）',
  订单详情: '注文詳細',
  购买过: '購入した商品/店舗',
  消息: 'メッセージ',
  商品管理: '商品管理',
  关联商品库: '紐付け管理',
  我的组合商品: 'セット組',
  国际发货: '国際配送',
  国际发货列表: '国際配送一覧',
  国际发货详情: '詳細',
  补货计划: '納品タイトル',
  资金管理: '資金管理',
  授权管理: 'API連携',
  再购入: '再見積依頼',
  下单: '発注',
  同步商品信息: '店舗商品を取込み',
  库存数: '良品',
  可售: '在庫あり',
  可用库存: '良品数',
  日本良品数: '日本良品数',
  中国良品数: '中国良品数',
  已锁定: '利用予定',
  待处理次品数: '返品不可不良品',
  导出成功: 'ダウンロードしました',
  'THE CKB发货单号': 'THE CKB発送依頼番号',
  复购: '再購入',
  筛选条件: '検索条件',
  '客户商品sku/海外仓sku': '貴社SKU/日本倉庫SKU',
  '平台客户sku/商品名称': '商品SKU/商品名',
  更新: '更新',
  平台商品信息: '商品情報',
  'AMAZON库存(可售)': 'Amazon（在庫あり）',
  'AMAZON库存(入库)': 'Amazon（入庫待ち）',
  'AMAZON库存(不可售)': 'Amazon（販売不可）',
  预计总库存: '合計',
  绑定: '紐付ける',
  绑定1: '連携する',
  解绑: '解除する',
  确认签收: '受取',
  '是否确认签收？': 'この商品を受け取りますか',
  '是否确认取消国际发货？ 仓库已在作业中的发货单无法取消。':
    'キャンセル不可当該配送依頼は倉庫作業中です　詳細は担当へご連絡下さい',
  '小计（元）': '小計（元）',
  实际发货数量: '実際配送数',
  提出: '提出',
  已确认: '処理中',
  尺寸: 'サイズ',
  /**
     *
     * 补充翻译3
     */
  寻源单号: '見積依頼番号',
  大货单: '量産',
  样品单: 'サンプル',
  预计可发货数: '最大発送数',
  查看订单详情: '注文詳細を確認',
  购买数量不可为空: '必須項目 購入数量',
  购买数量不可低于起订量: '購入数量が最低ロット数を満たしていません',
  子商品总数不能少于2件: '1セット組商品には、単品商品が2件以上必要です',
  批量编辑商品附加项: '商品オプション一括編集',
  '存在不足起订量的商品，请修改数量': '購入数量が最低ロット数を満たしていません',
  需要填写收货地址: 'お届け先住所を入力してください',
  添加收货地址: 'お届け先を追加',
  payoneer充值记录: 'Payoneerチャージ履歴',
  我知道了: '閉じる',
  我知道了2: '閉じる',
  '存入金额（USD）': '振込金額（USD）',
  待初审: '初回審査待ち',
  待终审: '最終審査待ち',
  已通过: '審査終了',
  上传成功: 'アップロードしました',
  参考单价: '単価',
  冻结数量: '購入数',
  扣费日: '計算日',
  上次扣费日: '在庫保管期間（期首）',
  上架日: '保管起算日',
  免费保管天数: '無料保管日数',
  计费天数: '有料保管日数',
  '当前账号下无店铺，请创建店铺后再执行操作': `【ご確認下さい】
      店舗未登録。
      店舗作成後、再試行して下さい`,
  /**
     *
     * 补充翻译4
     */
  普通发货: 'Amazon FBA納品以外',
  FBA发货: 'Amazon FBA納品',
  收货仓: '納品先',
  '如果您当前存在部分订单未完成的话，您账户可用余额中我们将会自动为您留下当下账户冻结金额*1的金额，来确保账户有足够的金额来支付国际运费后顺利发货。所以您目前可转账的金额为：账户可用余额-冻结金额': `対応中の注文がある場合は、国際送料をお支払うのに十分な金額があることを確保するために、利用可能額から（当アカウントのお預かり金＊１）の金額を一旦利用不可と設定させて頂きました。
       現在、振替可能額は、利用可能額からお預かり金を差し引いた金額です。`,
  本公司接受银行: '弊社受取銀行みずほ銀行',
  汇款人姓名: '振込人名義',
  汇款时间: '振込日時',
  汇款凭证: '入金・振込証跡',
  点击上传: 'クリックしてアップロード',
  良品入库: '入庫（良品）',
  不良品: '不良品',
  付费重拍: '有料交換',
  本次重拍费用X円: '有料、今回の再買付手数料はX円',
  '接受次品/缺货自动付费重拍（接受自动重拍，有助于我们更快的为您完成订单采购）':
    'D2C会員様は『交換』を推奨します',
  更换尺码: 'サイズ変更',
  更换款式: 'デザイン変更',
  '请输入链接(必填)': 'URLを入力（必須項目）',
  同款链接: '同一商品URL',
  点击可查看: 'クリックして確認可能',
  类似款链接: '類似商品URL',
  等待原链接: '元URL待ち',
  下单原链接: '元URL購入',
  '下单原链接（多出数量保留库存）': '元URL購入（残り在庫は在庫保管）',
  申请成功: '申請完了',
  申请成功2:
    'アフター補償申請提出しました、処理完了するまで2営業日程度かかりますのでしばらくお待ち下さい',
  请确认尺码: 'サイズのご確認',
  请确认颜色: '色のご確認',
  '请确认设计（款式）': 'デザインのご確認',
  '全网断货，建议取消': `【ご確認下さい】
    全サイト在庫切れ、キャンセルをお勧め致します`,
  // '原URL缺货，新的URL内商品是X元，请确认': `【ご確認下さい】
  //    元URLは在庫切れ、在庫あるURLの価格はX元です
  //    購入するかどうかをご確認ください`,
  '原商品缺货，找到了类似商品，请确认': `【ご確認下さい】
      元URLは在庫切れ、在庫ある類似商品が見つかりました
      購入するかどうかをご確認ください
      `,
  '预售商品。预计下单后X天后能发货，要等吗？': `【ご確認下さい】
       元URLは予約商品で、注文後X天出荷可能です
       購入するかどうかをご確認ください`,
  '找到新的现货链接，是否可以购买？': `【ご確認下さい】
    在庫あるURLが見つかりました
    購入するかどうかをご確認ください`,
  '此商品的最小起订量是X件。请确认是否购买。': `【ご確認下さい】
       当商品の最小ロット数はX件です
       購入するかどうかをご確認ください`,
  '找到符合下单量的新链接，是否可以购买。': `【ご確認下さい】
       希望購入数を購入できるURLが見つかりました
       購入するかどうかをご確認ください`,
  '原商品质量不佳，推荐在新链接采购。': `【ご確認下さい】
    何度交換しても不良品が届きましたので、新URLで発注をお勧めます`,
  到错货: '注文した商品とは異なる物が届いた',
  少件: '注文した数より多く商品が届いた',
  多件: '注文した数より少なく商品が届いた',
  快递扫不出: 'QRコードを読み取れない',
  // 颜色差异: '色差があり',
  // 商品有中文: '中国語表記',
  '配件差异（口袋，腰带，纽扣，拉链，拉绳等）': '付属品が違い',
  // logo差异: 'Logoが違い',
  // 尺码差异: 'サイズが違い',
  '设计差异（压线，领口，袖口，花纹，衣服设计等）': 'デザインが違い',
  '材质/面料差异': '生地が違い',
  $色差$: '不良理由：色差あり<br/>検品基準により、不良品と判断されました<br/>',
  $色差$2:
    '色差あり<br/>※何度も交換して同じ不良品になりました。<br/>再交換しても不良品改善の可能性なし（ロット生産のため）。<br/>不良が許容範囲内の場合、入庫許可を推奨<br/>※問題商品数が多く、納期遅延の可能性大。<br/>不良が許容範囲内の場合、入庫許可を推奨',
  // '污渍/斑点/水印': '汚れ・シミ・水シミ',
  // 破损: '破損',
  // 线头: '糸くず・ほつれ',
  // 接缝不良: '縫い目',
  // 抽丝: '伝線',
  // 针眼: '針の穴',
  // 霉菌: 'カビ',
  // 生锈: 'サビ',
  // 纽扣破损: 'ボタン破損',
  // 拉链破损: 'ファスナー破損',
  // 附属品缺陷: '付属品欠陥',
  // 有气味: '匂い',
  // 其他不良: 'その他',
  'THE CKB档口': 'THE CKB市場店舗',
  '我们的 OEM 仅适用于商务舱和头等舱成员。如果您想使用OEM，请从[会员信息]更改会员等级。如果您有任何问题，请联系我们的在线客服。':
    'OEMサービスはスタンダードプラン及びその以上の会員様が利用可能です。ご利用の場合は会員ランクの変更を行ってください。',
  充值会员: '会員ランク変更へ',
  购买数量不可低于X件: '最低ロット数は X です！',
  /**
     *
     */
  '平台库存（处理中）': 'THE CKB在庫（処理中）',
  '平台库存（已锁定）': 'THE CKB在庫（利用予定）',
  '平台库存（可用库存）': 'THE CKB在庫（良品数）',
  '平台库存（待处理次品数）': 'THE CKB在庫（返品不可不良品）',
  转账金额不能为0: '振替金額は０元以上の金額を入力してください',
  '同步中...': '取込中...',
  '同步完成-执行刷新': '取込完了',
  我的工作台: 'マイページ',
  订单管理: '注文管理',
  API同步订单: '注文管理（API発注）',
  库存管理: '在庫管理',
  寻源列表: '見積依頼管理',
  OEM复购: '再見積依頼一覧',
  'API/子账号配置': 'API連携/店舗作成',
  会员相关: '会員センター',
  会员办理: '会員申請',
  国际配送管理: '国際配送管理',
  FBA补货计划: 'FBA納品一覧',
  国际发货管理: '国際配送一覧',
  国际发货售后: 'アフター補償申請',
  主账号资金明细: '親アカウント口座一覧',
  店铺资金明细: '店舗口座一覧',
  OEM寻源: '見積依頼',
  全部店铺数据: '店舗情報',
  '这是您与THE CKB相处的第X天': '入会日数：X日',
  升级会员: '会員プランを変更',
  钱包余额: '利用可能額',
  未关联的商品: '未紐付け商品',
  API同步异常订单: '異常注文（API発注）',
  商品在库: '商品在庫管理',
  在库辅料: '資材在庫管理',
  下单金额: '注文金額',
  API下单量: '注文数（API発注）',
  订单数量: '注文数',
  采购金额: '注文金額',
  采购量: '注文数',
  发货量: '発送数',
  待发库存数: '検品済み（配送可能）',
  待确认补货计划: '確認待ち納品プラン',
  待确认补货计划1: '納品プラン（提出待ち）',
  未绑定商品: '未紐付け商品',
  请先关联商品: '未紐付け',
  对折: '二つ折り',
  不使用商品番号: '商品番号を使用しません',
  不使用客户商品sku: '表示しない',
  关联商品库填写: '紐付け内容を入力',
  请填写会社名: '会社名を入力してください',
  请填写会社地址: '会社住所を入力してください',
  '图片格式支持jpg，png。': 'アップロード可能な形式は「jpg」「png」のみです。',
  'LOGO图片比例为1:1，在水洗标打印时转变为黑白色':
    'ロゴ画像の画面比率は1：1で、白黒で印刷します。',
  缝制样式: '縫製スタイル',
  请选择商品番号填写方式: '商品番号の入力方式を選択してください',
  '更新中...': '更新中...',
  '更新完成-执行刷新': '更新完了',
  Amazon在庫数更新: 'Amazon在庫数更新',
  购买时间: '購入日時',
  收藏时间: '追加日時',
  /**
     *
     */
  更新时间: '更新日時',
  请选择需要复购的商品: '再購入したい商品を選択して下さい',
  请选择需要优先发货的商品: '分割発送したい商品を選択して下さい',
  请选择需要取消的商品: 'キャンセルしたい商品を選択して下さい',
  请选择需要售后的商品: '受領後返金を申請したい商品を選択して下さい',
  请选择需要导出的订单: 'ダウンロードしたい注文を選択して下さい',
  '自動発注をOFFにしました。': '自動発注をOFFにしました。',
  店铺url和访问令牌不能为空: '店舗URLとアクセスコードを入力して下さい',
  未关联sku数量: 'SKU未紐付け',
  星期一: '月曜日',
  星期二: '火曜日',
  星期三: '水曜日',
  星期四: '木曜日',
  星期五: '金曜日',
  星期六: '土曜日',
  星期日: '日曜日',
  平台库存: 'THE CKB在庫',
  AMAZON库存: 'Amazon在庫',
  不可售: '販売不可',
  入库: '入庫',
  当前所选商品中含有库存数为0的商品: '現在選択中の商品に、在庫数が0の商品が含まれています。',
  /**
     *
     */
  '商品“已上架”之前的状态下的总数量': '発注してまだ倉庫に到着してない数',
  已使用准备发给您的商品: '現在該当商品の配送予定数',
  可使用的正品数量: '現在倉庫にある良品数',
  '仓库发现商品次品且无法退款，进入您的次品库存':
    '現在倉庫にある返品不可の不良品数',
  弊社受取銀行: '弊社受取銀行',
  横浜駅前支店: '横浜駅前支店',
  店番292: '店番292',
  口座番号: '口座番号',
  '普通預金  4014779': '普通預金  4014779',
  口座名: '口座名',
  '株式会社  SNIFF JAPAN': '株式会社  SNIFF JAPAN',
  料金表: '料金表',
  国際配送依頼番号: '国際配送依頼番号',
  收据: '入金領収書',
  /**
     *
     */
  一键绑定: 'SKU自動紐付け',
  导出: 'ダウンロード',
  请确认售后信息: 'アフター補償申請',
  解冻数量: '数量',
  通过FBA补货计划发货: 'Amazon FBA納品',
  海外仓sku不能为空: '日本倉庫SKUをご入力ください',
  /**
     *
     */
  缺货: '在庫切れ',
  传输商品信息到店铺: '店舗に一括登録',
  '创建成功，并已为您自动创建关联': '作成完了、紐付けが自動的に作成されました',
  查看关联商品库: '紐付け管理を確認',
  领收书下载: '領収書ダウンロード',
  领收书: '領収書',
  流水: '明細',
  是否确定加购样品: 'サンプル発注しますか？',
  查看报价信息: '見積詳細',
  加购成功: 'カート追加完了',
  汇款金额必须大于0: '送金の金額をゼロ以上にしなればなりません。',
  确认取消: '確定',
  '请绑定 Amazon sku': 'Amazon SKU未指定商品あり　AmazonSKUと紐付けして下さい',
  '请绑定 CROSS MALL sku': 'CROSS MALL SKU未指定商品あり　CROSS MALL SKUと紐付けして下さい',
  /**
     *
     */
  换绑: '紐付け変更',
  '绑定Amazon sku': 'Amazon SKU紐付け',
  '绑定CROSS MALL sku': 'CROSS MALL SKU紐付け',
  '申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。': `
    キャンセル処理を実行するとエンドユーザーへの直送を停止し在庫保管します<`,
  是否确认取消授权: 'API連携を解除しますか',
  余额支付: '残高からお支払い',
  申込月数: '申込月数',
  转账成功: '振替完了',
  銀行振込: '銀行振込',
  '您的余额不足，请充值后再次支付':
    '口座残高が不足しています。チャージ後に再度ご注文をお願いいたします。',
  '5s后跳转充值页面': '※5秒後にチャージ画面へ自動で移動します。',
  '5s后跳转附加项配置': '5秒後にオプション設定ページへ遷移します',
  下单失败: '発注失敗',
  下单失败3: '注文に失敗しました',
  /**
     *
     */
  请确认本次重拍费用: '交換手数料を確認',
  当前单价: '単価',
  商品关联列表: '紐付け管理リスト',
  修改关联: '紐付け変更',
  编辑附加项: 'オプション編集',
  '为您的商品编辑的附加项，会再API下单时直接使用。如需修改请点击此处。':
    '商品オプション設定済であれば、API発注の注文商品オプションは自動設定可能です。 「編集」ボタンをクリックすると、再編集することができます。',
  请选择发货附加项: '選択発送用オプション',
  请上传图片: 'ロゴ画像をアップロード',
  一键删除: '一括削除',
  店铺商品信息: '商品情報',
  '如果是个人，请输入无': '個人の場合、なしをご入力ください',
  订单结算费用详情: '費用明細',
  物流详情: '配送状況詳細',
  订单搜索: '注文検索',
  发货详情: '国際配送情報',
  输入你的登陆密码: 'ログインパスワードを入力',
  是否确认复购: 'カートに商品を追加しますか',
  复购成功: 'カート追加完了',
  不同意: '同意しない',
  '请填写商品的尺寸分类。如果有多个大小，请添加行并输入大小。例M、L、XL、30cm*40cm*20cm等': `商品のサイズ分類を記載してください。
    サイズが複数ある場合は、行追加しサイズを入力してください。
    例 M,L,XL,30cm＊40cm＊20cm など `,
  '请输入正确的Amazon sku': '正しい Amazon skuを入力して下さい',
  '请输入正确的CROSS MALL sku': '正しい CROSS MALL skuを入力して下さい',
  打印标签模板: '商品ラベル',
  预览: 'プレビュー',
  设为默认地址: '既定の住所に設定',
  'Amazon sku绑定成功': 'Amazon Sku紐付け成功',
  'CROSS MALL sku绑定成功': 'CROSS MALL Sku紐付け成功',
  'CROSS MALL sku绑定成功': 'CROSS MALL Sku紐付け成功',
  '未处理，请点击【提出】按钮': '未処理<br/> ※正式対応には提出クリック',
  OEM报价: 'OEM見積',
  '处理中，需要1～2分钟': '処理中、所要時間1～2分',
  我的OEM商品: 'OEM商品',
  转到运输公司设置: '運送会社設定へ',
  '点击上方按钮编辑你常用的<span>快捷功能</span>':
    'チェックボックスで画面表示メニューを指定可能です',
  '拉动板块可<span>调整功能排序</span>哦！':
    '各メニューを選択し、構成を変更すると画面表示順を変更できます',
  '编辑后的功能入口在上方显示，你需要的功能直接点击前往即可':
    '編集した表示メニューは画面左上に表示されます<br/>システム内の各メニュー遷移に利用します',
  '<span>透明购</span>: 为首页，并为您推荐1688、淘宝、天猫的商品查找专区。<br/><span>市场购</span>: THE CKB扩展的市场采购货品更全，价格更低。<br/><span>我的频道</span>: 你在本平台的喜欢的商品都在这里。 <br/>任何情况下，点击<span>logo</span>回到本页面':
    '<span>ECサイト購入</span>：中国主要ECサイト(1688、タオバオ、Tmall)で商品検索・買付を行います<br/><span>市場仕入れ</span>：THE CKBが提携する卸売市場から商品検索・買付を行います<br/><span>MYチャンネル</span>：THE CKBからの推薦仕入れ先、お気に入り商品などを表示します<br/>※カエルアイコンクリックで、ECサイト購入　へ遷移します',
  '选择你感兴趣的<span>平台</span>和<span>类目</span>，再输入关键词，搜索更精准':
    '検索ECサイト、カテゴリーを指定し、商品検索キーワードを入力すれば関連商品をシステム内で検索可能です',
  '点击“X”在THE CKB平台搜索':
    '【X】クリックで、指定条件を元にTHE CKBシステム内で商品検索を行います',
  '点击“X”跳转你选择的平台搜索。':
    '【X】クリックで、指定条件を元に指定ECサイトで直接商品検索を行います',
  'THE CKB为你提供了多个选购平台。根据你的<span>采购类型迅速选品</span>。':
    '商品選定の便利サイトを紹介します',
  '点击上方切换你喜欢的品类，我们将根据该品类进行推荐。':
    '表示するカテゴリーを選択します<br/>選択カテゴリーの推薦商品を表示します',
  '如果您有多个店铺可点击这里切换店铺，为不同的店铺采购。THE CKB也会为不同的店铺推荐不同的商品。':
    '複数店舗を切り替えて、店舗毎に商品購入可能です<br/>店舗毎にTHE CKBから推薦商品を提示します',
  '你的专属担当根据你的采购习惯，为您甄选的店铺会展示在这里。':
    '専属マネージャーからの推薦ショップを表示します',
  '此处由系统根据你的采购习惯，为你甄选的店铺会展示在这里。':
    '購入履歴を元に、お客様にあった推薦ショップを表示します',
  '下方为商品的推荐，会根据你的购买习惯更新商品哦！！！':
    'システムから購入履歴を元に推薦商品を表示します',
  '你还没有店铺，快去创建一个你的店铺，用来采购你的商品。':
    '店舗が未作成です<br/>発注には店舗作成が必要です',
  跳过: 'ガイドを終了',
  主钱包: '親アカウント管理口座',
  子钱包: '選択店舗口座',
  国际发货创建成功: '国際配送依頼　作成完了',
  处理中的次品和异常: '不良品・異常（対応中）',
  不可退货次品: '不良品（返品不可）',
  去查看采购订单: '注文詳細へ',
  资金明细: '口座一覧',
  修改商品附加项: '編集',
  订单: '注文',
  申请取消成功: 'キャンセル申請済',
  选择同款: '同一商品URLで発注',
  '是否确认取消国际发货？': 'キャンセルを実行しますか',
  '海外仓（fnsku）/asin': '日本倉庫（fnsku）/asin',
  'Amazon sku/AMAZON商品名称': 'Amazon sku/Amazon商品名',
  '搜索Amazon sku/FNSKU/ASIN/SKU': 'Amazon sku/fnskuを入力して下さい',
  下单中: '注文処理中、暫くお待ちください',
  无效的URL: '有効なURLを入力して下さい',
  请选择打印模板: '商品ラベルを選択して下さい',
  商品更新: '商品更新',
  最新价格为X元:
    '価格を更新された商品あり、最新の注文価格にX元，更新が完了しました。',
  请选择要翻译的语种: '言語を選択：',
  '请输入THE CKB订单编号': 'THE CKB注文番号を入力',
  发货标题: '納品タイトル',
  请设置商品附加项: '商品の検品用オプションを設定して下さい',
  通过点击关联符合您要求的sku: 'クリックで対象商品を紐付け',
  商品附加项要保存吗: '検品用オプションを保存しますか',
  签收成功: '荷物受取完了',
  已签收: '受取完了',
  API状态: 'API連携',
  请上传箱唛: '必須箱ラベルアップロード',
  箱唛文件: '箱ラベル',
  上传箱唛: '箱ラベルアップロード',
  修改箱唛: '配送ラベル変更',
  无法取消附加项: 'キャンセルできません',
  商品情报: '商品情報',
  箱番号: '箱番号',
  请上传装箱清单: '納品書をアップロードして下さい',
  乐天: '楽天',
  乐天sku: '楽天SKU',
  上传文件只能是X格式:
    'アップロードファイルが不正　「X」形式ファイルをアップロードして下さい',
  装箱明细: '納品詳細',
  档口手续费: '市場仕入れ手数料',
  出库手续费: '出庫手数料',
  店铺仓库所在地: '店舗倉庫所在地',
  杭州仓: '杭州ルート',
  广州仓: '広州ルート',
  不需要检品: 'オプション必要なし',
  附加项验证: '商品オプションをご選択下さい',
  一键配置店铺配置商品附加项: '設定された商品オプションを利用',
  一键配置店铺配置发货附加项: '設定された発送オプションを利用',
  客户SKU: 'お客様SKU',
  平台SKU: 'THE CKB SKU',
  复制成功: 'コピー完了',
  'Amazon 库存': 'Amaozon 在庫',
  'Amazon 商品名称': 'Amazon 商品名',
  // 可用库存: '在庫あり',
  不可用: '販売不可',
  关联商品信息: 'メイン商品',
  仅良品数大于0的可创建国际发货单:
    '良品件数が1件未満の場合は、国際配送依頼を作成できません',
  最终采购价: '合計額（清算後）',
  '无法按拼团价进行采购，需按原价进行采购':
    '共同購入の買付期間内で購入条件に達していないため、通常購入価格で購入する必要があります',
  '我们会尽可能按拼团价为您购买，如无法按照拼团价购买，将会按照原价进行购买':
    '共同購入価格の指定条件に達しない場合、通常商品価格で購入します',
  '剩余XX天hh:mm:ss自动扣款': '自動引落まで後XX日hh:mm:ss',
  我的账单: '支払依頼書',
  待支付总额: '未支払額',
  账单名称: '取引内容',
  待支付: '支払待ち',
  扣款说明: '詳細',
  应付总额: '支払金額合計',
  钱包金额: '钱包金额',
  主账户账单: '親アカウント支払依頼書',
  子账户账号: '店舗支払依頼書',
  编辑组合商品: 'セット組商品を作成',
  请选择订单: '注文未選択　注文を選択して下さい',
  统一编辑发货附加项: '一括発送オプション編集',
  '引き落としに成功した場合は、商品を発送いたします。':
    '引き落としに成功した場合は、商品を発送いたします。',
  '残高不足の原因で引落できなかった場合は、出荷作業を停止して別途支払のご案内をお送りいたします。':
    '残高不足の原因で引落できなかった場合は、出荷作業を停止して別途支払のご案内をお送りいたします。',
  'ご入金確認ができ次第、商品を発送いたします。':
    'ご入金確認ができ次第、商品を発送いたします。',
  '発送の影響を与えるないように、商品発送前にはシステム口座に十分な残高を用意しておいて下さい。':
    '発送の影響を与えるないように、商品発送前にはシステム口座に十分な残高を用意しておいて下さい。',
  '点击【确定】按钮，系统将自动从余额扣除当前账单<br />应付总额XX元，确定支付吗':
    '「確定」ボタンをクリックすると、システム口座からXX元を引き落としいたしますよろしいでしょうか',
  请输入拒绝原因: '拒否する理由を入力',
  请选择清关地址: '未設定　Importer住所を設定してください ',
  请选择收货地址: '未設定　受取住所を設定してください',
  按原价采购: '通常購入価格で購入',
  拼团价: '共同購入価格',
  拼多多: 'Pinduoduo',
  '商品采购的最终价格，部分渠道如拼多多存在拼团失败需要按原价购买的情况':
    '最終購入単価Pinduoduoでは条件に達しない場合、共同購入価格ではなく通常単価で購入する場合があります',
  最终采购价详情: '詳細',
  取消类型: 'キャンセル種類',
  客户取消: 'お客様都合キャンセル',
  系统取消: 'THE CKB都合キャンセル',
  提交并下载: 'ダウンロート',
  请求对象姓名: 'お客様名',
  请求金额: '振込金額',
  点击下载: 'クリックしてダウンロード',
  请求书下载: 'デポジット振込申請書',
  请确认优先发货信息: '配送情報の詳細',
  '余额扣费汇率全部以：XX円 = 1元，进行换算，请确认后再进行支付':
    '為替レートは「XX円＝1元」で計算させて頂きます',
  编辑裁剪图片: '画像のサイズ変更',
  名称: '箱番号',
  实际重量: '実重量',
  体积重: '容積重量',
  长: '横',
  宽: '幅',
  高: '高さ',
  箱子: '段ボール箱',
  编辑剪切区域和移动图片: 'サイズ変更　画像を移動する',
  适合正方形logo: '正方形のデザインに適するログ',
  适合长方形logo: '長方形のデザインに適するログ',
  '目前该运输方式暂时无法显示物流状态，烦请自主到物流公司网址进行查询':
    '該当物流会社のステータスは表記できないため、お手数ですが、下記追跡URLにご確認くださいませ。\n 追跡URL：',
  '每一个商品需要上传一个对应的标签文件，格式为PDF，参考如下':
    'PDF形式で各商品ラベルをアップロードして下さい',
  点击查看更多: '詳しい手順についてはこちらへご参照ください',
  '文件SKU和商品列表SKU不一致，请检查后重新上传':
    'アップロードデータは追加された商品SKUと異なり、ご確認頂いた上で、再度アップロードして下さい',
  商品条码上传方式: '商品SKUアップロード設定',
  所有商品一个文件上传: '全SKU一括アップロード',
  一个商品一个文件上传: 'SKUごとに１つファイルとしてアップロード',
  请上传SKU文件: 'ファイルをアップロードしてください',
  '客户资材必须得提前先下好，保存在仓库，否则无法对应':
    '【ご注意ください】 \n 資材は事前にご用意が必要なもので、在庫がないなら対応ができません。在庫ない場合は、まずOEM見積依頼を提出して下さい。',
  跳转外链操作步骤:
    '検索先のECサイトを指定→日本語キーワード入力→指定サイトで商品検索可能',
  slogon: 'もっと簡単 もっと透明',
  '更简单，更透明': 'もっと簡単 もっと透明',
  chrome插件: 'KAERU ツール',
  插件下载: '拡張機能へ追加',
  插件简介: '中国商品リサーチ 発注をもっと簡単に！',
  立即安装: '今すぐインストール',
  站内搜索: 'サイト内検索',
  外部搜索: '外部検索',
  请确认: '【ご確認下さい】',
  '在X系统中追加购买商品的购物车，正在选择中的系统是否符合顾客的意向，请再次确认':
    'Xシステム で買付商品のカート追加が実行されました \n 選択中のシステムがお客様のご意向に沿っているか、再度ご確認下さい',
  d2cb2b系统介绍: 'D2C / B2B システムの補足：',
  系统说明: `D2Cシステム：1点からエンドユーザーへ直送する業務をサポート
    B2Bシステム：在庫を保持し国内EC関連倉庫や自社倉庫へ納品する業務をサポート
    Topメニュー 右側 B2B / D2C アイコンをクリックでシステム切替可能`,
  '系统说明ps(X元Y円)':
    'D2Cシステムは小口配送前提です。1配送単位の商品代金がX元（約Y円）以上の場合、B2Bシステムをご利用下さい',
  会员条约: '会員規約',
  使用条约: '利用規約',
  ホーム: 'ホーム',
  会社情報: '会社情報',
  隐私权政策: 'プライバシーポリシー',
  解除: '解除する',
  商品类目: 'カテゴリー',
  操作取消: '操作を取り消し',
  仅限输入英文字符: '英字のみで入力して下さい',
  仅限输入英文和数字字符: '英数字のみで入力して下さい',
  无效的邮编: '有効な郵便番号を入力して下さい',
  国际物流配置id不能为空:
    '未入力項目あり   運送会社と重量を両方入力してから、計算して下さい',
  '输入的支店名格式不正确，请设置1-20位字符':
    '支店名入力誤り 支店名は、1~20文字以内で入力して下さい',
  销售额取值范围: 'ご注文期間',
  返现类型: '還元方式',
  返现: '固定金額',
  返现2: '還元金額',
  返点: '還元率',
  销售额区间: 'ご注文合計額帯',
  '销售额X%': 'ご注文合計額X%還元',
  为期: '付与計算期間',
  X个月: 'Xヶ月',
  返现发放时间: '現金付与時期',
  每月X日自动返: '毎月X日に自動付与',
  每季度自动返: '四半期毎に自動付与',
  每半年自动返: '半年毎に自動付与',
  充值记录: 'チャージ履歴',
  处理结果: '対応ステータス',
  取消发货任务记录: '発送キャンセル履歴',
  取消采购记录: '買付キャンセル履歴',
  订单是否结算: '清算状況',
  未结算: '未清算',
  结算中: '清算中',
  已结算: '清算完了',
  结算失败: '清算失敗',
  发货取消结果: '配送キャンセル状況',
  查看异常联络处理记录: '処理履歴へ',
  结算时应退款金额: '返金額',
  '商品代金，订单结算后解冻至账户余额':
    'ご注文清算が完了後、キャンセルされた商品の(仮払)商品代金・商品オプション費用がシステム残高に返金されます',
  取消原因: 'キャンセル原因',
  'お客様申請(発送キャンセル済)': 'お客様申請(発送キャンセル済)',
  'お客様申請(発送キャンセル済・在庫保有)':
    'お客様申請(発送キャンセル済・在庫保有)',
  'カラー・サイズ不明': 'カラー・サイズ不明',
  異常注文処理履歴: '異常注文処理履歴',
  在庫切れ: '在庫切れ',
  お客様申請: 'お客様申請',
  予約販売: '予約販売',
  取最小注文ロット数あり消原因: '最小注文ロット数あり',
  '不良品(自動再仕入れ回数上限に達していても、出荷可能良品在庫が足りません)':
    '不良品(自動再仕入れ回数上限に達していても、出荷可能良品在庫が足りません)',
  '不良品(不良品対応設定で「返品返金」ご指定)':
    '不良品(不良品対応設定で「返品返金」ご指定)',
  '在庫切れ(自動再仕入れ回数上限に達していても、出荷可能良品在庫が足りません)':
    '在庫切れ(自動再仕入れ回数上限に達していても、出荷可能良品在庫が足りません)',
  全サイト在庫切れ: '全サイト在庫切れ',
  在庫切れ再発注完了: '在庫切れ再発注完了',
  查看处理详情: '対応詳細確認へ',
  主: '親口座',
  子: '店舗口座',
  '如果您想定制其他复杂产品，比如服饰杂货等，请升级商务舱，我们会有专门的客户经理单独一对一和您对接。': `資材以外（アパレル、雑貨など）のOEMサービスをご利用したい場合は、会員プランにてビジネスクラスにご変更ください。
  資材より、資材以外のOEM製品の開発流れは長くて複雑です。
  ビジネスクラスに対して、OEM経験が豊かな専任スタッフを付き、もっと細かく効率的な対応ができますので、ご興味のある方は、ぜひご検討の程よろしくお願いいたします`,
  模板效果预览: 'テンプレート閲覧',
  检品标准: '検品標準一覧',
  取消尺码变更: 'キャンセル',
  '填写尺码 如：Ｆ，XS，S，M，2XL等':
    '変更後のサイズをご入力　例：Ｆ，XS，S，M，2X',
  月销售额区间: '月销售额区间',
  活动有效期: '活动有效期',
  次品退货退款并付费重拍: '再買付対応',
  '以后的商品为次品时，请都默认处理为次品退货退款并付费重拍。':
    '不良品対応設定：<br/>今後不良品が発生した場合は、すべて「不良品返品返金、有料で再発注する」の方式で対応する',
  '因原商品质量不佳，我们为您重拍时自动寻找了以下新链接，但新链接价格不符合您的预期，请您确认':
    '指定ショップURL　不良品率高<br/>交換しても不良品改善の可能性なし（ロット生産のため）<br/>類似商品の代替ショップで買付可能<br/>→購入単価上限を超過のため、買付可否をご確認下さい<br/>代替ショップURL：<a href="H" target="_blank">H</a><br/>単価：X元',
  '因原商品质量不佳，我们为您自动寻找了以下新链接，请您确认是否需要再新链接下重拍':
    '指定ショップURL　不良品率高<br/>交換しても不良品改善の可能性なし（ロット生産のため）<br/>類似商品の代替ショップで買付可能<br/>代替ショップURL：<a href="H" target="_blank">H</a><br/>単価：X元',
  '以后的商品为次品时，请都默认处理为原商品退货退款并取消商品采购。':
    '不良品対応設定：<br/>今後不良品が発生した場合は、すべて「不良品返品返金、買付キャンセル」の方式で対応する',
  确认尺码: '指定サイズでの買付不可<br/>購入サイズを再度ご確認下さい',
  确认颜色: '指定カラーでの買付不可<br/>購入カラーを再度ご確認下さい',
  确认款式: '指定デザインでの買付不可<br/>購入デザインを再度ご確認下さい',
  全网断货: '全サイト在庫切れ',
  '原商品缺货-推荐同款-价格不符合客户预期':
    '指定URL在庫切れ　代替ショップ買付可能<br/>→購入単価上限を超過のため、買付可否をご確認下さい<br/>代替ショップURL：<a href="H" target="_blank">H</a><br/>単価：X元',
  '原商品缺货-推荐类似款':
    '指定URL在庫切れ　代替ショップ買付可能<br/>代替ショップURL：<a href="H" target="_blank">H</a><br/>単価：X元',
  '预售商品-推荐同款商品':
    '当該商品は予約注文となり、X日後の出荷予定<br/>即日出荷可能な代替ショップあり<br/>代替ショップURL：<a href="H" target="_blank">H</a>',
  '预售商品-无同款商品推荐': '当該商品は予約注文となり、X日後の出荷予定',
  '不满足最小起量-推荐同款商品':
    '最小注文ロットを満たしていません<br/>最小ロット：X件　注文数：Y件<br/>※指定注文数で購入可能な代替ショップあり<br/>代替ショップURL：<a href="H" target="_blank">H</a>',
  '不满足最小起量-无同款商品推荐':
    '最小注文ロットを満たしていません<br/>最小ロット：X件　注文数：Y件',
  '更换同款链接-价格不符合客户预期':
    '指定ショップURL　不良品率高<br/>交換後も不良品改善が見られません<br/>代替ショップでの買付推奨<br/>代替ショップURL：<a href="H" target="_blank">H</a>',
  颜色差异:
    '商品の色差あり<br/>交換しても不良品改善の可能性なし（ロット生産のため）<br/>※問題商品数が多く、納期遅延の可能性大',
  logo差异:
    'Logoが違い<br/>交換しても不良品改善の可能性なし（ロット生産のため）<br/>※問題商品数が多く、納期遅延の可能性大',
  '材质、面料差异':
    '生地が違い<br/>交換しても不良品改善の可能性なし（ロット生産のため）<br/>※問題商品数が多く、納期遅延の可能性大',
  配件差异:
    '付属品が違い<br/>交換しても不良品改善の可能性なし（ロット生産のため）<br/>※問題商品数が多く、納期遅延の可能性大',
  商品上有中文:
    '中国語表記<br/>交換しても不良品改善の可能性なし（ロット生産のため）<br/>※問題商品数が多く、納期遅延の可能性大',
  尺码差异:
    'サイズが違い<br/>交換しても不良品改善の可能性なし（ロット生産のため）<br/>※問題商品数が多く、納期遅延の可能性大',
  设计差异:
    'デザインが違い<br/>交換しても不良品改善の可能性なし（ロット生産のため）<br/>※問題商品数が多く、納期遅延の可能性大',
  $通电不良$:
    '不良理由：通電不良<br/>検品基準により、不良品と判断されました<br/>',
  $通电不良$2:
    '通電不良<br/>※何度も交換して同じ不良品になりました。<br/>再交換しても不良品改善の可能性なし（ロット生産のため）。<br/>不良が許容範囲内の場合、入庫許可を推奨<br/>※問題商品数が多く、納期遅延の可能性大。<br/>不良が許容範囲内の場合、入庫許可を推奨',
  $其他不良$:
    '不良理由：その他<br/>検品基準により、不良品と判断されました<br/>',
  $其他不良$2:
    'その他<br/>※何度も交換して同じ不良品になりました。<br/>再交換しても不良品改善の可能性なし（ロット生産のため）。<br/>不良が許容範囲内の場合、入庫許可を推奨<br/>※問題商品数が多く、納期遅延の可能性大。<br/>不良が許容範囲内の場合、入庫許可を推奨',
  '$污渍/斑点/水印$':
    '不良理由：汚れ・シミ・水シミあり<br/>検品基準により、不良品と判断されました<br/>',
  '$污渍/斑点/水印$2':
    '汚れ・シミ・水シミあり<br/>※何度も交換して同じ不良品になりました。<br/>再交換しても不良品改善の可能性なし（ロット生産のため）。<br/>不良が許容範囲内の場合、入庫許可を推奨<br/>※問題商品数が多く、納期遅延の可能性大。<br/>不良が許容範囲内の場合、入庫許可を推奨',
  $破损$: '不良理由：破損あり<br/>検品基準により、不良品と判断されました<br/>',
  $破损$2:
    '破損あり<br/>※何度も交換して同じ不良品になりました。<br/>再交換しても不良品改善の可能性なし（ロット生産のため）。<br/>不良が許容範囲内の場合、入庫許可を推奨<br/>※問題商品数が多く、納期遅延の可能性大。<br/>不良が許容範囲内の場合、入庫許可を推奨',
  $线头$:
    '不良理由：糸くず・ほつれあり<br/>検品基準により、不良品と判断されました<br/>',
  $线头$2:
    '糸くず・ほつれあり<br/>※何度も交換して同じ不良品になりました。<br/>再交換しても不良品改善の可能性なし（ロット生産のため）。<br/>不良が許容範囲内の場合、入庫許可を推奨<br/>※問題商品数が多く、納期遅延の可能性大。<br/>不良が許容範囲内の場合、入庫許可を推奨',
  $接缝不良$:
    '不良理由：縫製不良<br/>検品基準により、不良品と判断されました<br/>',
  $接缝不良$2:
    '縫製不良<br/>※何度も交換して同じ不良品になりました。<br/>再交換しても不良品改善の可能性なし（ロット生産のため）。<br/>不良が許容範囲内の場合、入庫許可を推奨<br/>※問題商品数が多く、納期遅延の可能性大。<br/>不良が許容範囲内の場合、入庫許可を推奨',
  $抽丝$: '不良理由：伝線あり<br/>検品基準により、不良品と判断されました<br/>',
  $抽丝$2:
    '伝線あり<br/>※何度も交換して同じ不良品になりました。<br/>再交換しても不良品改善の可能性なし（ロット生産のため）。<br/>不良が許容範囲内の場合、入庫許可を推奨<br/>※問題商品数が多く、納期遅延の可能性大。<br/>不良が許容範囲内の場合、入庫許可を推奨',
  $针眼$:
    '不良理由：針の穴あり<br/>検品基準により、不良品と判断されました<br/>',
  $针眼$2:
    '針の穴あり<br/>※何度も交換して同じ不良品になりました。<br/>再交換しても不良品改善の可能性なし（ロット生産のため）。<br/>不良が許容範囲内の場合、入庫許可を推奨<br/>※問題商品数が多く、納期遅延の可能性大。<br/>不良が許容範囲内の場合、入庫許可を推奨',
  $霉菌$: '不良理由：カビあり<br/>検品基準により、不良品と判断されました<br/>',
  $霉菌$2:
    'カビあり<br/>※何度も交換して同じ不良品になりました。<br/>再交換しても不良品改善の可能性なし（ロット生産のため）。<br/>不良が許容範囲内の場合、入庫許可を推奨<br/>※問題商品数が多く、納期遅延の可能性大。<br/>不良が許容範囲内の場合、入庫許可を推奨',
  $生锈$: '不良理由：サビあり<br/>検品基準により、不良品と判断されました<br/>',
  $生锈$2:
    'サビあり<br/>※何度も交換して同じ不良品になりました。<br/>再交換しても不良品改善の可能性なし（ロット生産のため）。<br/>不良が許容範囲内の場合、入庫許可を推奨<br/>※問題商品数が多く、納期遅延の可能性大。<br/>不良が許容範囲内の場合、入庫許可を推奨',
  $商品有中文$:
    '不良理由：中国語表記<br/>検品基準により、不良品と判断されました<br/>',
  $商品有中文$2:
    '中国語表記<br/>※何度も交換して同じ不良品になりました。<br/>再交換しても不良品改善の可能性なし（ロット生産のため）。<br/>不良が許容範囲内の場合、入庫許可を推奨<br/>※問題商品数が多く、納期遅延の可能性大。<br/>不良が許容範囲内の場合、入庫許可を推奨',
  $纽扣破损$:
    '不良理由：ボダン破損あり<br/>検品基準により、不良品と判断されました<br/>',
  $纽扣破损$2:
    'ボダン破損あり<br/>※何度も交換して同じ不良品になりました。<br/>再交換しても不良品改善の可能性なし（ロット生産のため）。<br/>不良が許容範囲内の場合、入庫許可を推奨<br/>※問題商品数が多く、納期遅延の可能性大。<br/>不良が許容範囲内の場合、入庫許可を推奨',
  $拉链破损$:
    '不良理由：ファスナー破損あり<br/>検品基準により、不良品と判断されました<br/>',
  $拉链破损$2:
    'ファスナー破損あり<br/>※何度も交換して同じ不良品になりました。<br/>再交換しても不良品改善の可能性なし（ロット生産のため）。<br/>不良が許容範囲内の場合、入庫許可を推奨<br/>※問題商品数が多く、納期遅延の可能性大。<br/>不良が許容範囲内の場合、入庫許可を推奨',
  $附属品缺陷$:
    '不良理由：付属品欠陥<br/>検品基準により、不良品と判断されました<br/>',
  $附属品缺陷$2:
    '付属品欠陥<br/>※何度も交換して同じ不良品になりました。<br/>再交換しても不良品改善の可能性なし（ロット生産のため）。<br/>不良が許容範囲内の場合、入庫許可を推奨<br/>※問題商品数が多く、納期遅延の可能性大。<br/>不良が許容範囲内の場合、入庫許可を推奨',
  $有气味$:
    '不良理由：匂いあり<br/>検品基準により、不良品と判断されました<br/>',
  $有气味$2:
    '匂いあり<br/>※何度も交換して同じ不良品になりました。<br/>再交換しても不良品改善の可能性なし（ロット生産のため）。<br/>不良が許容範囲内の場合、入庫許可を推奨<br/>※問題商品数が多く、納期遅延の可能性大。<br/>不良が許容範囲内の場合、入庫許可を推奨',
  '原URL缺货，新的URL内商品是X元，请确认':
    '指定URL在庫切れ　代替ショップ買付可能<br/>→購入単価上限を超過のため、買付可否をご確認下さい<br/>代替ショップURL：<a href="H" target="_blank">H</a><br/>単価：X元',
  请在我指定的新链接购买: '以下ショップで買付希望<br/>URL：',
  取消商品采购: '買付キャンセル',
  '取消商品采购+商品发送': '買付およびエンドユーザ発送をキャンセル',
  请在我指定的新链接下采购: '以下ショップで買付希望<br/>URL：',
  '请在THE CKB为我推荐的此链接下采购': '代替ショップURLで購入',
  '可以等待，请继续在原链接采购':
    '指定ショップURLで購入<br/>→発送待ち時間を許容',
  '我接受起订量，请继续在原链接采购':
    '最小ロット数に注文数量を変更し元ショップで購入<br/>(残った在庫は、一旦THE CKB倉庫に保管され、新注文で利用される予定です)<br/>→最小ロット数を許容',
  '我接受起订量，请继续在原链接采购（多采部分商品无异常上架后将作为库存在THE CKB仓库代为保管，并可匹配其他直发订单发出）':
    '最小ロット数に注文数量を変更し元ショップで購入<br/>(残った在庫は、一旦THE CKB倉庫に保管され、新注文で利用される予定です)<br/>→最小ロット数を許容',
  '问题不大，我能接受，请当成良品入库':
    '上記の商品問題を許容し、良品として入庫',
  '此问题我不能接受，请依然当成不良品处理':
    '色差を許容できず不良品として返品返金し、買付キャンセル',
  '我有可能有货的采购链接，请在这个链接再尝试购买':
    '以下ショップで買付希望<br/>URL：',
  '我等不及，请在我指定的新链接下采购':
    '以下ショップで買付希望<br/>→発送待ち時間を許容できず<br/>URL：',
  '我等不及，请在THE CKB为我推荐的此链接下采购':
    '代替ショップURLで購入<br/>→発送待ち時間を許容できず',
  '我不接受起订量，请在我指定的新链接下采购':
    '以下ショップで買付希望<br/>→最小ロット数を許容できず<br/>URL：',
  '我不接受起订量，请在THE CKB为我推荐的此链接下采购':
    '代替ショップURLで購入<br/>→最小ロット数を許容できず',
  'THE CKB推荐的链接价格等不合适，请在我指定的新链接下采购':
    '以下ショップで買付希望<br/>→代替ショップURLの価格を許容できず<br/>URL：',
  '此问题我不能接受，请依然当成不良品处理，并在我指定的新链接购买':
    '上記の商品問題を許容できず不良品として返品返金し、以下ショップで買付希望',
  我还是要继续在原链接采购: '指定ショップURLで購入<br/>→不良品率を許容',
  取消商品重拍: '再買付キャンセル',
  '取消商品重拍+商品发送': '再買付およびエンドユーザ発送をキャンセル',
  次品退货退款并取消商品采购: '買付キャンセル',
  '次品退货退款并取消商品采购+商品发送':
    '買付およびエンドユーザ発送をキャンセル',
  确定后将按照新的货代进行发货:
    '「確定」ボタンを押すと、変更後の運送会社で出荷いたします。<br/>よろしいでしょうか',
  '确定后将取消您的国际发货单，您需重新创建':
    'キャンセルを実行すると、該当国際配送依頼をキャンセルされ、再度国際配送依頼を作成する必要があります。<br/>キャンセルを実行しますか',
  关闭后将不再向您店铺同步物流单号及订单状态:
    '追跡番号の自動反映をオフにすると、自社サイトへの国際追跡番号・発送状況の自動反映が停止されます<br/>追跡番号の自動反映を解除しますか',
  关闭提醒: 'ご確認下さい',
  请选择: '選択して下さい',
  批量搜索: '一括検索',
  '每行一个（支持excel复制黏贴）': `1行に1つずつをご入力、Enterキーを押して改行する
  Excelデータを直接ペースト可能
  ※最大500件まで検索できます`,
  双击批量搜索: 'ダブルクリックで一括検索',
  选择类似款: '代替ショップ買付',
  '此问题我不能接受，请依然当成不良品处理，并取消商品采购':
    '上記の商品問題を許容できず不良品として返品返金し、買付キャンセル',
  '此问题我不能接受，请依然当成不良品处理，并取消商品采购+商品发送':
    '上記の商品問題を許容できず不良品として返品返金し、買付およびエンドユーザー発送をキャンセル',
  后台导入: '移行されたデータ',
  确认重拍: '交換対応',
  '$THE CKB通用纸箱说明$':
    '国際配送向けの高強度で丈夫な段ボール箱を使う、高質で在庫も十分',
  '$THE CKB发货袋说明$':
    '国際運送向けの高強度で丈夫な発送袋を使う、高質で在庫も十分',
  $厂家原箱说明$:
    '破損、国際発送強度に適さない可能性があり、出荷スピードに影響するリスクあり',
  纸箱类附加项必须选择一种:
    '下記の中から、ご希望の段ボール箱をいずれか１つを選択する必要があります',
  发货袋附加项必须选择一种:
    '下記の中から、ご希望の発送袋をいずれか1つを選択する必要があります',
  和日本工作人员在Line上商量:
    'ビジネス以上に変更したい\n日本人スタッフとLineで相談',
  取消发货: '発送キャンセル',
  '同意一个包裹无法装下商品时，THE CKB将为您拆成多个包裹进行发货':
    '・一梱包重量が5KGを超える場合<br/>ご注文された商品を分割して発送させて頂きます。',
  '由于该订单商品无法在一个包裹中装下，我们为您拆成了多个包裹进行发货':
    '1梱包重量が小口輸入規定を超したため、ご注文の商品を分割して発送致しました',
  拆: '自動分納',
  优: '分納',
  下单提醒: 'ご注意',
  下次不再提醒: '次回から表示しない',
  不再提醒: '次回から表示しない',
  采购来源: '仕入れ元',
  人气购物网站: '人気通販サイト',
  '发现海量中国商品，助您更简单，更透明地下单购物！':
    'より多くの商品を見つけることができ、中国仕入れをもっと簡単に！',
  使用tips: '使い方',
  '1.指定采购来源': '1.検索先の仕入れ元を指定',
  '2.选择商品类目或输入关键字': '2.日本語キーワード入力＆カテゴリー選択',
  '3.即可前往指定采购来源站点搜索相关商品':
    '3.指定仕入れ元のサイトで商品検索可能',
  '抱歉，订单正在打包中，不允许修改地址':
    '既に梱包中ですので、商品の配送先を変更できません',
  联系我们: 'お問い合わせ',
  失效: '有効期間切れ',
  '很抱歉！您的店铺（X）因token失效需重新绑定，如需帮助请联系客服':
    'API連携失効（X）連携を解除して再連携をして下さい',
  所选日期区间长度不可超过X天: '開始日を含めX日以内の日付しか選択できません',
  能够在中国找到丰富的供应商: '豊富な中国仕入れルートを開拓可能',
  '按照日本质量标准进行检验（隶属于日本公司）':
    '日本品質基準で検品可能(日本企業提携）',
  '最低国际运费保证，可运往23个国家/地区':
    '国際送料業界最安保証、23カ国·各地域へ発送可能',
  可靠的支持和即时的客户服务: '即時対応のカスタマーサービスで安心サポート',
  会员中心: '会員センター',
  我的会员: 'マイプラン',
  最低: '最安',
  会员规则变更通知: '会員プラン改定のお知らせ',
  '尊敬的用户，THE CKB团队经过谨慎考虑，为了更好的为用户提供服务，决定在经历了一段时间的免费运营后，于2023/1/11开始只对付费会员提供服务。':
    'THE CKBをご利用頂き、誠にありがとうございます。<br/>THE CKBではシステム品質の向上を図り、お客様にご満足頂けるサービス提供のため、<br/>誠に勝手ながら、以下の通り「0円会員プラン」の有料化を行うこととなりました<br/>急な変更となり誠に申し訳ございませんが、ご理解の程宜しくお願いいたします<br/><br/>変更日：<span style="color:#eb4545">2023/1/11</span><br/>変更内容：<span style="color:#eb4545">エコノミープラン　0円　→ 1980円　/月額</span><br/>※有料のエコノミープランへ自動アップデート済（有効期間：<span style="color:#eb4545">2023/01/31まで</span>）',
  '您也不用担心，您是陪伴我们成长的首批用户，我们已为您自动升级到新会员，并且免费送您会员到1月31日（原价1980日元/月)！赶快去试用体验吧！':
    'プラン有料化に伴う主な変更点及び、お客様にご協力をお願いしたい事項は以下となります<br/>＜サービス変更点＞<br/>★エコノミープラン　買付手数料（5％）→無料★<br/>★2023年1月中　会員費無料　＆　Lineお友達登録で更に30日間会員費無料★<br/><br/>＜システム機能の変更点＞※今後順次追加予定<br/>★携帯専用アプリのサービス開始★　2023年3月<br/>★新たなシステム連携先追加（ヤフショ、メルカリ、Stores　など）★　2023年<br/>★新たな中国買付ルート追加★　2023年',
  '到期后会员将失效，将无法享受下单服务，欢迎随时充值新会员。':
    '＜ご協力頂きたい事項＞<br/>新エコノミープランの無料期間以降（無料期間：〜2023/01/31）、お客様ご自身で変更後プランの選択をお願いします<br/>※新プラン選択を行わない場合、システム利用が不可となります。ご注意下さい。',
  新会员权益介绍: '＞詳細はこちら ',
  开通新会员: '新会員プラン変更へ',
  查看新会员: '新会員プラン一覧へ',
  '开通会员，立享下单代买服务。请联系主账号开通。':
    '新規会員登録で中国仕入れが可能！※会員登録は親アカウントから操作して下さい',
  '开通会员，立享下单代买服务': '新規会員登録で中国仕入れが可能！',
  '开通会员，即可享受下单代买服务。': '新規会員登録で中国仕入れが可能！',
  '请联系主账号开通。': '※会員登録は親アカウントから操作して下さい。',
  '即可享受下单代买服务。': '即可享受下单代买服务。',
  '有效期：': '会員資格終了日：',
  未登録: '未登録',
  未登录: 'ログアウト状態',
  '会员等级变更！': '会員プラン変更完了のお知らせ',
  您当前的会员等级已变更为V: 'ご利用プランがVに変更されました',
  立即享用会员: 'システムTOPへ',
  '您的会员已到期！': '会員資格期限切れのお知らせ',
  '您当前的会员已到期，为了不影响正常下单和使用，请及时开通哦！（不影响历史订单集账户余额充值）':
    '選択中会員プランの期限が切れています、極力早めの会員費チャージ手続きをお勧め致します。',
  查看会员: '会員プラン一覧へ',
  // 新会员
  'THE CKB会员，为您的买卖生活提供一切所需。':
    'THE CKB会員プラン、中国仕入れをもっと簡単に！',
  入会优享超多服务:
    'さらに多くの特典を体験するには、スタンダードプランにアップグレード！',
  开通会员: 'アップグレード',
  有效期至: '有料会員資格終了日',
  自动续费已开启: '会員費自動支払: ON',
  自动续费已关闭: '会員費自動支払: OFF',
  成为: 'に変更予定', // xxxx 成为xxx会员
  '{member}に変更予定': '{member}に変更予定',
  去续费: '会員資格を延長する',
  当前自动续费不可开启: '会費の自動引き落とし設定ができません',
  '您在持有预充会员【XX】期间，暂不可开启自动续费。在该预充会员正式开启后，我们会自动为您开启会员的自动续费，敬请谅解。':
    '【XX】プラン変更を予約済のため、会費の自動引き落とし設定ができません<br/>該当プランが有効化されましたら、自動で会費の自動引き落としをオンにします',
  知道了: '閉じる',
  '请及时关闭PayPal账户内不需要的自动续费，如未关闭，我们会将这笔钱充值到您的余额，可能需要您承担部分手续费。':
    '※Paypalの自動支払い設定済で会員プラン更新を行う場合、以前のPaypal自動支払いの解除を行なって下さい。<br/>解除されない場合、自動で費用チャージが実施されます。<br/>誤った費用チャージ分の返金は返金手数料のご負担をお願いするのでご注意下さい。',
  关闭PayPal自动续费教程: '自動支払いの解除マニュアルへ',
  关闭paypal自动续费教程: '自動支払いの解除マニュアル',
  续费提示: '会員資格延長に関するお知らせ',
  '续费后，会在XX开始自动延长YY时间':
    '支払完了すると、選択済プランの会員YYの有効期限はXXから延長されます',
  '检测到您当前有T1至T2的预充会员，续费成功后，会取消原来预充的会员，预充会员的<span style="color:#EB4545;">钱款不予退还</span>。':
    'お客様は既に【V】プラン（有効期間：T1〜T2）変更を予約済のため、プラン更新は実施しないで下さい。<br/>万が一、プラン更新された場合、予約済の【V】は無効となり<span style="color:#EB4545;">事前支払済費用の返金不可となります</span>。',
  升舱提示: '会員プランアップに関するお知らせ',
  '您当前为V1，想开通V2，您想选择何时生效？开通成功后，选择将不可更改':
    '現プランはV1です。V2に変更する場合は、今すぐV2を有効にする <br/>ORV1の有効期間終了後にV2を有効にするかを選択できます。',
  '检测到您当前有T1至T2的预充会员，降仓成功后，会取消预充会员，预充会员的<span style="color:#EB4545;">钱款不予退还</span>。':
    'お客様は既に【V1】プラン（有効期間：T1〜T2）変更を予約済のため、プラン更新は実施しないで下さい。<br/>万が一、プラン更新された場合、予約済の【V1】は無効となり<span style="color:#EB4545;">事前支払済費用の返金不可となります</span>。',
  降舱提示: '会員プランダウンに関するお知らせ',
  '续费后，会在T开始自动延长V时间':
    '支払完了すると、選択済プランの会員V終了日がTから延長されます。',
  '您当前为V1，想开通V2，为保障您当前的会员权益，会等原会员套餐到期（TT）后开始实行降仓会员，是否要进行降仓？':
    '現プランはV1です。V2に変更する場合は、V1の有効期間終了後にV2を有効にします。',
  '检测到您当前有2段会员，升舱成功后，会取消当前会员和预充会员，<span style="color:#EB4545;">钱款不予退还</span>。':
    '会員プラン変更すると、【V1】と【V2】会員資格は無効となります。<span style="color:#EB4545;">会員費の返金はできませんので、予めご了承下さい。</span>',
  '检测到您当前有T1至T2的预充会员，升舱成功后，会取消预充会员，预充会员的<span style="color:#EB4545;">钱款不予退还</span>':
    'お客様は既に【V】プラン（有効期間：T1〜T2）変更を予約済のため、プラン更新は実施しないで下さい。<br/>万が一、プラン更新された場合、予約済の【V】プランは無効となり<span style="color:#EB4545;">事前支払済費用の返金不可となります</span>。',
  立即生效: '今すぐ有効',
  '{time}开始生效': '{time}から有効化', // XXX开始生效
  定时升舱: 'プランアップ予約',
  利用期间: '申込月数',
  '%off': '%割引',
  '折合X円/月': '割引後価格 X円/月',
  已成功开通预充会员: '会員費支払完了',
  已成功开通会员: '会員費支払完了',
  '已为您开启预充会员V，有效期为Y':
    'Vの会員費支払が完了しました<br/>有効期間：Y',
  '已为您开启V，有效期为Y': 'Vの会員費支払が完了しました<br/>有効期間：Y',
  '为了不影响您的后续使用，请保持PayPal内开启自动续费。':
    'PayPalでの自動支払設定を推奨しています、未登録の方は是非設定を！',
  已优惠: 'X円OFF',
  确认协议并立即支付: '規約に同意してお支払いへ',
  请阅读: '',
  会员服务协议: '会員利用規約',
  及: '',
  自动续费服务规则: '自動支払規約', // 整句话 请阅读“会员服务协议”及“自动续费服务规则”
  高级会员专享服务: 'Lineでのご相談',
  '如需开通商务舱或头等舱会员，请先用line扫描右侧二维码联系我们，获取专属咨询服务。':
    '※スタンダードクラス会員以上の利用者様。以下、QRコードをスキャンして相談可能。',
  恭喜成功开通: 'のご利用ありがとうございます。',
  '为了更好地帮您履行下单履约，您需要提前填写以下信息。':
    '注文に関する対応を円滑に進めるため、以下ショップ設定を事前にご対応下さい。',
  添加店铺: '店舗追加',
  采购设置: '仕入れ設定',
  国际配送设置: '国際配送設定',
  暂不设置: '今は設定しない ',
  保存设置: '保存',
  请填写完成国际配送设置: '国際配送設定を行って下さい',
  请填写完成采购设置: '仕入れ設定を行って下さい',
  请填写完成店铺信息: '店舗情報を入力して下さい',
  去开通: 'お申し込み',
  是否要关闭自动续费: 'ご確認下さい',
  '关闭自动续费后，您的V将于T到期。关闭后会影响您后续的正常使用，请谨慎关闭。是否现在关闭？':
    '会員費自動支払を解除すると、現会員プランVの利用がTに終了します。',
  '为了能正常关闭自动续费，请务必前往paypal关闭自动续费。':
    '※Paypalの会費自動支払いを設定した場合、会員プラン変更を行う場合、Paypalの自動支払い設定の解除を行なって下さい。<br/>解除されない場合、自動で費用チャージが実施されます。<br/>誤った費用チャージ分の返金は返金手数料のご負担をお願いするのでご注意下さい。',
  '已为您开启V自动续费，记得保持余额充足。':
    '口座からの自動引落設定を行なった場合：<br/>残高不足で自動支払を失敗した場合は、発注不可となるため、口座に十分な残高をご準備下さい。',
  '为了能正常打开自动续费，请务必前往PayPal开启自动续费。':
    'PayPal自動支払を選択した場合：<br/>paypal公式サイトで自動支払いを設定して下さい。',
  支付金额: '合計額',
  '支付金额(円)': '合計額(円)',
  '尊敬的用户，您需办理会员后，方可下单，请联系主账号办理':
    '発注機能を利用する場合、まず会員登録を行っていただく必要があります<br/><b>親アカウントから会員登録をして下さい</b>',
  办理会员: '有料会員登録へ',
  '尊敬的用户，您于T变更为非会员用户，我们已发站内信告知您：开启自动同步下单功能及按钮已关闭（变为非会员后，不影响历史订单及账户余额提现）':
    'Tより会員資格が停止されましたため、APIの自動発注機能を一時的に停止しました（既に対応された注文、および残高の引出しには影響がありませんのでご安心下さい）<br/>詳しくはシステム内のメッセージからご確認お願い致します。',
  '尊敬的用户，您需办理会员成功后，方可同订单数据':
    '注文取込機能を利用する場合、まず会員登録を行っていただく必要があります',
  '尊敬的用户，您需办理会员成功后，方可开启自动同步下单，请联系主账号办理':
    '自動発注機能を利用する場合は、まず会員登録を行っていただく必要があります<br/><b>親アカウントから会員登録をして下さい</b>',
  '尊敬的用户，您需办理会员成功后，方可开启自动同步下单':
    '自動発注機能を利用する場合は、まず会員登録を行っていただく必要があります',
  '尊敬的用户，您于T变更为非会员用户，已授权的API被禁用，需办理会员成功后，方可同步订单数据，请联系主账号办理':
    'Tより会員資格が停止されましたため、連携済状態のAPI機能が利用出来なくなりました。継続利用を希望する場合は、まず会員登録を行っていただく必要があります<br/><b>親アカウントから会員登録をして下さい</b>',
  '尊敬的用户，您需办理会员后，方可授权绑定子店铺，请联系主账号办理':
    'API連携機能を利用する場合、まず会員登録を行っていただく必要があります<br/><b>親アカウントから会員登録をして下さい</b>',
  '尊敬的用户，您需办理会员成功后，方可授权绑定子店铺':
    'API連携機能を利用する場合、まず会員登録を行っていただく必要があります',
  授权店铺API绑定变更: 'API連携状態変更のお知らせ',
  '尊敬的用户，您于T变更为非会员用户，已授权店铺绑定的API变更为禁用状态（不影响历史订单及账户余额提现）':
    'Tより会員資格が停止されましたため、連携済状態のAPI機能が利用出来なくなりました（既に対応された注文、および残高の引出しには影響がありませんのでご安心下さい）',
  '已授权（禁用）': '連携済（利用不可）',
  '円/月': '円/月',
  '/月': '{currency}/月',
  '{currency}/月': '{currency}/月',
  绑定信用卡支付: 'クレジットカードを追加',
  你还没有绑定信用卡: '現在利用できるカードがございません',
  有効期限: '有効期限',
  请选择信用卡: 'クレジットカードを選択して下さい',
  '是否删除信用卡？': 'このクレジットカード情報を削除しますか？',
  信用卡卡号: 'クレジットカード番号',
  信用卡安全码: 'セキュリティコード',
  仅限数字: '数字のみ入力可能',
  '仅限输入3-4位数字安全码': '3-4桁の数字のみ入力可能',
  '仅限数字，例：05/2022': '数字のみ入力可能　例：05/2022',
  请检查卡信息是否有误: 'クレジットカード情報が正しいかを確認して下さい',
  '支付失败，请重新操作！': '支払い失敗、再度お試し下さい',
  paypal信用卡: 'クレジットカード',
  充值失败: 'チャージ失敗',
  请联系主账号更改: '親アカウントから操作して下さい',
  已为您开启自动续费: '会員費の自動支払を ON にしました',
  设为默认支付方式: 'デフォルトのお支払い方法に設定する',
  支付失败: '支払失敗のお知らせ',
  '余额不足，请先充值余额后重试。':
    '口座残高不足、月額会員費の資金チャージをお願いします。',
  每次询问我处理次品方式: '都度対応方式を確認する',
  '尊敬的用户，您需办理会员后，方可下单':
    '発注機能を利用する場合、まず会員登録を行っていただく必要があります',
  会費: '会費',
  PayPal加载中: 'PayPalロード中',
  '余额不足，请先绑定店铺后充值，再重试':
    '口座残高不足、店舗追加し資金チャージしてから、再度お試し下さい',
  '信用卡-由PayPal提供，支持Visa、MasterCard、AMEX、JCB等类型':
    'VISA、MasterCard、AMEX、JCBなどPayPalアカウントに登録しているクレジットカードブランドをご利用頂けます',
  次品处理: '返品不可不良品対応',
  处理时间: '対応日時',
  '处理中(转正品)': '対応中（良品として入庫）',
  已转正品: '良品として入庫済',
  所属订单编号: 'THE CKB注文番号',
  次品图片: '画像',
  次品原因: '原因',
  次品数: '数量',
  次品共: '返品不可不良品：',
  '次品转正品后，产生的商品附加项费用，可在子钱包（费用流水）页面，使用订单编号查询费用记录，':
    '良品として入庫したら、発生された手数料は店舗資金明細から確認できます。THE CKB注文番号を検索条件として検索もできます。',
  '去查询>': '明細確認へ',
  批量作废: '一括で廃棄する',
  批量转正品: '一括で良品として入庫',
  '您确定转正该批次的次品吗？': '選択した商品を良品として入庫しますか？',
  '次品转正后，平台将按正品处理相关业务流程，且不可再次打次，请慎重操作！':
    '良品として入庫すると、良品の対応方式として対応させて頂き、再度不良品として判断できません選択した商品を良品として入庫しますか？',
  '您确定作废该批次的次品吗？': '【ご確認下さい】',
  '次品作废后将不可转正品，不可退还，':
    '廃棄処理を依頼すると、お客様において当該商品の所有権が放棄されたものとみなされます',
  'THE CKB平台有权自行处理，且无任何经济纠纷，':
    'その場合、再度良品としてお客様に配送依頼ができません',
  '请慎重操作！': '選択した商品を廃棄してもよろしいでしょうか？',
  '已申请转正品！<br />我们将尽快处理，转正品成功后将有站内信通知到您':
    '良品として入庫するの申請を確認して早速対応をさせて頂きます<br />操作完了次第、システム内のメッセージから通知致しますのでご留意下さい',
  已作废成功: '廃棄依頼完了',
  作废: '廃棄する',
  转正品: '良品として入庫',
  含次品转正品: '返品不可不良品が良品として入庫済',
  '次品经您转为正品后，可视为正品下单，存在消费者不可接受的风险，请谨慎操作！平台不承担相关责任。':
    '良品として入庫した後、他の良品としてエンドユーザーへ配送します。エンドユーザーが受け入れられない可能性がありますので予めご了承ください',
  '查看转正记录>': '返品不可不良品の対応履歴へ',
  会员开通记录: '会員費お支払い履歴',
  活动赠送: '無料体験',
  自动续费: '自動更新',
  自动续费2: 'プラン自動更新',
  开通失败: '支払失敗',
  开通成功: '支払済み',
  待生效: '待生效',
  会员套餐: '会員ランク',
  '支付价格（日元）': '金額（円）',
  会员有效期: '会員資格の有効期間',
  导出记录: 'ダウンロード',
  会员订单编号: '注文番号',
  类型2: '種類',
  '如果您现在更改会员计划，您当前的会员资格将失效。请注意，会员费不可退还。':
    '今すぐ会員プラン変更すると、現会員資格は無効となります。<span style="color:#EB4545;">会員費の返金はできません</span>ので、予めご了承下さい。',
  '请重新选择商品附加项，您之前选择的附加项可能失效或价格发生变化':
    '商品オプション未選択ご注文時に選択した商品オプションの価格が変更され、または利用不可になる可能性があるため、再度商品オプションを選択して下さい',
  历史选择商品附加项: 'ご注文時に選択した商品オプション',
  附加项总价: '合計額（概算）',
  开通会员2: '会員費お支払い',
  状态2: 'ステータス',
  '请重新选择商品附加项，': '商品オプション未選択',
  您之前选择的附加项可能失效或价格发生变化:
    'ご注文時に選択した商品オプションの価格が変更され、または利用不可になる可能性があるため、再度商品オプションを選択して下さい',
  请选择附加项后再提交:
    '商品オプション未選択　内容を選択してから再度お試し下さい',
  色差: '色差',
  '污渍/斑点/水印': '汚れ・シミ・水痕',
  破损: '破损',
  线头: '糸くず・ほつれ処理',
  接缝不良: '縫い目',
  抽丝: '伝線',
  针眼: '針の穴',
  霉菌: 'カビ',
  生锈: 'サビ',
  商品有中文: '中国語表記',
  纽扣破损: 'ボタン破損',
  拉链破损: 'ファスナー破損',
  附属品缺陷: '付属品欠陥',
  有气味: '匂いあり',
  其他不良: 'その他',
  处理状态: 'ステータス',
  请输入订单编号: 'THE CKB注文番号を入力',
  银行卡便捷支付: '銀行振込（反映スピードUP）',
  '线下汇款至我们指定的银行账户，点此查看': '弊社指定口座へ振込',
  收款账户信息: '指定口座情報を見る',
  绑定您的支付行信息:
    '振込元口座情報を入力<br/><span style="font-size:12px">※入力間違いにご注意下さい</span>',
  提交支付信息: '振込済金額を入力し提出',
  绑定银行卡信息: '振込元口座を登録',
  '系统确认中的状态是指银行到账通知时间存在差异，如超过3天状态未变更，请先联系当地银行确认打款是否成功，再联系客服处理':
    '入金時間は、金融機関により異なります。但し、もし3営業日以上まだご入金が確認できなかった場合は、まず支払が成功したかどうかを銀行とご確認の上、オンラインカスタマーまでご連絡下さい',
  银行名称2: '弊社受取銀行',
  银行账号2: '口座番号',
  支店名2: '振込元支店名',
  支店号: '振込元支店番号',
  账户持有人: '振込元口座名義',
  设为默认支付方式2: '既定の支払方法に設定',
  系统确认中: '入金確認中',
  '系统确认中~预计1-3个工作日到账，后续可在充值记录查看资金入账情况！':
    '入金確認中<p style="margin-top:10px">1〜3営業日に着金予定で、着金したらチャージ履歴画面にて詳細情報を確認できます!</p>',
  '复制收款银行信息，去线下银行转账至我们的收款银行': '弊社指定口座へ指定金額',
  '线下银行转账成功后，您可以在这里绑定您自己的银行卡信息':
    '振込完了後、お客様の振込元銀行口座情報を入力',
  '输入金额，点击“确定”按钮，提交支付信息':
    '振込済金額を入力し、「確定」ボタンをクリック',
  '请先确认线下汇款成功后再提交，否则审核会被拒绝':
    '銀行振込は、お客さまご自身によって当社が指定する銀行口座への振込手続を行う必要があります。<br/>チャージ申請を提出する前に、振込が完了したかご確認してください',
  '请输入1-20位银行名称': '銀行名称は20文字以内で入力して下さい',
  请输入7位数字银行账号: '口座番号は7桁で入力して下さい',
  '请输入1-20位支店名': '支店名は20文字以内で入力して下さい',
  请输入3位支店号: '支店番号は3桁で入力して下さい',
  '请输入1-20位账户持有人': '名義人は20文字以内で入力して下さい',
  不可代购: '仕入れ不可',
  '输入的密码格式不正确，请设置6-32个字符，字母和数字的组合，字母区分大小写':
    'パスワード入力誤り，パスワードは、6~32文字の英数字混在で設定して下さい（英字は大文字、小文字を識別しますのでご注意下さい）',
  '是否修改密码？': '是否修改密码？',
  '系统检测到您当前的密码过于简单，存在安全风险，建议您修改密码。':
    'パスワードの変更が必要です，パスワードの安全性が低い、不正アクセスを防ぐために、より複雑なパスワードに変更することをお勧めいたします',
  '注册或登录后，将为您推荐更多个性化内容。':
    '新規登録 OR ログインして、お客様の好みに合うコンテンツを確認可能',
  '注册或登录后，可查看更多相似商品':
    '新規登録 OR ログインして、より多くの類似商品を確認可能',
  删除成功: '削除成功',
  完成以下配置才可使用表格导入创建订单功能:
    'Excel一括注文をご利用の場合、以下の注文関連設定を事前に対応が必要となります',
  默认商品附加项配置: 'デフォルトオプション設定',
  默认发货附加项配置: '発送時オプション設定',
  默认国际物流配置: '運送会社設定',
  前往配置: '設定へ',
  注意事项: '注意事項：',
  '1.表格数据最多为1000行，超过请分多个表格导入':
    '１．一度にアップロードできるのは最大1,000行までです。これを超える場合は、複数のエクセルファイルに分割してアップロードしてください',
  '2.仅支持.xlsx、.xls文件，且小于20M':
    '２．アップロードするファイルは .xls または .xlsx形式であり、1ファイルのサイズは最大20MBまでです',
  '3.导入成功后，请前往「待付款」，进行付款后完成下单':
    '3. アップロード完了次第、「注文管理」→「注文履歴」の「支払い待ち」画面にてお支払い下さい',
  '4.当前仅支持日本地址导入':
    '４. Excel一括注文の場合、日本以外の住所をご利用いただくことができません',
  订单创建中: 'アップロード中',
  下单失败提示: 'アップロードが完了しました',
  本次导入成功X个订单: 'アップロードされた件数：X',
  失败X个订单: '失敗件数：X',
  失败订单请重新导入:
    '下記のアップロードに失敗した注文をダウンロードし修正の上、再度アップロードして下さい',
  失败订单下载: 'アップロード失敗の注文をダウンロード',
  我已知晓: '閉じる',
  下载: 'ダウンロード',
  // 表格下单字段改不得
  order_客户订单号: 'お客様注文番号',
  order_直行便SKU: 'THE CKB SKU',
  order_数量: '数量',
  order_收件人姓名: '受取人',
  order_联系电话: '電話番号',
  order_都道府县: '都道府県',
  order_市: '市',
  order_详细地址: '詳細住所',
  order_邮编: '郵便番号',
  order_国家: '国/地域',
  good_直行便SKU: 'THE CKB SKU',
  good_数量: '数量',
  good_客户SKU: 'お客様SKU',
  '表格数据最多为1000行，请分多个表格导入':
    '一度アップロードできるのは、最大1,000行までです。件数が超える場合、複数のエクセルファイルに分かれて行って下さい',
  '表格数据最多为200行，请分多个表格导入':
    '一度アップロードできるのは、最大200行までです。件数が超える場合、複数のエクセルファイルに分かれて行って下さい',
  客户订单号不能为空: 'お客様注文番号を入力して下さい',
  客户订单号最长为100个字符: 'お客様注文番号の最大入力文字数は100文字です',
  商品SKU不能为空: 'THE CKB SKUを入力して下さい',
  '请输入6~100个字符的商品SKU': 'THE CKB SKUは6~100文字以内で入力して下さい',
  '第X行，同一个客户订单号SKU有且仅能有一行':
    'X行目,同じお客様注文番号とTHE CKB SKUがすでに存在します',
  请输入7位数字的邮编: '郵便番号は数字7桁で入力して下さい',
  表格导入创建订单: 'Excel一括注文',
  表格导入中: 'アップロード中',
  表格导入创建商品: 'Excel一括アップロード',
  批量付款: '一括お支払い',
  客户订单号: 'お客様注文番号',
  '商品总额(￥)': '商品合計額（RMB）',
  商品总额: '商品合計額',
  '附加项总额(￥)': '商品オプション合計額（RMB）',
  附加项总额: '商品オプション合計額',
  '总计(￥)': '合計額（RMB）',
  '单价(￥)': '単価（RMB）',
  '附加项金额(￥)': '商品オプション合計額（RMB）',
  附加项金额: '商品オプション合計額',
  '小计(￥)': '小計（RMB）',
  确认订单信息: '注文内容を確認する',
  商品创建中: 'アップロード中',
  请勿上传空文件:
    '空のファイルはアップロードできません。内容を入力してからもう一度お試し下さい',
  请勾选订单: '注文をご選択下さい',
  表格下单: 'Excel一括注文',
  数量不能为空: '数量を入力して下さい',
  请输入大于等于1的整数: '１以上の整数を入力して下さい',
  收件人姓名不能为空2: '受取人名を入力して下さい',
  '请输入1-50个字符的商品SKU': '受取人名は1~50文字以内で入力して下さい',
  联系方式不能为空: '電話番号を入力して下さい',
  '请输入8-11字符的联系方式': '電話番号は数字8~11桁以内で入力して下さい',
  都道府县不能为空2: '都道府県を入力して下さい',
  '请输入1-50字符的都道府县': '都道府県は1～50文字以内で入力して下さい',
  '请输入1-50字符的市': '市は1～50文字以内で入力して下さい',
  都道府县与市不匹配: '都道府県名と市が一致しません',
  详细地址不能为空2: '詳細住所を入力して下さい',
  邮编不能为空2: '郵便番号を入力して下さい',
  '请输入1-50个字符的收件人姓名': '受取人名は1~50文字以内で入力して下さい',
  '相同订单下，收件人信息与第X行不一致':
    '同一注文番号であり、お届け先情報がX行目の情報と不一致です',
  '订单创建成功，完成付款后下单成功':
    'アップロード完了、「注文管理」→「注文履歴」の「支払い待ち」画面にてお支払い下さい',
  第X行: 'X行目',
  数据不完整: '入力データ不備 内容を確認の上、再度お試し下さい',
  数量需为大于0的整数: '数量は１以上の整数を入力して下さい',
  第X行SKU重复: 'X行目　同じTHE CKB SKUがすでに存在します',
  上传失败请重试: 'アップロード失敗　もう一度お試し下さい',
  客户订单号最长为32个字符: 'お客様注文番号の最大入力文字数は32文字です',
  没有该都道府县: '該当する都道府県が存在しません',
  请上传文件: 'ファイルを選択してください',
  '文件大于20M,请重新上传':
    'アップロードファイルは .xls、.xlsx形式である必要があり、1ファイルあたりのサイズは20MBまでです',
  表格导入商品: 'Excel一括アップロード',
  '1.表格数据最多为200行，超过请分多个表格导入':
    '１．一度アップロードできるのは、最大200行までです。件数が超える場合、複数のエクセルファイルに分かれて行って下さい',
  '请输入1-200字符的详细地址': '詳細住所は1~200文字以内で入力して下さい',
  删除成功2: '削除に成功しました',
  '会员才可查看我的收藏、足迹、购买过内的商品哦':
    'お気に入りリスト、閲覧履歴、購入した商品/店舗の閲覧には会員登録が必要です',
  会员登录: '有料会員登録へ',
  '货物发出去之后不要在亚马逊后台再打开这个补货计划，避免调用api失败':
    '納品プランの処理をスムーズに行うため、<br/>商品が発送される前に、Amazonセラーセントラルにて再度納品プランを開かないで下さい',
  '订单读取中，预计需要1-3分钟，请稍后刷新页面查看读取结果':
    '注文取込み中です <br/>１～３分経過後、再度ページを更新して取込結果を確認して下さい',
  处理详情: '対応詳細',
  文件大小不超过10M: 'アップロードできるファイルサイトは10MBまでです',
  'PayPal加载中，请稍等':
    'PayPalの決済ページを読み込み中、しばらくお待ち下さい',
  由PayPal提供服务: 'PayPalによるサービス提供',
  '请求超时，请稍后重试':
    '現在接続できません、しばらくしてからもう一度お試し下さい',
  '预计到账CNY：X元': '見込入金額CNY: X元',
  '支付中，请稍等': 'お支払い処理中です、しばらくお待ち下さい',
  '您填写的信息受到加密保护，请安心填写':
    'ご入力頂いた情報は、暗号化されて保護されますので安心してご入力下さい',
  再试一次: '再読み込み',
  请注意: 'ご注意下さい',
  保留自动续费: '自動支払設定継続(ON)',
  关闭自动续费: '自動支払設定解除(OFF)',
  继续保留自动续费: 'キャンセル(自動支払設定ON)',
  提交并关闭自动续费: '回答提出(自動支払設定OFF)',
  升级成商务舱及以上就可享用更多寻源服务:
    '当該操作はビジネスクラス以上の会員登録が必要です',
  电话: '電話番号',
  充值撤回: 'チャージ取消し',
  请选择银行卡: '支払先の銀行口座を選択して下さい',
  费用合计: '総費用',
  已失效: 'URL切れ',
  已下架: '在庫切れ',
  商品不存在: '削除済商品あり',
  '存在已失效商品，请调整商品':
    '【ご注意下さい】<br/>在庫切れの商品があるため、購入できません',
  '存在已下架商品，请调整商品':
    '【ご注意下さい】<br/>在庫切れの商品があるため、購入できません',
  '存在库存过低商品，请调整发货量或及时补充库存':
    '【ご注意下さい】<br/>THE CKB在庫数不足の商品があるため、購入できません',
  '多个商品有异常，请重新调整商品':
    '【ご注意下さい】<br/>複数商品に異常が発生したため、対応してから再度お試し下さい',
  '商品已下架，请调整商品或发货量':
    '在庫切れの商品があるため<br/>発送数を調整するかまたは在庫保有の注文から在庫を補充して下さい',
  '商品已失效，请调整商品或发货量':
    'URL切れの商品があるため<br/>発送数を調整するかまたは在庫保有の注文から在庫を補充して下さい',
  库存不足: 'THE CKB在庫数不足',
  库存不足1: '在庫が不足しているため、注文できません。事前に日本倉庫に商品を補充してください。',
  库存不足2: '日本倉庫搬送専用在庫不足',
  '该商品近30天不良率超过X%，请谨慎选择。':
    '該当商品の不備率がX%を超えています。違うショップで購入するのがおすすめです',
  '该商品近30天回货速度慢，请谨慎选择。':
    '該当店舗の出荷スピードが平均より下です。違うショップで購入するのがおすすめです',
  '※商品不良包含：次品、到错货、多件/少件情况。':
    '以下のいずれかに該当する場合は、不備と判断します:欠陥品・相違品・欠品',
  '※回货时长超过15天。': '※出荷までの日数が15日以上かかります',
  '当前订单包含需采购的商品，如遇到商品无法采购等情况导致取消时，将通过异常联络通知您，您可在':
    '当前订单包含需采购的商品，如遇到商品无法采购等情况导致取消时，将通过异常联络通知您，您可在',
  中更改默认项: '中更改默认项',
  '超过组合sku数量，一个组合商品至多由30种不同单品sku组成':
    'セット組不可　1注文で単品商品を最大30SKUまでセット組可能です',
  链接添加: '商品URL',
  '遇到该场景时，需要每次都通过异常联络联系':
    '自動発送キャンセル許可せず、都度確認希望',
  '同意THE CKB直接取消该商品发货，剩余商品正常发货，无需询问':
    '自動発送キャンセル許可、同一注文で他商品がある場合、他商品のみ発送',
  '遇到该场景时，若商品为普通商品则无需询问，剩余商品正常发货；':
    '<strong>セット組商品：</strong>自動発送キャンセル許可せず、都度確認希望',
  '若为组合商品的子商品，则需要每次都通过异常联络联系':
    '<strong>セット組商品以外：</strong>自動発送キャンセル許可、同一注文で他商品がある場合、他商品のみ発送',
  '当直发单中存在「全网断货」或「次品重拍到上限」的商品时，是否允许THE CKB直接取消发货任务':
    '<strong>商品発送不可の場合の自動発送キャンセル対応可否を設定（エンドユーザー直送注文）</strong>\n<sub style="color:#999">※「全サイト在庫切れ」OR「自動再仕入回数上限超」の商品がある場合など</sub>',
  发货设置: '異常注文設定',
  '当前订单包含需采购的商品，如遇到商品无法采购等情况导致取消时，将通过异常联络通知您，您可在中更改默认项':
    '弊社対応時の問題事項は、異常注文メニューでお知らせ致します。異常注文発生時のデフォルト対応設定は以下メニューで対応可能です',
  '店铺配置->发货设置': '「店舗管理」→「異常注文設定」',
  '该商品取消采购和发货，订单下其余商品（若有）正常发货':
    '該当エラー商品は発送キャンセル、同一注文で他商品がある場合、他商品のみ発送',
  '该商品取消采购和发货，订单下其余商品（若有）也取消发货，转为库存':
    '該当エラー商品は発送キャンセル、同一注文で他商品がある場合、他商品は在庫保管',
  '该商品取消采购和发货，订单下其余商品（若有）自定义发货或转为库存':
    '該当エラー商品は発送キャンセル、同一注文で他商品がある場合、商品毎に個別対応指示',
  '该商品不取消采购和发货，在我指定的新链接继续购买':
    '該当エラー商品は以下の指定ショップで再購入希望',
  '「已取消」或「已发货」或「待发货」或「触发异常联络未处理」的商品无法再次选择':
    '「キャンセル済」、「発送待ち」、「発送済」、「異常注文判断待ち」の商品は、対応指示変更不可',
  继续发货: '通常発送希望',
  取消发货转为库存: '発送キャンセル、保管在庫へ変更',
  选择结果: '対応指示内容',
  最终组合结果: 'セット組内訳',
  选择: '変更なし',
  次品重拍达到上限: '自動再仕入れ回数上限に達した',
  $次品重拍达到上限$: '自動再仕入れ回数上限に達したキャンセル推奨',
  '由于您选择次品退货退款，未触发次品重拍':
    '『返品返金』の不良品対応を指定のため、不良品が発生次第、自動でショップへ返品・商品代金致します',
  $全网断货$: '全サイト在庫切れ',
  $商品组合信息$: '商品情報',
  $商品基础信息$: '商品情報',
  请选择规格后再追加: '必須項目　商品プロパティ',
  商品已存在: '追加不可　同じ商品既に追加済み',
  请创建关联关系后再选择: 'SKU紐付けを行った後、再度お試し下さい',
  组合或oem商品不允许编辑尺码变更: '组合或oem商品不允许编辑尺码变更',
  请编辑附加项后保存: '必須項目<br/>子商品の商品オプションを選択してください',
  '主商品无库存时下直发单，附加项将不执行':
    '※D2C‐エンドユーザー直送注文の場合、セット組オプションの設定は無効になります',
  请补充手机号信息: '携帯電話番号をご入力してください',
  '为了更好的为您服务，我们建议您补充手机号信息':
    'より良いサービスの提供ができるよう、携帯番号の補充が必要となります',
  不写区号: 'その他',
  补充手机号: '補充します',
  '活动赠送(推广联盟)': '紹介アンバサダー特典',
  经济舱: 'エコノミープラン',
  标准舱: 'スタンダートプラン',
  商务舱: 'ビジネスプラン',
  头等舱: 'ファーストプラン',
  '国/地区': '国/地域',
  '请输入国家/地区': '请输入国家/地区',
  日文名: '日本語表記',
  英文名: '英語表記',
  请先配置默认物流信息: '運送会社設定した後、再度お試しください',
  温馨提示: 'ご確認ください',
  去升级: 'スタンダード会員へ変更',
  暂不升级: 'このまま購入',
  '当前提交的订单商品数量达X件，升级标准舱预计本单可节省Y元手续费(入库手续费&出库手续费)，是否升级后再下单？':
    '該当ご注文の商品数がX点を超えています。<span style="color:#EB4545;">スタンダード会員に変更すると、合計Y元の手数料が無料となります</span>（入庫手数料＆出荷手数料）。<br/>スタンダード会員へアップグレードしましょうか。',
  '出库手续费(预估)': '出庫手数料',
  '入库手续费(预估)': '入庫手数料',
  '可节省手续费合计(预估)': 'スタンダード会員に変更するとX元をお得になります。',
  件1: '点',
  是否拦截: '出荷保留',
  拦截状态: '出荷保留',
  关闭拦截: '保留を解除',
  开启拦截: '出荷作業を保留',
  出荷保留不可: '出荷保留不可',
  // erp5.0.1
  商品发货详情: '商品发货详情',
  商家虚假发货: 'ショップ側虚偽発送',
  物流揽收超时: '物流受け入れ遅延',
  物流周转超时: '物流転送遅延',
  物流停滞: '物流停滞',
  '运力不足，物流缓慢': '輸送能力不足による配送遅延',
  '天气因素，物流缓慢': '天候不良による配送遅延',
  '节日因素，物流缓慢': '祝日による配送遅延',
  '首次加入会员，尊享首月': '新規ご入会で、30日間お試し',
  立即入会: '有料会員登録へ',
  首次加入会员: '新規ご入会で',
  尊享首月: '30日間お試し',
  首次入会: '新規ご入会者様限定！',
  试用: '特別割引体験中',
  '新客优惠活动还剩：': '新規入会キャンペーン応募期間：残り',
  首月: '30日間お試し',
  名额仅剩: '残りわずか',
  '次月续费X円/月': '翌月から毎月X円',
  '※对于新用户专享活动，如果在会员到期前关闭自动续费，则不会产生使用费。只要没有办理关闭自动续费，就会从下个月开始以正常价格续费。':
    '※新規ユーザー限定価格が適用されるのは初月のみとなります。翌月から通常の料金で自動引落しになります。自動引落設定の解除は、会員情報ページから変更可能。',
  '新客{A}円': '{A}円',
  新客1円: '1円',
  新客X折: 'X％割引',
  '新客{x}折': '{x}％割引',
  新人试用活动: '会員費お支払い（割引価格）',
  推广联盟: '紹介アンバサダー',
  '恭喜您已成为THE CKB专业推广者': 'プロ紹介アンバサダーになりました！',
  '恭喜您已成为THE CKB普通推广者': '一般紹介アンバサダーになりました！',
  我的专属推广码: 'あなたの紹介コード',
  '复制邀请码或者链接，即可进行推广':
    '紹介コードまたは紹介用URLをコピーし、知人や友人と共有しましょう',
  复制: 'コピー',
  复制2: 'コピーを作成',
  开启推广之旅: '確定',
  '欢迎来到THE CKB！': 'ザ・THE CKBへようこそ',
  '成功邀请了您，恭喜您获得': '紹介登録特典 ',
  '天会员免费试用！': '日間 無料体験可能！簡単中国仕入れをご体験下さい！',
  我也要推广: '紹介アンバサダーになる',
  '邀请码(选填)': '招待コードを入力',
  邀请码错误: '招待コードが正しくありません。もう一度ご確認ください。',
  '邀请码无效，请重新输入': '招待コードが正しくありません。もう一度ご確認ください。',
  请输入日文: '日本語入力をお願いします',
  请输入英文: '英文入力をお願いします',
  无相关搜索结果: '一致する検索結果なし',
  支持日文搜索: '日本語で検索',
  支持英文搜索: '英語で検索',
  '支持日文/英文搜索': '日本語または英語で検索',
  都道府县日文: '都道府県(日本語表記)',
  市区町村日文: '市区町村(日本語表記)',
  都道府县英文: '都道府県（英語表記）',
  市区町村英文: '市区町村（英語表記）',
  请输入日文详细住所: '詳細住所を日本語でご入力ください',
  请输入英文详细住所: '詳細住所を英語でご入力ください',
  // 4.0.2翻译
  收件人姓名: '受取人',
  '订单中所有商品的状态为“已检品”或“已取消”时，清算订单':
    '注文の全商品ステータスを「検品済」＆「キャンセル済」に変更すると、注文を清算します',
  是否有异常联络: '異常連絡',
  使用客户商品sku: '表示する',
  去找同款: '類似品を探す',
  待付款提醒: '【ご注意ください】',
  '您有{num}笔订单待付款，请及时支付，否则会影响订单履约':
    '【ご注意下さい】支払待ち注文が存在します。ご確認の上お支払い下さい。',
  余额不足: '残高不足',
  分期付款: 'お支払いへ',
  确定支付: '確定',
  已支付: '支払済み',
  本期支付: '今回の支払金額',
  订单总金额: '合計金額',
  '当前账户余额不足，请先充值。':
    '【残高不足】店舗口座残高をご確認の上、資金チャージをして下さい',
  支付信息: '支払金額',
  已支付金额: '支払済金額',
  待支付金额: '未支払金額',
  我司请求重量: 'THE CKB請求重量',
  运输公司请求重量: '運送会社請求重量',
  '※运输公司称重比我司称重的情况下，需要补扣差额。':
    '※運送会社請求重量がTHE CKB請求重量より重い場合、国際送料差額分差し引きを追加します。',
  国际发货详情2: '国際配送明細',
  快递公司: '運送会社',
  发货附加项2: '発送用オプション',
  重量差补扣: '重量差による追加請求金額',
  国际运费补扣总和: '国際送料追加請求総額',
  退款: '国際送料返金',
  国际发货合计额: '国際配送合計金額',
  '金额（元）': '金額(元)',
  偏远地区费: '遠方輸送手数料',
  箱标: '箱ラベル',
  补扣: '追加料金',
  超长费: 'オーバーサイズ料金',
  改派费: '配達先変更手数料',
  扣件费: '配送ストップ手数料',
  退件费: '返送手数料',
  销毁费: '廃棄手数料',
  仓储费: '物流倉庫保管費',
  关税: '税金',
  关税1: '税金立替え（関税+消費税）',
  特殊处理费: '特別対応費用',
  次品退款: '次品退款',
  订单已清算完毕: '注文清算済',
  下载收据: '領収書ダウンロード',
  资金明细2: '資金詳細',
  押金: 'お預かり金',
  已返还: '返金済',
  未返金: '未返金',
  商品代金: '商品代金',
  未确认: '未確定',
  国内运费2: '中国国内送料',
  代购手续费: '手数料',
  '商品代金(押金)': '商品代金(お預かり金)',
  '商品附加项(押金)': '商品オプション(お預かり金)',
  返金: '返金',
  '商品附加项(返品不可不良品)': '商品オプション(返品不可不良品)',
  国内运费退款: '中国国内送料返金',
  既成品采购费: '既製品仕入れ',
  市场商品采购费: '市場商品仕入れ',
  次品重买: '不良品再購入',
  次品退货2: '不良品返品',
  商品组合: '商品組み合わせ',
  入库费: '入庫作業',
  出库费: '出荷作業',
  '订单仍在进行中，当前产生的费用并不是最终实际费用':
    '注文未清算のため、費用がまだ確定していません。ご注意ください',
  '发货费用总额(元)': '国際配送合計金額(元)',
  发货费用总额: '国際配送合計金額',
  // 附加项
  附加项管理: 'オプションセット',
  已失效2: '選択不可',
  商品附加项组合: '商品オプションセット',
  发货附加项组合: '発送オプションセット',
  编辑商品附加项: '商品オプションの設定管理',
  编辑类目附加项: 'カテゴリーオプションの設定管理',
  创建附加项组合: '新規オプションセット',
  修改附加项组合: 'オプションセットの編集',
  操作成功: 'オプションセットが既に設定完了でした',
  附加项组合: 'オプションセット',
  '您可以将多项附加项创建为一个组合，帮助您快速选择附加项':
    '効率向上のため、複数のオプションを同時選択し一つのオプションセットとして設定することができます',
  '抽检数量根据比例向上取整；选择抽检如发生次品，则无法发起售后':
    'ご注意ください：<br/>・抜取検査のサンプル数は比率によって切り上げて整数を取ります。<br/>・抜取検査を行った場合、不良品が発生してもアフターサービスを利用することはできません。<br/>・抜取検査サービスを選択した場合、　検査サンプルに不良品が検出されても、　検品されてない商品は再検査できず全て良品として入庫されます。',
  请填写抽检比例: 'サンプル数の割合を入力してください',
  '使用了抽检服务，无法发起次品售后':
    '抜き取り検査を行った場合、不良品が発生してもアフターサービスを利用することはできません。',
  添加: '追加',
  组合名称: 'オプションセット名',
  肩宽: '肩幅',
  横宽: '身幅',
  胸围: 'バスト',
  前挡: '股上',
  下裆: '股下',
  衣长: '着丈',
  袖长: '袖丈',
  袖宽: '袖幅',
  袖口宽: '袖口幅',
  连肩袖长度: '裄丈',
  领围: '衿周り',
  腰围: 'ウエスト',
  臀围: 'ヒップ',
  前档长: '股上',
  后档长: '股下',
  裤脚宽: '裾幅',
  大腿根围: 'わたり幅',
  半身裙: 'スカート',
  裙长: '総丈',
  连衣裙: 'ワンピース',
  后衣长: '後身頃',
  '头围（内侧）': '頭周り(内寸)',
  高度: '高さ',
  肩带: '肩ひも',
  下胸围: 'アンダーバスト',
  长度: '総丈',
  最大宽度: '最大幅',
  跟高: 'ヒール高さ',
  鞋底宽: '底幅',
  '鞋底的长度（有鞋跟的商品除外）': 'ソール全長（ヒールのある商品を除く）',
  鞋前宽: '甲周り',
  '脚踝围（外侧）': '足首周り（外寸）',
  '筒围（内侧）': 'つつ周り（内寸）',
  鞋底高度: 'ソール高さ',
  宽度: '横',
  我的商品测量结果: '撮影＆採寸結果',
  我的商品测量结果menu: '撮影＆採寸結果',
  附加项数量: 'オプション数',
  请选择2: '選択してください',
  范围: '検査方式',
  抽检比例: 'サンプル比率',
  全检: '全数検査',
  抽检: '抜取検査',
  新增寻源任务: '新規見積依頼',
  分包: 'ショップ側分割発送',
  辅料选择: '資材をご選択下さい',
  快递公司请求重量: '運送会社請求重',
  退差价: '返金',
  本期支付金额: '商品代金(頭金)',
  '订单商品代金(预估)': '商品代金（概算）',
  本次实付商品代金: '商品代金（頭金）',
  待支付商品代金尾款: '商品代金（残金）',
  '订单商品附加项(预估)': 'オプション費用（概算）',
  '订单本次实付金额(预估)': '合計支払金額（概算）',
  '订单已生成，部分订单支付失败，': '注文完了，注文状況から進捗をご確認下さい',
  '订单已生成，生成订单信息如下请随时关注订单动态':
    '注文完了，注文状況から進捗をご確認下さい',
  同一个寻源单不能同时下大货和样品:
    '同じ書類で完成品とサンプルを同時に作成することはできません',
  同一个订单只能存在一个OEM商品下单: '同一注文で重複する商品は発生しません',
  订单应冻结金额: 'お預かり金額',
  合计2: '合計',
  注册信息隐私说明: 'プライバシーに関する注意',
  物流公司不能为空: '※必須項目です',
  展开全部数据: 'もっと見る',
  图像: '画像',
  商品规格2: '規格',
  商品SKU: '商品SKU',
  单价2: '単価',
  单品数量: '単品数量',
  单品落单数: '単品残在庫数',
  '库存发生变更，请重新提交订单':
    '在庫数に変動がありました。再度注文をご提出ください',
  '商品已失效，库存不满足需求量，无法下单': '恐れ入りますが、商品は現在ご注文いただけない状態です（リンク無効・在庫保有不足のため）',
  成品区库存重组需收取组合费用:
    '【ご注意下さい】<br/>単品在庫を利用してセット組した際は、セット組手数料が発生します',
  成品区库存使用数量: '単品在庫利用数',
  质检区库存使用数量: 'セット組残在庫利用数',
  使用库存会收返工费:
    '単品在庫を利用してセット組した際は、再作業手数料が発生します',
  成品区可用的库存数量:
    '単品在庫を利用してセット組した際は、再作業手数料が発生します',
  组合返工费用: 'セット組再作業手数料',
  组合返工: '再作業手数料',
  质检区落单的库存数量: 'セット組商品の残在庫',
  库存: '在庫数',
  '{day}期({rate})商品代金(押金)': '第{day}期目({rate})　商品代金(お預かり金)',
  X期金额: '第X期目商品代金',
  本期冻结总价: '商品代金（頭金）',
  'THE CKB官方精选商品': '1688公式厳選商品',
  收起: '閉じる',
  详细: '詳細',
  展开: '詳細',
  '1. 1688什么是官方精选供应商': '1. 1688公式厳選サプライヤーとは何か',
  '是1688官方选定的价格更具竞争力的人气供应商。':
    '1688公式が選定した、より高い価格競争力を持つ人気サプライヤーです。',
  精选供应商的特点: '厳選サプライヤーの特徴',
  良品率高: '良品率が高い ',
  价格比其他店铺有优势: '価格が他ショップと比べて優位',
  拥有人气畅销商品: '人気売れ筋商品をもつ',
  '1688严格挑选的供应商保证以下条件':
    '1688厳選サプライヤーに以下の条件が保証されています',
  '48小时内店铺发货': '48時間以内ショップ出荷',
  '7天无条件退货': '7日間無条件返品',
  加快退款速度: '返金対応スピード向上',
  '2. 什么是受欢迎的商品': '2. 人気商品とは何か',
  '1688根据公式保留的内部数据，我们分析客户的购买历史，偏好，趋势等，并预测客户可能感兴趣的产品。':
    '1688公式が保持する内部データにより、顧客の購買履歴や嗜好、傾向などを分析し、顧客が興味を持つ可能性が高い商品を予測します。',
  '3. 为什么我们可以给予低价?': '3. なぜ低価格で対応できるのか',
  '严格挑选的特别价格只对特定合作伙伴、企业共享。':
    '厳選サプライヤーに設定された特別価格は、特定パートナー、企業にのみ共有されます。',
  'THE CKB通过与1688的业务合作，作为特定企业可以以特别价格购买商品，也可以提供给THE CKB的会员':
    'THE CKBは、1688との業務提携により特定企業として特別価格で商品を仕入れることができ、THE CKBの会員様にも提供が可能となります。',
  '4. 优点是什么': '4. メリットは何か',
  '根据1所描述的精选供应商的内容和条件，可以缩短订单的交货期，提高良品率。':
    '1に記載した厳選サプライヤーの内容、条件によりご注文の納期を短縮し、良品率を高めることができます。',
  变更理由: '配送不可の理由',
  涉及药事法: '麻薬、医薬品、医薬部外品、医療器具',
  涉及食品法: '食品関連',
  带电池: '電池及び電池が装着されている商品',
  木制品: '木製品',
  侵权产品:
    '特許権、実用新案権、意匠権、商標権、著作権、著作隣接権、育成者権を侵害する物品',
  '粉末，液体，以及易燃易爆物品': '粉末、液体、可燃性物質',
  '武器配件，管制刀具等':
    'けん銃、小銃、機関銃、砲、これらの銃砲弾及びけん銃部品',
  动植物产品: '動植物関連',
  不满足发货重量要求: '配送用の重量要件が満たされていません',
  价格过高: 'ご指定の運送会社の運賃が高すぎ',
  'THE CKB专属会员': 'THE CKB PRO会員',
  'THE CKB专属会员权益': 'THE CKB PRO会員特典',
  立即开通专属会员: 'THE CKB PRO会員を登録する',
  立即续费专属会员: 'THE CKB PRO会員資格を継続する',
  复制专属会员推广链接: 'あなたの紹介用URLをコピーする',
  功能特权: '追加特典',
  您的专属权益: 'PRO会員',
  非会员: '通常会員',
  专属会员专享服务: 'THE CKB PRO会員専属お問合せ',
  专属会员: 'THE CKB PRO会員',
  '您还可选择THE CKB普通会员': 'THE CKB通常会員への登録を選択',
  '如有任何疑问，请用LINE扫描右侧二维码联系我们，获取专属咨询服务。':
    'ご質問等ございましたら、右側のQRコードを読み込む、lineでお問い合わせください。専属コンサルティングサービスを取得する事が可能です。',
  '您无法购买该会员，请前往会员中心购买普通会员':
    'Pro会員を購入できません。会員センターにて通常会員の購入を行ってください',
  提醒: '【ご注意下さい】',
  请输入中文: '中国語入力',
  '注册成功后国家/地区无法更改，请谨慎选择':
    '※登録後の国情報は変更できません',
  // 国际化
  '都道府県/州/地域': '都道府県/州/地域',
  国際料金表: '国際料金表',
  国家不能为空: '国籍は空白に出来ません',
  国家填写有误: '国籍の記入に誤りがあります',
  待确认报价: '見積修正',
  保留中: '保留中',
  通常出荷: '通常出荷',
  'PRO会员尊享：常规权益+PRO追加权益，查看':
    'PRO会員専属：ファーストプラン全サービス+PRO追加特典。プランサービス一覧は',
  常规权益: 'こちらへ',
  '1688原价': '原価',
  '当前会员等级享无水印图片{X}次/月，剩余{Y}次':
    '現在の会員プランでは、透かし無しの画像を{X}回ダウンロード可能。後残{Y}回。',
  '※无水印图片次数说明': '※透かし無し画像ダウンロード権限',
  无限使用: '無制限',
  '{X}次/月': '{X}回／月',
  升级会员享无限次: '会員プランを変更',
  '抱歉，您的无水印次数已达上限，升级会员享受无限次。':
    '透かし無し画像のダウンロード回数上限に達しました。会員プランをアップグレードすると無制限で利用可能。',
  '您当前的会员等级，可享无限次“无水印”图片下载。':
    '現在の会員プランでは、無制限に透かし無しの画像をダウンロード可能。',
  无水印: '透かし無し',
  有水印: '透かしあり',
  同款商品: '類似商品',
  暂无相关搜索结果: '検索結果はありません',
  去站外搜更多: '外部サイトから検索',
  重新上传图片搜索: '画像をアップロード',
  '监测到您当前尚未安装KAERU插件，【站外搜】功能需要配合KAERU插件才可正常使用哦。':
    '【外部サイト検索】機能が使えません。【外部サイト検索】の利用にはKAERUツールのインストールが必要です。',
  '什么是KAERU插件？': 'KAERUツールとは',
  去安装: 'インストールへ',
  暂不安装: 'キャンセル',
  '1688严选': '1688厳選',
  去1688严选搜: '1688厳選サプライヤーから検索',
  查看1688官方精选供应商商品: '1688公式の厳選サプライヤー商品を見る',
  只看精选会员折扣价: '割引価格商品のみ表示',
  已发货2: '発送済',
  未发货2: '未発送',
  找同款: '類似商品を探す',
  会员计划: '会員プラン',
  'LINE 查询': 'LINEでのお問合せ',
  新限量: '新規限定',
  '您输入的值的长度对于目标字段来说可能太短或太长。 请再次输入正确的内容':
    '入力した値の長さは、対象のフィールドに対して短いすぎるか長すぎる可能性があります。再度適切な内容を入力して下さい',
  您输入的值格式错误: '入力した値の形式は正しくありません',
  错误请联系客服: 'エラーあり カスタマーサービスへご連絡下さい',
  '*汇率以“”计算': '※為替レートは「」で計算させて頂きます',
  我确认并同意以上内容: '上記の内容につき、確認・同意する',
  Shopif操作动手册: 'Shopify連携マニュアル',
  您已选择关闭自动付款: '自動支払設定OFF を選択されました',
  '★请再次确认★': '★再確認下さい★',
  '[推荐设置！ 超过90%的用户设定]': '【設定推奨！9割以上の利用者が設定】',
  '我们建议您自动支付支付每月的会员费。':
    '毎月の月額会員費は＜自動支払設定＞をお勧めいたします',
  '*如果自动付款设置为“关闭”，则需要采取以下措施。':
    '※自動支払設定「OFF」の場合、以下の対応が必要となります',
  '① 每月需要缴纳会费工作': '①毎月自身での会員費支払い作業が必要',
  '（2）如果会员有效期满而未采取第（1）项中的措施，则将无法使用所有会员服务。':
    '②①の対応を行わず、会員有効期間を経過すると、全ての会員様向けサービスが利用不可',
  '→需再次办理入会手续': '→再度会員手続きが必要',
  '不可续费功能，超过有效期后无法使用': '有効期間経過後 利用不可機能',
  '· 直接从中国EC网站购买购物车': '·中国ECサイトからの直接カート買付',
  日语和图片产品搜索: '·日本語&画像での商品検索',
  产品订单: '商品発注',
  '· 直接采购中国产品，最高品质检验': '·中国商品の直購入＆最高品質検品対応',
  '·行业最快的物流服务': '·業界最速の物流サービス',
  '最快、最便宜的国际运输': '·最速&最安値での国際発送',
  '· 与其他网站（BASE、shopify、亚马逊等）的链接':
    '·他サイト連携（BASE、shopify、Amazonなど）',
  '· 自动下单、批量产品注册、FBA发货等': '·自動発注、商品一括登録、FBA納品など',
  '如果取消自动付款，过期后将不会自动续充会员':
    '自動支払いを解除された場合、会員資格停止後、',
  '您的订单将自动停止处理，这可能会导致交货延迟。':
    'ご注文処理が自動的に停止され、配送遅延にもつながります。',
  '您确定要关闭会员费自动续费功能吗？':
    '本当に会員費自動支払いを「OFF」にしてよろしいでしょうか？',
  问卷调查: 'アンケート調査',
  '感谢您使用它。 请帮助我们今后改进我们的服务。':
    'ご利用いただきありがとうございました。今後のサービス向上のため、アンケートにご協力ください。',
  必需的: '必須',
  请填写投诉内容: '不満点についてご記入ください',
  '取消自动缴纳会费的原因（可多选）':
    '会員費自動支払いを解除する理由(複数選択可)',
  我想按照自己的节奏使用会员服务: '自分のペースで会員サービスを利用したい',
  我想更改会员费支付方式: '会員費支払い方法を変更したい',
  '我对会员费自动缴费服务功能不满意（焦虑）':
    '会員費自動支払いサービス機能に不満がある（不安）',
  我想取消乘坐直飞航班: 'THE CKBの利用を中止したい',
  其他的: 'その他',
  '请告诉我们您选择“我想取消直飞航班”的原因（可多选）':
    '·「THE CKBの利用を中止したい」で選択した理由を教えてください(複数選択可)',
  不常使用: '利用頻度が低い',
  昂贵的: '料金が高い',
  系统可操作性差: 'システムの操作性が悪い',
  对运送速度不满意: '発送スピードに不満がある',
  对产品质量不满意: '商品品質に不満がある',
  我对支持和询问的答复不满意: 'サポートや問い合わせなどの対応に不満がある',
  我没有得到我想要的服务: '自分にあったサービスがあまり提供されなかった',
  '如果您想使用任何其他服务，请告知我们。':
    '他の利用したいサービスがあったらご記入ください',
  '如果您还有其他意见或要求，请随时填写。':
    'その他、ご意見・ご要望などがありましたら自由にご記入ください',
  '请选择需要的项目。': '必須項目を選択してください。',
  请选择需要的项目: '必須項目を選択してください。',
  结束日期: '終了日',
  新人开通专属会员享: '新規限定 初月',
  '円/首月': '円',
  名额仅剩X名: '残りわずかX名',
  特惠体验中: '特別割引体験中',
  直播价: '【ライブ配信】特別価格',
  直播中: 'ライブ配信中',
  去预约: '配信予約',
  '请购买会员后观看直播。':
    'ライブ視聴は会員資格が必要です。会員登録または更新をお願いします。',
  距离开播还剩: 'ライブが始まるまで',
  '商品缺货，无法下单，请重新勾选商品下单。':
    '商品在庫切れ<br/>該当商品を削除後、再注文をお願いします',
  预约成功: '预约成功',
  系统使用手册: 'システムマニュアル',
  视频: '動画マニュアル',
  下面的检索结果都是1688官方的精选商品:
    '下記の検索結果はすべて1688公式厳選サプライヤー商品になります',
  '搜索1688官方精选供应商以外的店铺时，请使用URL直接搜索或KAERU工具进行对应':
    '1688公式厳選サプライヤー以外のショップを検索する場合、URL直検索またはKAERUツール   を用いてご対応下さい',
  '「1688官方精选，指根据以下内容内部选定的商店」':
    '『1688公式厳選サプライヤーの特徴』 ',
  '·良品率高·价格竞争力高于其他店·1688畅销商品':
    '·良品率が高い ·価格競争力が高い ·1688内の売れ筋商品あり',
  '『精选供应商的保证条件』': '『厳選サプライヤーの保証条件』',
  '·购买后48小时内店铺发货・7天无理由退货・比其他店铺更快速退款':
    '·買付後48時間以内出荷 ·7日間無条件返品可 ·返金対応が迅速',
  'THE CKB会员特惠价': 'THE CKB会員限定 特別価格',
  价格竞争力高于其他店: '価格競争力が高い',
  '1688畅销商品': '1688内の売れ筋商品あり',
  未读: '未読',
  请求失败: '要求に失敗しました',
  对应情报: '対応情報',
  '确认要追加商品吗？': 'カートに商品を追加しますか?',
  // todo 待翻译
  利用规约: '利用規約',
  隐私条款: 'プライバシーポリシー',
  隐私权限: 'プライバシーポリシー',
  次转正提醒: 'ご注意ください',
  OEM条款: 'OEM支援利用規約',
  '请输入THE CKB发货单号': 'THE CKB発送依頼番号を入力',
  '处理缺陷/异常': '不良・異常対応中',
  纸板外箱: '段ボール外箱',
  自有品牌运输袋: '自社ブランド発送袋',
  様: '様',
  '这是提交订单时重新订购（缺货、出现缺陷时重新购买）的临时付款。 包括产品价格和产品选择成本。':
    '注文提出時、再発注(在庫切れ、不良品発生時の再買付)で仮払いただく費用です。商品代金、商品オプション費用が含まれます。',
  '一旦最终费用确定，相关费用将全额退还。':
    '最終費用が確定次第、当該費用は全額返金致します。',
  '经检验、退货、换货等后，为最终产品价格及产品选择费用。':
    '検品や返品、交換など対応後の最終確定した商品代金、商品オプション費用となります。',
  '这将是中国境内的最终运费和购买费用。':
    '最終確定した中国国内送料、買付手数料となります。',
  商品オプション設定: '商品オプション設定',
  料金詳細: '詳細料金表',
  規格: '規格',
  名: '名',
  サイズ: 'サイズ',
  '已上架(已清算)': '検品済み',
  '({time}に保留を自動解除)': '({time}に保留を自動解除)',
  KAERU工具: 'KAERUツール',
  発送: '発送',
  API連携: 'API連携',
  箱唛: '箱ラベル',
  '什么是THE CKB': 'THE CKBとは',
  费率计划: '料金プラン',
  计划诊断: 'プラン診断',
  国际航运: '国際送料',
  代购服务: '仕入サービス',
  '- 购买现有产品': '- 既存品買付',
  '- FBA直送': '- FBA直送',
  检验服务: '検品サービス',
  '- 检查': '- 検品',
  '- 维修': '- 補修',
  物流服务: '物流サービス',
  '- 国际运输': '- 国際運送',
  '- 仓库储存': '- 倉庫保管',
  促销服务: '販促サービス',
  '- 翻译': '- 翻訳',
  '- 照片': '- 撮影',
  '- 导入文章': '- 輸入記事',
  系统: 'システム',
  '- 库存系统': '- 有在庫システム',
  '- 无库存系统': '- 無在庫システム',
  使用流程: 'ご利用の流れ',
  常问问题: 'よくある質問',
  文件要求: '資料請求',
  免费注册2: '無料登録',
  询问: 'お問い合わせ',
  有缺陷的产品退货: '不良品返品',
  OEM批量生产: 'OEM量産',
  OEM样品订单: 'OEMサンプル発注',
  暂无数据: 'データが一時的にありません',
  '由于没有可用的运输方式，需要您取消发货':
    'ご利用可能な配送ルートがないため、発送キャンセルお願いします',
  此订单已取消发货: '発送がキャンセルされました',
  无可用运输方式: 'ご利用可能な配送ルートありません',
  $国际运单号$: '国際発送番号',
  // 直播
  线下: '工場直営',
  必须: '必須項目',
  '国家/地区': '国・地域',
  首页: 'ホームページ',
  用户协议: 'ユーザー規約',
  登录名: 'ユーザー名',
  返回上一步: '前のステップに戻る',
  注册完成: '登録完了する',
  邀请码: '招待コード',
  '登录名/邮箱': 'ユーザー名',
  邮箱登录: 'メールアドレスでログイン',
  '只需绑定一次，后续可用{platform}直接登录': '登録後、{platform}アカウントでもログイン可能になります',
  确认绑定: '連携を完了する',
  '还没有THE CKB账户，现在去注册并绑定':
    'THE CKBのアカウント未登録のため、今すぐ登録・API連携を行ってください',
  去注册: '新規登録はこちら',
  '注册并绑定您的THE CKB账户': 'THE CKBアカウントの作成・連携',
  '绑定您的THE CKB账户': 'THE CKBアカウントのログイン・連携',
  '抱歉，该商品暂不支持购买': 'すみません、該当商品が買付不可です。',
  '使用插件，您可以将1688等平台产品直接添加到THE CKB购物车中。':
    'KAERUツールを利用して1688など公式サイトから直接商品をTHE CKBカートに追加可能  ',
  钱包余额不足: '残高不足口座残高をチャージして下さい',
  国际料金表提示:
    '国際送料に関して以下のポイントをご確認下さい：<br/>・国際送料は、弊社倉庫での実測に基づいて料金が引落されます。<br/>・弊社の測定と物流会社の測定とで誤差が生じる可能性があります。<br/>・出荷後には、遠隔地の料金、配達先住所の変更手数料、サイズ・重量超過の料金など、追加料金が発生する場合があります。<br/>・物流会社からの請求書を確認し、差額がある場合には翌月に請求させていただくことがございます。<br/>また、国際送料の引落しに残高が足りない場合は、出荷が一時停止され、別途支払い案内が送信されます。<br/>ご入金確認後、商品の発送が行われます。<br/>影響を避けるため、商品発送前にシステム口座に十分な残高をご用意いただくようお願いいたします。',
  通关名义: '通関名義',
  个人: '個人',
  企业: '企業',
  邮箱不能为空: '※必須項目です',
  会社编号不能为空: '※必須項目です',
  公司名不能为空: '※必須項目です',
  // 三方登录
  '已经注册的邮件地址。请登录，进行{A}关联。':
    '既に登録済みのメールアドレスです。ログインして、{A}連携を行ってください。',
  同意用户协议: 'プライバシーポリシーに同意する',
  '注册成功后登录名将无法更改。': '登録成功後、ログイン名は変更できません。',
  '6-32个字符': '6〜32文字',
  '字母和数字的组合(字母区分大小写)':
    '英字と数字の組み合わせ（英字は大文字と小文字を区別します）',
  '已有CKB账户，去【登录并绑定】':
    'すでにTHE CKBアカウントをお持ちの場合は、<span>こちら</span>からログイン・連携してください',
  '还没有CKB账户，现在去【注册并绑定】':
    'まだTHE CKBアカウントをお持ちでない方は、<span>こちら</span>からご登録・連携を行ってください。',
  三方登录管理: 'SNS登録管理',
  绑定成功: '連携完了',
  '是否解绑{A}账户': '{A}のアカウントを解除されますか？',
  绑定失败: 'API連携失敗',
  '您的账户已被其他账号绑定，无法绑定当前账号。':
    '持ちのアカウントは既に別のアカウントに連携されているため、現在のアカウントとの連合ができません。',
  授权回调中: 'API連携コールバック中',
  授权成功: 'API連携成功',
  '我还没有CKB账户，现在': 'まだ CKB アカウントを持っていません',
  绑定您的CKB账户: 'ログインして、所有のCKBアカウントと連携する',
  直播回放: 'ライブ再生',
  观看回放: '再生',
  月: '月',
  日: '日',
  主站: 'ホーム',
  // 1688国家货盘---start
  手机验证码: '認証コード',
  注册成为1688官方认证账号: 'THE CKB X 1688  アカウントを新規登録',
  手机号验证码登录: '電話番号でログイン',
  邮箱验证码登录: 'メールアドレスでログイン',
  使用手机号找回密码: '携帯番号入力',
  使用邮箱找回密码: 'メールアドレス入力',
  手机号验证码: '認証コード',
  国家专属搜索和专属货盘: '1688公式優良認定商品',
  '搜索1688国家专属严选货盘 所有产品品质保障': '商品名で1688優良商品を検索',
  'THE CKB为1688日本官方专属运营商': 'Alibaba 1688の公式日本専用サイト',
  'THE CKB为1688日本官方专属代采商': 'Operation by Alibaba Group×SNIFF Group',
  了解国家专属搜索框和普通搜索框的区别: '優良商品検索と通常商品検索の違いは',
  查看1688国家货盘商品: '1688正式認証商品へ',
  '1688日本官方合作伙伴': '1688 JAPAN',
  注册1688官方认证账号: '1688 JAPAN アカウントを新規登録',
  立即注册: '今すぐ登録',
  履约质量: 'ショップ評価',
  综合体验: '総合評価',
  认证工厂: '認証工場',
  '24小时揽收率': '24時間以内の荷物発送率',
  '48小时揽收率': '48時間以内の荷物発送率',
  '5星': '5つ星',
  '4.5星ー5星': '4.5から5つ星',
  '4星ー4.5星': '4から4.5つ星',
  '4星以下': '4つ星以下',
  服务保障: 'サービス保障',
  当日发货: '当日出荷',
  '24小时发货': '24時間以内出荷',
  '48小时发货': '48時間以内出荷',
  '7天无理由': '7日間の無条件の返品',
  '对搜索结果是否满意？': '検索結果に満足していますか？',
  满意: '満足',
  不满意: '不満',
  '请说说你的不满意的点，以便我们改进':
    '改善に参考なるために、不満点を教えてください。',
  感谢您的反馈: 'フィードバックありがとうございます。',
  感谢您的宝贵意见: 'ご貴重な意見頂きありがとうございます。',
  去1688国家专属货盘搜索: '1688商品検索へ',
  '1688国家货盘': '1688公式認定商品',
  手机号登录: '電話番号',
  '手机号格式不正确，请重新输入':
    '電話番号の形式が正しくありません。正しい番号を入力してください。',
  复购率: 'リピーター率高い順',
  获取条款内容失败: '利用規約の取得に失敗しました',
  '该手机号已被注册，请重新输入':
    'この電話番号は既に登録されています。他の電話番号を登録してください',
  // 1688国家货盘---end
  '很遗憾，这个商品不符合日本代购条件，可以看看其他商品':
    'エラが発生しました当該商品が輸出入禁止・規制対象品となるため、買付できません',
  // 为了防止冲突，最后一行不要修改，添加的翻译写在之上
  $最后一行谢谢$: '',
  'Citibankの内部調整に伴い、2023年9月11日（月）19:30（日本時間）より、銀行振込（Citibank）振込サービスを停止させていただけます今後、システムへのチャージは、銀行振込（みずほ銀行）、Paypal、クレジットカードを通じてご利用いただけます。':
    'Citibankの内部調整に伴い、<span style="color:#ff7070">2023年9月11日（月）19:30（日本時間）</span>より、銀行振込（Citibank）振込サービスを停止させていただけます<br />今後、システムへのチャージは、銀行振込（みずほ銀行）、Paypal、クレジットカードを通じてご利用いただけます。',
  登录失败: 'ログインに失敗しました',
  折扣价: '割引価格',
  未授权_: 'ブランドライセンス未取得',
  已授权_: 'ブランドライセンス取得済',
  已失效_: 'ブランドライセンス認可切れ',
  品牌集: 'ブランドコレクション',
  查看更多_: '詳細を見る',
  '请输入主营类目、品牌名称或风格':
    '商品品目、ブランド名、ファッショイメージなどを入力して検索',
  什么是品牌集: 'ブランドコレクションとは',
  主营类目: '商品品目',
  品牌_: 'ブランド',
  风格_: 'ファッショイメージ',
  采购市场_: '仕入れサイト',
  可授权形式: 'ライセンス種類',
  全部_: 'すべて',
  普通授权: '一般ライセンス',
  独家授权: '独占販売権',
  均价范围: '平均商品単価',
  自定义_: '価格帯',
  已授权__: '取得済',
  申请中: '申込中',
  未授权__: '未取得',
  已失效1: '期限切れ',
  地址: '店舗所在地',
  平均客单价: '平均客単価',
  授权类型: 'ブランドライセンス種類',
  品牌风格: 'ブランドイメージ',
  产品理念: 'ブランド理念',
  品牌说明书: 'ブランド紹介',
  授权申请: 'ブランドライセンスを申込',
  收起筛选: '閉じる',
  展开更多: 'もっと見る',
  '距离授权到期仅剩{day}天': '有効期限残{day}日',
  品牌授权已过期: 'ブランドライセンス認可切れ',
  '品牌店铺已关注，请前往商品管理-我的收藏中查看':
    '当該ブランドをフォローしました！「商品管理」ー「お気に入り」でチュックして下さい',
  品牌店铺已取消关注: '当該ブランドをフォロー解除しました',
  所有商品: 'すべての商品',
  类目1: '品目',
  '7日上新': '今週分（週次更新）',
  请输入商品名称: '商品名をご入力下さい',
  '请前往进行品牌授权后，方可购买': '発注にはブランドライセンス取得が必要',
  新增授权任务: '新規申込フォーム',
  品牌图片: 'ブランド画像',
  品牌信息: 'ブランド情報',
  品牌名称: 'ブランド名',
  品牌链接: 'ブランドURL',
  授权条件: '取得条件',
  可授权类型: '申込可能ライセンス種類',
  申请授权类型: 'ブランドライセンス種類',
  请选择1: 'ご選択下さい',
  用途: '用途',
  销售平台: '主な販売サイト',
  平台链接: '販売サイトURL',
  '预计月采购额（円）': '発注見込額/月（円）',
  '预计年采购额（円）': '発注見込額/年（円）',
  其他补充说明: '補充事項',
  是否需要联名: 'コラボ要望',
  联名需求描述: '要望詳細',
  保存1: '一時保存',
  保存并发布: '提出',
  授权条件1: '許可取得条件',
  提示1: 'ご確認下さい',
  '提交授权申请后，THE CKB工作人员会在{day}个工作日内联系您。可在工作台-品牌管理查看授权进度':
    '申請フォーム提出済。{day}営業日以内にご案内いたします。「マイページ」ー「ブランドライセンス一覧」で推進状況確認可能。',
  '授权已保存，可在工作台-品牌管理查看授权进度':
    '申請フォーム一時保存済。「マイページ」ー「ブランドライセンス一覧」で随時編集可能',
  前往查看: '今すぐ確認',
  '前往查看>': '今すぐ確認>',
  下载授权书: '販売ライセンス書 ダウンロード',
  优质供应商: '厳選サプライヤー',
  目录: 'コンテンツ',
  供应商优势: 'ブランドの魅力',
  基础信息: 'ブランドについて',
  热卖产品: 'ヒット商品',
  品牌授权书: '販売ライセンス書',
  品牌授权: 'ブランドライセンス一覧',
  申请类型: 'ブランドライセンス種類',
  申请日期: '作成日時',
  开始日期: '開始日時',
  结束日期1: '締切日時',
  新增品牌授权: 'ブランドコレクション',
  待提交: '未提出',
  审核中: '審査中',
  已授权3: '承認済',
  已拒绝3: '却下済',
  申请信息: '申込情報',
  审核信息: '審査状況',
  授权状态1: 'ステータス',
  授权有效期: '認可有効期間',
  重新申请: '再申請',
  审核详情: '審査状況',
  通过: '承認済',
  时间1: '却下済',
  '是否确认提交？': '提出してよろしいですか',
  '是否确认取消？': '申し込みをキャンセルしますか',
  '存在部分商品未授权，请查看详情并申请授权':
    '【エラー】ブランドライセンス未取得の商品があります。詳細をご確認の上、関連ブランドライセンスをお申し込みください',
  关税收取方式: '関税の納付方法',
  请求书请求: '請求書払い',
  '(物流公司直接向您收取关税和通关手续费)': '(輸送会社が代理支払後請求)',
  账号扣税: 'リアルタイム口座から差引',
  金融机构代码: '口座金融機関コード',
  选择扣税账号: 'リアルタイム口座を追加',
  分行代码: '口座支店コード',
  账号_关税: '口座番号',
  进口商标准代码: '輸入者標準コード',
  价格申报规则: '輸入申告価格の計算方法',
  按照原价申报: '取引価格を変えず申告',
  整单按固定折扣申报: '取引価格を変えて申告（指定比率で減算）',
  '价格申报＝THE直航采购商品单价（元）×申报比率':
    '※価格申告＝THE CKB仕入商品単価（元）×申告比率',
  '关于价格申报比率的填写，因为只能填写51%~99%的范围，所以填写时请注意数值':
    '※価格申告比率の記入について、51%~99%の範囲しか記入出来ないため、記入する時数値をご注意ください',
  '【注意】进行过少申报时，海关有没收运输行李的风险※本公司不承担责任。请谅解':
    '【注意】過少申告を行なった場合、税関で輸送荷物を没収されるリスクあり※弊社では責任は負いかねます。ご了承下さい',
  申报折扣: '価格申告比率',
  申报折扣不能为空: '申告比率が入力されていません',
  申报折扣格式不正确: '入力エラー：数字は51〜99の範囲内で入力して下さい',
  申报折扣必须大于50: '指定可能範囲：51%〜99%',
  申报折扣必须小于100: '指定可能範囲：51%〜99%',
  扣税账号不能为空: 'リアルタイム口座を追加して下さい',
  '您未选择按照原价申报，存在监管风险，海关可能会扣留货物':
    '過少申告を行なった場合、税関で輸送荷物を没収されるリスクあり※弊社では責任は負いかねます。ご了承下さい',
  修改一下: 'キャンセル',
  继续创建: '確認',
  扣税账号设置: 'リアルタイム口座設定',
  添加新账号: 'リアルタイム口座を追加',
  请选择账号: 'リアルタイム口座を選択して下さい',
  设为默认扣税账号: 'デフォルトに設定',
  订单商品总数量: '商品数',
  '该地区不支持访问，请求地址':
    'この地域ではアクセスがサポートされていません。アドレスが要求されました',
  用户IP: 'ユーザーIP',
  点这里给我们发送错误报告:
    'バグレポートを送信するにはここをクリックしてください',
  进入品牌: '詳細を見る',
  联名品牌: 'コラボブランド',
  联名: 'あり',
  不联名: 'なし',
  操作后状态: 'ステータス',
  我收藏的品牌: 'お気に入りブランド',
  品牌已下架: 'ブランド出品停止中',
  前往品牌列表: 'ブランド一覧へ',
  '前往品牌列表>': 'ブランド一覧へ',
  查看全部: '詳細を見る',
  '前往授权>': '代理権取得で割引適用>',
  前往授权: '申し込みへ進む',
  店铺余额: '店舗残高',
  普通授权字段说明: '一般ライセンス：日本で販売可能になることを指します',
  独家授权字段说明: '独占販売権：唯一の独占販売者になることを指します',
  '品牌集的优势介绍 给用户带来什么':
    'ライセンス取得済みの商品を販売することで、安定的なEC事業を継続可能',
  销售平台不能为空: '販売サイトを記載して下さい',
  联名品牌不能为空: 'コラボブランドを記載して下さい',
  '品牌集的优势 用户可以获得哪些权益，在品牌集购买商品有什么优惠等等': `
    中国ブランドを仕入、販売する際に、ブランドのライセンスを許可必要があります。<br/>
    THE CKBでは現時点で、数多くの中国ブランドの独立の販売権を取得し、そんなブランドを集めたコレクションがこちら！<br/>
    THE CKBを通じて、こちらのブランドの販売権を申請することが出来、そして一定の仕入量を達成した場合は独占販売権を申請可能！<br/>
    <br/>
    ブランドライセンスの魅力といえば、①コスト競争力 ②在庫安定さ ③オリジナル性 がポイントとして挙げられます。更にブランドの独占販売権を得ることにより、市場競争の排除、価格の自由設定、売上の安定化等の事が出来ます。<br/>
    中国輸入販売を継続し、価格競争に巻き込まれないよう、ぜひこちらの機能をご活用ください！
    `,
  淘宝: 'タオバオ',
  '验证码正在发送到您的邮箱，请注意查收':
    '認証コードを登録メールアドレスに送信しました。',
  寻找: '探す',
  直营商城: '直売モール',
  待完善: '編集待ち',
  '密码的新建/变更': 'パスワードの作成・変更',
  请填写邮箱: 'メールアドレスを入力してください',
  '正在发送请求，请稍侯': 'お待ちください。現在リクエストを送信中です。',
  手机重置密码: '携帯電話のパスワードリセット',
  次品重买1: '不良品再購入',
  资金明细3: '口座一覧',
  商品附加项1: '商品オプション',
  商品附加项2: '商品オプション',
  押金1: 'お預かり金',
  全检1: '全数検査',
  件2: '件',
  公司英文名: '英語表記',
  服装类目: 'アパレル',
  杂货类目: '雑貨',
  圣诞节HOT商品: 'クリスマスヒット商品',
  展开更多2: 'もっと見る',
  没有搜索结果: '検索結果はありません',
  默认1: 'デフォルト',
  找相似1: '類似商品(THE CKB)',
  英文名1: '英語表記',
  请选择附加项3: 'オプション紐付け',
  选择物流公司1: '運送会社',
  价格1: '価格',
  注意3: 'ご注意下さい',
  起订量1: 'ロット数',
  使用邮箱注册: 'メールアドレスで新規登録',
  使用手机号注册: '携帯番号で新規登録',
  已取消1: 'キャンセル済',
  为了告知介绍大使会员的用户名:
    '紹介したアンバサダー会員にユーザー名を通知するため、',
  '请不要在用户名中注册包含能够识别个人身份的信息，比如真实姓名等。':
    'ユーザー名は本名等個人を識別することのできる情報を登録しないようにお願いいたします。',
  '如果用户名中包含您的个人信息，请事先同意提供给推广者会员。':
    'ユーザー名にお客様の個人情報が含まれていた場合、アンバサダー会員に提供することに予め同意いただきます',
  收起筛选条件: '閉じる',
  展开筛选条件: 'さらに表示する',
  筛选条件1: '選択項目 フィルタ',
  批量修改物流: '一括運送会社変更',
  采购均价: '商品単価（清算後）', // この運送会社では発送不可です要変更
  option手续费: 'オプション費用',
  '默认物流不可发该国家，请重新选择': 'この運送会社では発送不可です要変更',
  '第{day}期': '第{day}期目',
  '商品的供应商次品多，无法购买': '該当工場の製品不良率が高いため、買付不可',
  '※商品的供应商次品多，无法购买':
    '※該当工場の製品不良率が高いため、買付できません。',
  '商品侵权，无法购买': '知的財産権侵害の恐れがあり、仕入不可',
  '※商品侵权，无法购买': '※知的財産権侵害の恐れがあるため、仕入れできません。',
  '商品次品过多，无法购买': '該当製品の不良率が高いため、買付不可',
  '※商品次品过多，无法购买': '※該当製品の不良率が高いため、買付できません。',
  '商品缺货，无法购买': '該当製品は生産終了のため、買付不可',
  '※商品缺货，无法购买': '※該当製品は生産終了のため、買付できません。',
  '商品为易燃易爆产品，无法购买':
    '引火性及びその他危険品に該当するため、仕入不可',
  '※商品为易燃易爆产品，无法购买':
    '※引火性及びその他危険品に該当するため、仕入れできません。',
  '商品为液体，无法购买': '液体物に該当するため、仕入不可',
  '※商品为液体，无法购买': '※液体物に該当するため、仕入れできません。',
  '商品为仿牌，无法购买': '模倣品または海賊版に該当するため、仕入不可',
  '※商品为仿牌，无法购买':
    '※模倣品または海賊版に該当するため、仕入れできません。',
  '商品为粉末，无法购买': '粉末物の物品に該当するため、仕入不可',
  '※商品为粉末，无法购买': '※粉末物の物品に該当するため、仕入れできません。',
  '商品为未防腐处理木制品，无法购买':
    '臭化メチル未処理の木製品に該当するため、仕入不可',
  '※商品为未防腐处理木制品，无法购买':
    '※臭化メチル未処理の木製品に該当するため、仕入れできません。',
  '商品为管制刀具，无法购买': '刀剣類に該当するため、仕入不可',
  '※商品为管制刀具，无法购买': '※刀剣類に該当するため、仕入れできません。',
  '商品为动植物，无法购买': '検疫有害動植物に該当する疑いがあり、仕入不可',
  '※商品为动植物，无法购买':
    '※検疫有害動植物に該当する疑いがあり、仕入れできません',
  黑名单商品不支持下单:
    'エラーが発生しました ブラックリストに載っている商品は仕入れできません',
  '该供应商次品多，无法购买': '該当工場製品不良率高、買付不可',
  '该供应商因次品过多，无法购买其产品':
    '該当工場は製品不良率が高いため、買付できません',
  请取消PayPal自动续费: 'PayPalの定期支払いを解除してください',
  '已设定Paypal的自动支付，请解除以前的Paypal自动支付。如果未解除，将自动进行费用充值。请注意，对于错误费用的退款，您将需要支付退款费用。':
    '現在、定期支払いの停止は完了していません。PayPal公式サイトより解除手続きを進めてください。<br/>返金が必要な場合の振込手数料は、お客様のご負担となります。<br/>ご了承ください',
  一键设置追跡番号自動反映: '一括設定追跡番号自動反映',
  设置当前页追迹番号反映: '現在のページに追跡番号を反映設定',
  开启: 'オン',
  一件购买: '1点から仕入れ',
  批发: '卸売',
  '建议订购数：{num}':
    'お勧めの仕入れ数：<span style="color:#E83D51;">{num}</span>点',
  可享批发优惠价:
    '（<span style="color:#E83D51;">仕入れ単価が下がるため</span>）',
  API自动下单设定: 'API自動発注設定',
  '当自动下单的商品不满足最小起订量，且有“一件购买”价时':
    '卸売最小ロット数未達の場合、「1点から仕入れ」の価格で買付可否を設定して下さい',
  '不询问，自动下单成功（以“一件购买”价）':
    '自動的に「1点から仕入れ」の価格で買付',
  每次询问: '都度対応方式を確認する',
  '有最小起订量限制，价格更优惠': '最小ロット数制限あり・仕入れ単価がより安い',
  '无最小起订量限制，可一件购买': '最小ロット数制限なし・１点から発注可能',
  支持一件代发: '1点から仕入れ可能',
  '当前订单内商品不满足最小起订量，继续下单将以“一件代发”价格下单':
    '最小ロット数に達していません。「1点から仕入れ」の価格で買付しますか',
  '※填写手机号码，优先获得客服联系帮助':
    '※イベントの最新情報を希望される方は、電話番号をご入力ください  ',
  滚动查看更多: 'もっと見る',
  '设置为自动下单，不再询问': 'API自動発注設定画面へ',
  请在下方选择重新购买或取消指示:
    '以下から「再買付」または「キャンセル」指示をご選択下さい',
  为不超过次品退货期限次品默认退货:
    '【※ご注意】日本式検品基準に基づき本商品は不良品と判断したため、メーカへ返品処理中です。<br/>商品代金の返金完了までしばらくお待ちください',
  '＜农历新年前希望交付的OEM订单推荐下单时间＞':
    '＜旧正月前納品を希望するOEM注文のお勧め発注期間＞',
  服装·杂货: 'アパレル・雑貨',
  '1月5日（星期五）': '１月５日（金）前',
  截止: '前',
  材料: '資材',
  '1月18日（星期四）': '１月１８日（木）前',
  '※即使超过接单截止时间，仍然可以下OEM订单，但发货可能会延迟到2月下旬以后。':
    '※お勧め発注期間を過ぎてもOEM発注は可能ですが、発送は２月下旬以降に遅延する可能性があります。',
  '※根据工厂的情况，即使在接单截止时间前下的OEM订单，也有可能在春节之后才发货。':
    '※工場によりますので、お勧め発注期間前のOEM注文でも春節後に発送される場合があります。',
  成品采购春节停止下单时间2:
    '＜旧正月前THE CKB倉庫に納品を希望する既製品注文のお勧め発注期間＞',
  '１月27日': '１月27日（土）前',
  'Taobao・1688等': 'Taobao・1688等',
  '2月4日': '2月4日（日）前',
  '※由于部分店铺已经开始休业，2月4日之前下单的商品也有节前发不出货的可能':
    '※ショップによりますので、お勧め発注期間前のご注文でも２月17日以降に発送される場合があります。',
  '※2月4日（日）~2月17日（土）的订单我们也受理，统一在2月17日之后采购':
    '※お勧め発注期間を過ぎても注文を受付可能ですが、２月17日以降順次対応させていただきます。',
  '※为防止断货建议1月屯两个月库存':
    '※ショップ側の商品在庫切れを避けるために、1月中に2ヶ月分の商品在庫を事前に確保するのをお勧めします。',
  建议春节前尽快囤货2: '',
  春节前希望发货的发货委托制作的推荐期间2:
    '＜旧正月前出荷を希望する発送依頼作成のお勧め期間＞',
  船运节前出货发货依赖截单时间2: '船便',
  空运节前出货发货依赖截单时间2: '空港便',
  '2月1日（木）19时': '２月１日（木）１９時前',
  '2月6日（火）19时': '２月６日（火）１９時前',
  截单时间之后的发货依赖可能会在节后发货:
    '※お勧め期間を過ぎても発送依頼を受付可能ですが、出荷が旧正月明けになる可能性があります。',
  春节期间仓库爆单请提前安排发货:
    '※春節前後の数週間は荷物の量が増えてしまい、通常よりも発送に時間がかかることが予想されます、余裕を持ったスケジュールを計画してください。',
  '＜旧正月 OEM发货和报价申请休假通知＞':
    '＜旧正月　OEM発注・見積依頼休業のお知らせ＞',
  休假期间: '休業期間',
  '2月7日（星期三）至2月17日（星期六）': '２月７日（水）～２月１７日（土）まで',
  '※即使在休假期间，我们仍然接受OEM发货和报价申请。':
    '※休業期間中でもOEM発注や見積依頼を受け付けております。',
  '我们将在旧正月过后顺序处理，请尽早提交您希望订购的商品。':
    '旧正月明けに順次対応させていただきますので、発注希望の商品は早めにご提出いただくことをお勧めいたします。',
  '我们建议您尽早提出申请。': '',
  '＜旧正月期间成品采购停业通知＞': '＜ 旧正月 既製品買付休業のお知らせ＞　',
  休业期间: '休業期間',
  '2月4日（星期日）至2月17日（星期六）': '２月４日（日）～２月１７日（土）',
  '※即使在休业期间，我们仍然接受订单。':
    '※休業期間中でも注文を受け付けております。',
  '我们将在旧正月过后按顺序进行处理，请尽早提交您希望订购的商品。':
    '旧正月明けに順次対応させていただきますので、発注希望の商品は早めにご提出いただくことをお勧めいたします。',
  '＜旧正月仓库停业通知＞': '＜旧正月　倉庫休業のお知らせ＞',
  'D2C（仓库发货停止）2': 'Ｄ２Ｃ（倉庫出荷停止）',
  '2月9日（星期五）至2月14日（星期三）': '２月９日（金）～２月１４日（水）',
  'B2B（仓库发货停止）2': 'Ｂ２Ｂ（倉庫出荷停止）',
  '2月9日（星期五）至2月17日（星期六）': '２月９日（金）～２月１７日（土）',
  '※即使在休业期间，仍然可以创建发货请求，但我们将按照重新开放业务的顺序进行处理。':
    '※休業期間内でも発送依頼作成が可能ですが、営業再開降順次対応させていただきます。',
  '月费{price}': '月額{price}円',
  'D2C订单的情况下，购买手续费为{fee1}/个，入库手续费为{fee2}/个，出库手续费为{fee3}/个，总计为{fee4}/个。':
    'D2Cで注文する場合、買付手数料{fee1}/点、入庫費{fee2}/点、出庫費{fee3}/点が掛かるので<br/>トータル{fee4}/点になります。',
  '请注意，如果发生这些手续费，可能无法退款。':
    '手数料が発生された場合、返金不可の可能性があるためご注意ください。',
  元_1: '元',
  PRO会员: 'PRO会員',
  默认顺序: 'デフォルト順',
  价格从低到高: '単価の安い順',
  价格从高到低: '単価の高い順',
  '新商品確認サービスでは、サンプルの撮影と採寸を行います。':
    'このサービスでは、入庫された商品（サンプル品）の撮影と採寸を行います。サンプルの返品につきましては、不良品のみ対応させていただきます。',
  '同じSKUで複数の商品をご購入の場合でも、確認対象は一つの商品に限定されます。':
    '同じSKUで複数の商品をご購入の場合でも、確認対象は一つの商品に限定されます。',
  选择的订单国家不一致:
    '一括変更不可 配送地域の異なる注文が含まれているため、一括変更ができません',
  次品默认退货退款: '※不良品は自動的に返品されます',
  '请决定发生次品时，您的重拍设置': '不良品発生時の再買付設定を教えて下さい',
  留在购物车: 'カートに戻る',
  '商品SKU作用旨在区分相同商品的不同规格、尺寸、颜色等。':
    '同じ商品の仕様、サイズ、色などを区別するために、<br/>お客様独自に設定した商品の識別コード指します。',
  '您可以直接填写自家店铺现有的的商品SKU，也可以额外设置新的SKU。':
    '自社ショップの商品SKUをそのまま使用したり、別途独自のSKUを設定することができます。<br/>数字のみでも使用可能であり、英字と数字の組み合わせも利用できます。',
  '用于识别不同订单。': '注文を特定するために使用されます。',
  '您可以直接引用自家店铺的客户订单号，':
    'お客様の自社ショップの注文番号をそのまま引用できますし、',
  '也可以另外输入文字区分您的订单。': '注文タイトルを入力するのも可能です。',
  '例）': '例）',
  '＜店铺订单号＞ 503-0575395-6075865': '＜店舗注文番号＞　503-0575395-6075865',
  '＜订单标题＞ 2024年1月24日李先生的订单已读':
    '＜注文タイトル＞　令和6年1月24日山田様分',
  专属折扣价: '特別価格',
  '关联商品可以支持1对多的绑定啦！':
    '关联商品可以支持<b style="color:#008060;">1对多</b>的绑定啦！',
  '该价格仅供参考，请登录后获取实际价格信息':
    'この価格は参考価格であり、実際の価格情報はログイン後にご確認いただけます。',
  '在国际发货时，如果包含易碎或尖锐的物品，建议选择气泡膜或者缓冲垫。':
    '国際発送時には、割れやすいものや尖ったものを含む場合、プチプチ梱包やクッション梱包の利用をお勧めします。',
  '气泡膜体积较小，但是保护作用会比缓冲垫差一点。':
    'プチプチ梱包は容積が小さいため、保護効果はやや劣ることがあります。',
  '缓冲垫体积较大，但是保护作用较强。':
    'クッション梱包は大きな容積を持ち、より強力な保護が可能です。',
  '您也可以选择同时使用两种缓冲材。不管是哪种方式都无法确保100%不破损。': '両方の緩衝材を併用することもできますが、100％の破損防止を保証することはできません。',
  注册或登录以查看更多信息: '閲覧するには、新規登録またはログインして下さい',
  '加入CKB 会员计划以查看更多信息': 'ページ閲覧には有料会員登録が必要です',
  库存保管费: '在庫保管料',
  包裹滞留费: '出荷保留荷物保管料',
  '免费滞留天数（自然日）': '無料保管日数',
  结算周期: '決済期間',
  发货单编号: '国際配送番号',
  滞留日期: '出荷保留日',
  发货完成日期: '出荷完了日',
  免费滞留天数: '無料保管日数',
  计费类型: '種類',
  '数量(体积)': '数量（容積）',
  体积: '容積',
  体积类型: 'サイズ規格',
  '元/个/天': '元/点/日',
  个: '点',
  '元/m³/天': '元/m³/日',
  明细下载: '明細ダウンロード',
  关于超过免费保管期限的保养费: '無料保管期間を過ぎた場合の保管料について',
  超小: 'XS',
  小: 'S',
  中: 'M',
  大: 'L',
  超大: 'XL',
  '注: 体积为3边合计，小于1cm则按1cm计算':
    '※箱の縦、横、高さの3つの寸法を足した3辺サイズです。1cm未満の場合、１cmとして計算されます。',
  关于超过免费滞留期的滞留费:
    '残高不足による出荷停止が発生した荷物の保管料について',
  按包裹计费: '荷物の数量で計算する',
  按箱子计费: '梱包サイズで計算する',
  '注: 箱子体积小于1㎡则按1平方米计算':
    '※容積は1㎥未満の場合、1㎥として計算されます',
  '您本月库存保管费和包裹滞留费账单已生成，合计XX元。请前往"资金管理"进行查看':
    '今月分の保管料明細書が発行されました（合計XX元）。詳細は「資金管理」画面でご確認下さい',
  包裹: '荷物',
  $箱子$2: '梱包',
  及以上: '~',
  '3边合计': '3辺合計サイズ',
  库龄: '在庫の保管日数（日）',
  以上: '以上',
  '180日以上': '180日以上',
  '365日以上': '365日以上',
  总计天数: '決済期間保管日数',
  需计费天数: '有料保管日数',

  是否使用在途库存: '処理中在庫を使用しますか',
  使用1: '使用する（処理中の在庫を直送注文に使用）',
  '(如果您选择了「使用」，如您有处理中的库存，将会使用处理中库存进行下单(无需支付商品费用，处理中库存成品上架后即可发货))':
    '在庫は検品が完了すると自動的に発送されます',
  不使用1: '使用しない（改めて仕入れ先から買付）',
  '(如果您选择了「不使用」，则会为您采购成品库存不足的商品)':
    '新規買付された商品を直送注文に使用します',
  使用在途库存: '処理中在庫を利用する',
  不使用在途库存: '処理中在庫を使用しない',
  处理中库存提醒: '処理中在庫のお知らせ',
  '以下商品有正在处理中的库存，请选择处理方式：':
    '以下の商品は一部が処理中です。対応方法を選択して下さい:',
  '不使用在途库存，直接下单重新采购': '処理中在庫を使用せず、新規買付を行う',
  '使用处理中库存进行下单（无需支付商品费用，处理中库存成品上架后即可发货）':
    '処理中在庫を使用する（商品が直送注文に使用されます。検品が完了すると自動的に発送されます。）',
  '请选择是否使用在途库存进行下单处理方式：':
    '処理中在庫の対応方法を選択して下さい:',
  批量优先发货: '一括分納発送',
  请将优先发货筛选项改为是后操作1:
    '「注文検索」→「分納発送」で、分納発送可能の注文を絞込んでから、一括処理を行って下さい',
  请将优先发货筛选项改为是后操作:
    'エラーが発生しました。<br />「注文検索」→「分納発送」で、分納発送可能の注文を絞込んでから、一括処理を行って下さい',
  '批量优先发货中，请稍等1-3分钟，期间请勿重复操作':
    '【分納発送処理中】　１～３分程度時間をおいてから再度お試しください',
  在途: '引当予定',
  在途抵用: '処理中在庫使用',
  等待采购: '買付待ち',
  采购处理中: '買付中',
  采购完成: '買付完了',
  国内运输中1: '中国国内運送中',
  已入库1: '入荷済み',
  质检中1: '検品中',
  异常处理中: '異常処理中',
  //   取消: '取消',
  同意1: '確認',
  购买数: '発注数',
  处理中库存使用数: '処理中在庫数',
  是否确认批量优先发货: '一括分納発送をしますか',
  '※処理中＝ 国内運送中＋入庫済み＋検品中':
    '※処理中＝ 国内運送中＋入庫済み＋検品中',
  已经存在提前发货任务:
    'すでにバッチ処理中です。分納発送をご希望の場合は、注文を個別に処理して下さい',
  '在国际发送时，在包含易碎物品或尖锐物品的情况下建议使用小型包装和靠垫包装。':
    '国際発送時には、割れやすいものや尖ったものを含む場合、プチプチ梱包やクッション梱包の利用をお勧めします。',
  '小型包装由于容积小，保护效果会稍差。':
    'プチプチ梱包は容積が小さいため、保護効果はやや劣ることがあります。',
  '靠垫包装有很大的容积，可以进行更强有力的保护。':
    'クッション梱包は大きな容積を持ち、より強力な保護が可能です。',
  '也可以同时使用两种缓冲材料,我们不能保证100%的防损坏。':
    '両方の緩衝材を併用することもできますが、100％の破損防止を保証することはできません。',
  '按手起批 1手={num}双': 'セット売り {num}点で1セット',
  商品数量选择不正确:
    '【発注エラー】セット販売の商品があります。倍数で発注して下さい',
  '此商品附加项只对该订单中需采购的商品生效，对库存商品不生效':
    'この商品追加オプションは、この注文で購入する商品にのみ有効で、在庫商品には適用されません。',
  选择订单数: '注文数',
  确认分纳发送吗: '一括分納発送をしますか？',
  发送确认: '确认分纳发送吗 ',
  更新成功: '更新しました',
  // sku一对多翻译
  '关联商品可以支持(1对多)的绑定啦！':
    '１店舗商品SKUあたり、(最大３つまで)の仕入れ商品SKU（THE CKB SKU）と紐付けができるようになりました',
  供货商品数: '紐付け商品数',
  api商品: '店舗商品',
  创建关联商品: '商品SKU紐付け',
  选择已同步商品: '店舗商品を選択',
  选择外部销售商品: '店舗商品を選択',
  选择供货商品: '仕入れ商品を選択',
  选择关联的规格: 'SKU紐付け',
  保存即关联成功: '保存して完了',
  销售商品: '店舗商品',
  请输入商品名2: '商品名を入力',
  '当前店铺未绑定API，授权后可绑定商品，享受自动下单功能':
    'API未連携。API連携後、SKU紐付けと注文自動発注が可能',
  去授权: 'API連携へ',
  请先去授权: '【検索エラー】先にAPI連携して下さい',
  '当前店铺已绑定API，去选择要绑定的商品':
    'API連携済み。商品SKUを紐付けして下さい',
  选择销售商品: '店舗商品を選択',
  重置2: 'リセット',
  选择2: '選択',
  绑定中: '紐付け処理中',
  已关联: '紐付け済み',
  未关联: '未紐付け',
  供货商品: '仕入れ商品',
  '选择OEM、组合商品': 'OEM、セット組、在庫商品、お気に入り商品から選択',
  '绑定成功后，多个供货商品之间的库存可共用！下单时会按照顺位进行依次扣除':
    '紐付け完了後、仕入済み商品の在庫数は共有されます。在庫は第1商品から優先的に利用されます。',
  '请输入URL、商品名、THE CKB SKU': '商品名、URL、THE CKB SKUで検索して紐付け',
  主2: 'メイン',
  商品: '商品',
  '所有供货商品库存不足时，将会采购主商品':
    '保有在庫数が０の場合は、第1商品を新規買付します。',
  次: 'サブ',
  '第{num}顺位商品': '第{num}商品',
  设为主商品: 'メインに設定',
  规格2: 'バリエーション',
  去选择要绑定的供货商品: '仕入れ商品を選択して下さい',
  '可支持绑定多个商品，建议前往绑定库存商品':
    '１商品につき、最大３つまで仕入れ商品SKU（THE CKB SKU）を紐付けできます',
  库存商品: '在庫商品',
  是否确认删除2: '仕入れ商品を削除しますか',
  删除后将自动解绑该商品下已绑定的SKU:
    '削除後、商品SKU紐付けが自動解除されます',
  绑定成功2: '紐付け完了',
  '抱歉，绑定失败': '紐付けが失敗しました',
  '原因：该商品已被其他销售商品绑定，需要先解绑后才能绑定该商品。':
    '理由：既に他の店舗商品と紐付け済みです。先に紐づけを解除して下さい ',
  当前被该商品绑定: '紐付け済みの店舗商品',
  解绑并绑定到当前商品上: '解除して紐付ける',
  最多只能绑定3个商品:
    '１商品につき最大３つまで、仕入れ商品SKU（THE CKB SKU）と紐付けできます',
  最多只能绑定30个商品:
    '１商品につき最大３0つまで、仕入れ商品SKU（THE CKB SKU）と紐付けできます',
  供货商品库存: '仕入れ商品  THE CKB在庫数',
  销售商品库存: '店舗商品  THE CKB在庫数',
  '当前售卖商品库存为关联的所有供货商品的库存总和，以便您进行销售库存的预估和管理':
    '店舗商品  THE CKB在庫数＝仕入れ商品（第１＋第２＋第３商品）の合計保有在庫数となります',
  销售sku: '店舗商品SKU',
  销售SKU: '店舗商品SKU',
  去绑定: '商品SKU紐付け',
  修改绑定: 'SKU紐付け変更',
  当前商品绑定关系: '紐付け詳細',
  '当前商品未绑定Amazon sku，请在下方搜索进行绑定':
    'Amazon SKUの紐付けは完了していません。検索欄で検索して紐付けして下さい',
  平台2: 'プラットフォーム',
  '请输入要绑定的Amazon sku': 'Amazon SKUを入力して下さい',
  '请输入要绑定的CROSS MALL sku': 'CROSS MALL SKUを入力して下さい',
  '已绑定Amazon sku': 'Amazon SKU紐付け完了',
  '已绑定CROSS MALL sku': 'CROSS MALL SKU紐付け完了',
  查看商品绑定关系: '詳細を確認',
  我知道了3: '閉じる',
  '当所有供货商品库存不足，将会采购主商品':
    '保有在庫数が０の場合は、第1商品を新規買付します。',
  是否设为主商品: '第１商品（メイン）に設定しますか',
  是否解绑: '紐付けを解除しますか',
  编号: 'sku',
  '当前店铺未授权同步数据功能，授权后可绑定商品，享受自动下单功能':
    'API未連携。API連携後、SKU紐付けと注文自動発注が可能',
  '当前店铺已授权同步数据功能，去选择要绑定的商品':
    'API連携済。店舗商品を選択して下さい',
  去选择: '商品SKU紐付け',
  去选择2: '店舗商品を選択',
  去选择3: '仕入れ商品を選択',
  '请点击“同步商品”': '「店舗商品取込」をクリックして下さい',
  '可支持绑定多个商品，前往去绑定库存商品':
    '店舗商品につき、最大3つまでの仕入商品を紐付けできます。紐付け完了後、THE CKB在庫は「第1商品 → 第2商品 → 第3商品」の順に利用されます。複数倉庫出荷を設定している場合は、優先庫の設定に従って在庫が使用されます。いずれの在庫も0の場合、第1商品（メイン商品）のみが新規で買付されます。',
  '可支持绑定多个商品，前往去绑定库存商品1':
    '店舗商品につき、最大3つまでの仕入商品を紐付けできます。紐付け完了後、THE CKB在庫は「第1商品 → 第2商品 → 第3商品」の順に利用されます。複数倉庫出荷を設定している場合は、優先庫の設定に従って在庫が使用されます。',
  '当前商品未绑定Amazon sku,请在下方搜索Amazon sku进行绑定':
    'Amazon SKUの紐付けは完了していません。検索欄で検索して紐付けして下さい',
  '当前商品未绑定CROSS MALL sku,请在下方搜索CROSS MALL sku进行绑定':
    'CROSS MALL SKUの紐付けは完了していません。検索欄で検索して紐付けして下さい',
  当前sku已绑定: '紐づけエラー：当バリエーションは既に他の商品と紐付け済みです',
  是否解除绑定: '紐付けを解除しますか',
  三方商品关联不允许多对多:
    'エラーが発生しました。当該商品は同時に複数の店舗商品と紐付けすることができません',
  黑名单商品不允许关联商品:
    '仕入れ商品はブラックリストに登録されているため、紐付けできません',
  '该商品不在该店铺内，请重新操作':
    '店舗アカウントが切り替えられため、商品データを読み取れませんでした。引き続き紐付けするには、元店舗に切り替えて下さい',
  '请先选择三方商品后，再添加此商品来绑定吧！':
    '店舗商品を先に選んでから、SKU紐付けと注文自動発注が可能',
  一键添加: '商品紐付け',
  请输入商品名3: '店舗商品名で検索',
  '标签模板包含logo，请上传logo图片': 'テンプレートに商品ロゴが含まれる場合、ここでロゴ画像をアップロードして下さい',
  品牌不能为空: 'ブランド名未入力',
  收件人名不能为空: '受取人名未入力',
  店铺名不能为空: '店舗名未入力',
  会社名不能为空: '会社名未入力',
  会社名: '会社名',
  收件人名: '受取人名',
  商品标签logo: '商品ロゴ',
  商品标签模板: '商品ラベル',
  新建模板: 'テンプレートを作成',
  编辑模板: 'テンプレートを編集',
  zozotown商品标签信息: 'zozotown商品ラベル詳細',
  批量导入: '一括アップロード',
  已上传: 'アップロード済み',
  '商品标签为空，请上传标签信息': '商品情報が不足しています。情報を追加して、ファイルを再アップロードして下さい',
  '商品标签信息缺失，请补充': '商品情報が不足しています。「編集」ボタンをクリックして、情報を再編集して下さい',
  '仅支持xlsx文件，请检查后重新上传': 'ファイル形式が不一致です。XLSXファイルをアップロードして下さい',
  '文件字段与模板字段不一致，请检查后重新上传': 'テンプレートと一致している必要があります。データを編集して、ファイルを再アップロードして下さい',
  '商品列表不存在此SKU，请删除': '商品データがありません。ファイルから削除して、再アップロードして下さい',
  '字段长度大于50，请删减': '1つのセルに入力できる文字数の上限は５０文字までです。削除してから、ファイルを再アップロードして下さい',
  请先新建模板: 'テンプレートを先に作成して下さい',
  下载商品标签模板: 'テンプレートをダウンロード',
  纳品书明细: '納品書明細',
  打印内容类型: '種類',
  变量: '商品情報',
  条形码: 'JANコード',
  添加内容: 'プリント項目の追加',
  字段名称: '内容',
  固定文本: 'テキスト',
  LOGO: 'ロゴ',
  纸张尺寸: 'ラベルサイズ',
  重复添加: '追加した内容は既に存在しています',
  列: '列目',
  excel内容为空: '商品情報が不足しています。情報を追加して、ファイルを再アップロードして下さい',
  请先添加商品: '商品を先に追加下さい',
  zozotown商品标签: 'zozotown商品ラベル詳細',
  已存在: 'アップロード済み',
  客户码: '入庫予定日',
  条形码必须为数字: 'JANコードで使える文字は数字のみです。0から9までの数字を入力して下さい',
  price必须为正数: 'Price（値段）の数値は０より大きくして下さい',
  请输入: '入力して下さい',
  仓库打印纳品书时需要显示相关信息: '納品書のプリントアウトに必要な情報です',
  操作步骤: '手順',
  选择纸张尺寸: 'ラベルサイズを選択',
  调整模板内容: 'プリント項目を編集',
  移动显示位置: 'プリント項目の位置を調整',
  保存模板: 'テンプレートを保存',
  操作提示: 'ご注意下さい',
  '可以通过点击删除不需要的内容，如果您想要新增内容，可点击【追加】按钮进行新增': '※消したい商品規格をクリックして削除できます。また、「プリント項目の追加」ボタンを押して新しい規格を追加することも可能です。',
  '红色边框的内容表示您需要通过excel进行上传，黑色边框的内容为固定文本会固定显示在商品标签纸上': '※赤枠で囲まれた詳細情報はExcelファイルで編集し、アップロードする必要があります。',
  示例图: '参考例',
  '请先下载商品标签模板，填写内容后再上传模板': 'テンプレートをここでダウンロードし、内容を編集してから「ファイルをアップロード」をクリックしてアップロードして下さい',
  失效商品不允许关联商品:
    'エラーが発生しました。 出品停止した商品と紐付けできません',
  易燃易爆物品: '可燃性物質',
  粉末: '粉末',
  液体: '液体',
  保管费计费尺寸: 'サイズ規格',
  // 库存保管费: '在庫保管料',
  尺寸规格: 'サイズ規格',
  '3边总尺寸': '3辺合計サイズ',
  库存保管天数: '在庫保管日数',
  '0-180日': '0-180日',
  '181日以上': '181日以上',
  '141cm以上': '141cm以上',
  '{price}元/点/日': '{price}元/点/日 ',
  自建独立站: '自社ECサイト',
  // 成本计算器
  总预估成本价: '仕入原価計算',
  请先在下方选择SKU: '商品バリエーションを選択して下さい',
  成本计算: '原価計算',
  应用工具: 'ツール',
  成本计算器: '原価計算ツール',
  运输公司: '運送会社',
  预估运输费用: '国際送料の見積もり',
  运输时效: '配送日数',
  费用暂时无法预估: '見積もり不可',
  运费估算: '国際送料計算',
  展开1: '展開',
  更多: 'もっと見る',
  支持表格字段自定义展示: '選択した項目のみを表示可能',
  表格筛选: '表示項目',
  标题1: '項目名称',
  明细1: '詳細',
  表格恢复为初始状态: 'リセット',
  表格已恢复为初始状态: 'リセットしました',
  约: '約',
  寄往国家: 'お届け先国',
  运送会社: '運送会社',
  '补充手机号，获得担当优先服务!': 'イベントの最新情報を希望される方は、電話番号をご入力ください',
  立即填写: '入力する',
  主账号余额: '利用可能額（親アカウント）',
  主账号余额1: '利用可能額',
  立即处理: '確認する',
  API自动下单异常: 'API自動発注エラー',
  待支付账单: '支払依頼書（支払待ち）',
  OEM待确认报价: 'OEM見積（承認待ち）',
  常用功能: 'よく使う機能',
  全部功能: 'すべて',
  '有包裹因欠费而无法发货，请尽快转账': '残高不足のため、一部の荷物の発送が一時停止しています。早めのチャージをお願いします',
  自定义常用功能: '追加',
  待处理异常订单: '異常注文（対応待ち）',
  组合商品落单: 'セット組残在庫',
  重要公告: '重要なお知らせ',
  热门活动: 'キャンペーン',
  功能更新: '機能更新',
  暂无公告: 'お知らせがありません',
  会员自动续费: 'プラン自動更新',
  '条(未读)': '通（未読）',
  'X个包裹因欠费而无法发货，请尽快充值': 'X个包裹因欠费而无法发货，请尽快充值',
  请添加常用功能: '「よく使う機能」を追加してください',
  最多添加5个常用功能: '追加できる「よく使う機能」は５つまでです',
  在库商品: '在庫商品',
  当前店铺: '現在の店舗',
  箱规: '梱包サイズ',
  '标准舱客户可以提供OEM资材服务。商务舱及以上客户可以提供服装，杂货OEM服务': 'OEM資材サービスはスタンダード会員以上、OEM既製品（アパレル、雑貨）サービスはビジネス会員以上の方がご利用いただけます。ご利用の場合は、会員ランクの変更を行ってください。',
  导出SKU费用明细: '費用明細書ダウンロード',
  sku费用明细: '費用明細',
  // 单品预估成本价: '单品预估成本价'
  // 修改: '修改'
  /** 清野需求 */
  注意事項: '注意事項',
  '1.色物の場合は、洗濯時に多少色落ちすることがありますので、他の洗濯物との混入はお避け下さい。また、汗や湿った状態での摩擦により、色落ちが生じる恐れがあります。': '1.色物の場合は、洗濯時に多少色落ちすることがありますので、他の洗濯物との混入はお避け下さい。また、汗や湿った状態での摩擦により、色落ちが生じる恐れがあります。',
  '2.洗濯後多少の縮みがあります。': '2.洗濯後多少の縮みがあります。',
  '3.生成り、淡色製品には蛍光増白剤が入っていない洗剤をご使用下さい。': '3.生成り、淡色製品には蛍光増白剤が入っていない洗剤をご使用下さい。',
  水洗标名称: 'テンプレート名',
  '在下单时，如未主动选择水洗标，将全部设为默认水洗标': '※注文時に洗濯タグを未選択の場合、デフォルトの洗濯タグが適用されます',
  设为默认水洗标: 'デフォルトに設定',
  请输入水洗标名称: 'テンプレート名を入力して下さい',
  填写的客户商品规格将打印在水洗标上: '入力内容は洗濯タグに表示されます',
  '示例：L码，红色等': '例：レッド、Ｍサイズ',
  '请输入客户商品规格  示例：L码，红色等': '商品情報を入力してください（例：レッド、Ｍサイズ）',
  '日本工业标准法要求产品上需要标注商品规格信息，若无规格信息，您的商品售卖可能受到影响': '※日本の法律により、アパレル商品の販売時には品質や洗濯表示などが記載されたタグを取り付けることが義務付けられています。',
  水洗标图片: 'テンプレート画像',
  '您填写的规格信息将打印在该商品的水洗标上，请您再次确认规格信息是否正确,确认后规格信息将作用在该SKU所有订单上': '編集した商品規格情報は洗濯タグに表示されます。<br/>内容に誤りがないことを確認してから、「確定」を押して下さい',
  '打印水洗标，需确认客户商品规格信息': '洗濯タグを作成するには、まず商品規格情報を編集して下さい',
  批量导入规格: 'Excel一括編集',
  客户商品规格只用于在水洗标上打印: '「お客様商品規格」は洗濯タグの表示のみに使用されます',
  在库管理编辑: '「在庫管理」より編集',
  订单编辑: '注文画面より編集',
  组合商品编辑: '「セット組商品一覧」より編集',
  购物车下单: 'カートより編集',
  场景: '操作',
  '客户商品规格/客户SKU': 'お客様商品規格・お客様SKU',
  修改客户商品规格为: '変更後お客様商品規格：',
  修改客户SKU为: '変更後お客様SKU：',
  '3.导入成功后将更改客户商品SKU及客户商品规格信息': '３．アップロードが完了すると、お客様のSKUとお客様商品規格が変更されます。未入力の場合は、両方とも空白となりますのでご了承ください。',
  '4.THE CKB SKU为必填项，客户商品SKU及客户商品规格不填写默认不修改': '',
  '存在多个一样ckb sku: {sku}': 'THE CKB SKUに重複が発生しています。重複内容を削除した後、再アップロードして下さい。 sku: {sku}',
  '{sku} 该ckb sku不存在': '{sku} 該当するTHE CKB SKUのデータが見つかりません',
  客户sku过长: '入力されたお客様SKUが、最大文字数を超えています。100文字以内に変更して下さい',
  商品规格过长: '入力された商品規格が最大文字数を超えています。20字以内に変更して下さい',
  选择水洗标: '洗濯タグを選択',
  水洗标: '洗濯タグ',
  请选择水洗标: '洗濯タグを選択',
  默认水洗标: 'デフォルト',
  请填写水洗标名称: 'テンプレート名を入力して下さい ',
  商品未填写客户商品规格: '自社商品規格未入力',
  水洗标信息: '洗濯タグ情報',
  '读取文件中，即将更新数据': 'ファイルをアップロード中です。しばらくお待ち下さい',
  '商品规格/客户SKU': 'お客様SKU・お客様商品規格編集',
  请选择SKU数量: '',
  部分商品未关联采购链接: 'THE CKB商品と紐付けない商品があります',
  不通过系统下单: 'システム経由ではありません',
  '请确认，只下单已关联商品，未关联商品不会下单': '紐付けされた商品のみを発注し、紐付けられていない商品は発注しません。ご確認ください。',
  导入: '導入',
  规格自定义编辑请在option设定处: '※商品の規格は、オプション設定画面から行ってください',
  '材质为自动读取，不可编辑': '※表地は自動的に読み取られるため、編集できません',
  '商品的规格，请从选项设定画面进行编辑。未输入的情况下不显示': '※商品の規格は、オプション設定画面から編集してください。未入力の場合は、画面上に表示されませんので、ご了承ください',
  /** 清野end */
  待处理异常: '異常注文',
  有1: 'はい',
  无1: 'いいえ',
  是1: 'はい',
  否1: 'いいえ',
  到货延迟: '出荷遅延（仕入先）',
  预计发货时间: '出荷予定日（仕入先）',
  X件: 'X点',
  预计到货时间: 'THE CKB入庫予定日',
  跟单进度: '進捗状況',
  跟单反馈时间: 'お問い合わせ時間',
  '预计发货时间：<br/>无': '出荷予定日（仕入先）：<br/>未定',
  无2: '未定',
  中国国内运输物流编号: '中国国内追跡番号',
  点击查看物流状态: '配送状況を確認',
  '已到货，入库中': 'THE CKB倉庫到着済、現在入庫作業中です',

  '商品为预售商品，商家回复预计X发货': '【予約販売商品】Xメーカー出荷予定',
  '商家还在生产中，商家回复预计X发货': '【商品製造中】Xメーカー出荷予定',
  '遇到节假日（工厂放假），商家延迟到X发货': '【メーカー休暇による出荷遅延】X見込み',
  '商家预计X发货，有可能会分批次发货': '【分割発送可能性あり】Xメーカー出荷予定',
  '该商品正在生产中，不确认出货时间': '【商品製造中】出荷予定日未定',
  '已跟商家确认最新发货时间，商家未回复': '【仕入先未返信】出荷予定日未定。担当者が引き続き進捗状況を確認します',
  '无预计发货时间，正在与您确认商品详细中': '【出荷予定日未定】注文情報（商品バリエーション、送料など）要確認 ※ステータスの反映にはお時間を要する場合があります。確認済みの場合はご容赦ください',
  '商品为预售商品，商家回复预计延迟到X发货': '【予約販売商品の出荷遅延】X見込み',
  '商家还在生产中，商家回复预计延迟到X发货': '【生産の遅れによる出荷遅延】X見込み',
  '遇到节假日（工厂放假），商家回复预计延迟到X发货': '【メーカー休暇による出荷遅延】X見込み',
  '商家预计延迟到X发货，有可能会分批次发货': '【生産の遅れによる出荷遅延】X見込み。分割発送の可能性があります',
  '出货时间变更，询问商家未回复出货时间，会持续跟进': '【仕入先未返信】出荷予定日未定。担当者が引き続き進捗状況を確認します',
  '询问商家未回复出货时间，会持续跟进': '【仕入先未返信】出荷予定日未定。担当者が引き続き進捗状況を確認します',
  '出货时间变更，正在与您确认商品详细中': '【出荷予定日未定】注文情報（商品バリエーション、送料など）要確認 ※ステータスの反映にはお時間を要する場合があります。確認済みの場合はご容赦ください',
  '经再次跟卖家确认发货时间，因为产品还在生产中，发货时间延迟至X': '【生産の遅れによる出荷遅延】X見込み',
  '已经再次跟卖家确认发货时间，发货时间提前至X': '【出荷予定日より早く納品可能】X見込み',
  '已和商家核实是否按原计划发出，发货时间未变': '【出荷スケジュール通り】X見込み',
  '已和商家核实是否按原计划发出，卖家暂未回复，明日会继续跟进': '【仕入先未返信】担当者が引き続き進捗状況を確認します',
  '跟卖家确认，卖家扔未回复，卖家除预计该商品正在生产中，不确认出货时间发货时间X之外，未给到新的发货信息，若预计发货时间未发货，我司会继续确认': '【仕入先未返信】担当者が引き続き進捗状況を確認します',
  '遇到节假日（工厂放假），商家延迟到X': '【メーカー休暇による出荷遅延】X見込み',
  '商家回复产品还在生产中，预计X发货': '【生産の遅れによる出荷遅延】X見込み',
  '已跟商家确认最新发货时间，商家暂无法提供准确的发货时间': '【出荷予定日未定】担当者が引き続き進捗状況を確認します',
  '商家会分批发货，首次发货时间为X': '【出荷遅延】X見込み。分割発送の可能性があります',
  正在与您确认商品详细中: '【出荷予定日未定】注文情報（商品バリエーション、送料など）要確認 ※ステータスの反映にはお時間を要する場合があります。確認済みの場合はご容赦ください',
  '确认到最新状态为未发货，原因是之前商家虚假发货，预计最新发货时间为X': '【商品未出荷】仕入先の都合により、仮の追跡番号が発行されました。更新後：X出荷予定',
  '确认到最新状态为分批次发货，预计剩余商品最新发货时间为X': '【出荷遅延】X見込み。分割発送の可能性があります',
  '确认到最新状态为未发货，原因包裹丢失，预计最新发货时间为X': '【商品未出荷】配送中に荷物が紛失したため、仕入先は再発送の手配中です。X出荷予定',
  '确认到最新状态为未发货，原因是之前商家虚假发货，目前暂无预计发货时间，会持续跟进': '【商品未出荷】仕入先の都合により、仮の追跡番号が発行されました。出荷日未定。担当者が引き続き進捗状況を確認します',
  '确认到最新状态为未发货，原因包裹丢失，目前暂无预计发货时间，会持续跟进': '【再送日未定】配送中に荷物が紛失しました。商品再発送予定日未定。担当者が引き続き進捗状況を確認します',
  '确认到最新状态为未发货，商家出货时间变更-商家回复产品还在生产中，目前暂无预计发货时间，会持续跟进': '【商品未出荷】生産の遅れにより、出荷に遅延が生じています。 出荷予定日未定。担当者が引き続き進捗状況を確認します',
  '确认到最新状态为未发货，商家出货时间变更-商家回复产品还在生产中，预计X发货': '【商品未出荷】生産の遅れにより、出荷に遅延が生じています。X出荷予定',
  '确认到最新状态为未发货，商家未回复，目前暂无预计发货时间，会持续跟进': '【商品未出荷】仕入先未返信。出荷予定日未定。担当者が引き続き進捗状況を確認します',
  '已为您中途确认，商家生产计划有调整，预计X发货': '【商品未出荷】メーカーの生産計画が変更されました。X出荷予定',
  '已和商家核实是否按原计划发出，发货时间未变，X': '【出荷スケジュール通り】X見込み',
  '已经连续Y次（读取采购确认最近连续次数“需持续确认预计发货时间”）跟卖家确认，卖家扔未回复，卖家除预计发货时间X之外，未给到新的发货信息 若预计发货时间未发货，我司会继续确认': '【商品未出荷】何度も問い合わせましたが、仕入先からの返信はありません。担当者が引き続き進捗状況を確認します',
  '确认到最新状态为入库少件，剩余商品预计X到仓（预计到仓时间规则=预计发货时间+3天同现在）': '【商品点数不足】不足分の再発送を依頼済みです。X THE CKB倉庫へ入庫予定（※この入庫予定日は、出荷予定日に3日を加えた目安であり、確約するものではありません。）',
  '确认到最新状态为入库少件，剩余商品，商家未回复，目前暂无预计发货时间，会持续跟进': '【商品点数不足】不足分の再発送時期は未定です。担当者が引き続き進捗状況を確認します',
  '确认到最新状态为入库少件，剩余商品，商家回复暂无预计发货时间，会持续跟进': '【商品点数不足】不足分の再発送時期は未定です。担当者が引き続き進捗状況を確認します',
  '尚处在中国国内运输中，之前商家提供的物流单号有误，现已更正，预计X到仓': '【中国国内配送中】追跡番号を更新しました。X入庫予定',
  '尚处在中国国内运输中，因运输途中包裹丢失，商家已补发，预计X到仓': '【中国国内配送中】配送中に荷物が紛失したため、仕入先は再発送の手配がしました。X入庫予定',
  '尚处在中国国内运输中，确认因物流公司运力不足，物流缓慢，预计X到仓': '【中国国内配送中】現在、中国国内の物流が大変混み合っており、配送に遅れが生じています。X入庫予定',
  '尚处在中国国内运输中，确认因天气因素，物流缓慢，预计X到仓': '【中国国内配送中】悪天候の影響により、配送に遅れが生じています。X入庫予定',
  '尚处在中国国内运输中，确认因中国节日因素，物流缓慢，预计X到仓': '【中国国内配送中】祝日の影響により、配送に遅れが生じています。X入庫予定',
  '包裹已签收，正在紧急入库中': '【受取済み】現在入庫作業中です',
  '确认到最新状态为中国国内运输中，商家分批次发，分包物流已新增，预计X到仓': '【中国国内運送中】分割発送により、複数の配送伝票が発行されています。X出荷予定',
  '确认到最新状态为入库少件，剩余商品预计X到仓': '【商品点数不足】不足分の再発送を依頼済みです。Xに入庫予定',
  '跟卖家确认，卖家扔未回复，卖家除预计发货时间X之外，未给到新的发货信息，若预计发货时间未发货，我司会继续确认': '【仕入先未返信】担当者が引き続き進捗状況を確認します',
  '确认到最新状态为中国国内运输中，预计X到仓': '【中国国内配送中】X入庫予定',
  /** 市场购透明化 */
  '这就是市场购！': '市場直買付とは',
  '用户下单即采，采购人员当天直接前往源头采购并检品，最快当天发货，避免国内运输耗时和中间商层层加价，有效控制成本，为客户提供优质货品。': '「市場直買付」とは、ご注文いただいた商品を、担当者が当日に卸売市場へ直接買い付けに行くサービスです。中国国内での配送時間を大幅に短縮し、最短即日発送も可能です。また、卸売業者などを介さないので、コスト削減にもつながります。',
  视频了解: '動画を視聴',
  代采平台: '仕入先サイト',
  '以下平台支持直接采购，快挑选您心仪的商品吧！': '気になる商品をチェックしよう！',
  中国杭州第一家获淘宝官方正式授权的批发平台: '杭州市で初めて淘宝（タオバオ）の公式認可を受けた卸売プラットフォーム',
  精品男装: '杭州市に立地',
  源头直采: 'メンズ専門',
  快速发货: '品揃え豊富',
  采购商品2: '商品を見る',
  了解网站: '詳細',
  '中国广州市最大的服装批发平台。': '広州市最大の卸売プラットフォーム。衣料品専門の卸売に特化し、600万軒以上の実店舗やオンラインショップの販売者に向けて、幅広い商品を提供しています',
  精品女装: '広州市に立地',
  一手货源: 'レディース専門',
  真实档口: '衣料品専門',
  采购流程: '仕入れの流れ',
  平台采购将通过以下流程高效且便捷地完成: '商品探すから到着まで3ステップ！',
  代采优势: 'THE CKBの強み',
  '直行便提供信息透明、交易高效、服务完善的采购环境，买家可以更方便、快捷地完成采购': 'もっと簡単に、もっと透明に',
  丰富的款式: '豊富なラインナップ',
  '直接从中国各地主要批发市场采购，实时更新商品，紧跟最新潮流趋势。': '中国各地の主要卸市場から直接仕入れを行い、常に最新のトレンドに基づいた商品をリアルタイムで更新しています。',
  极高的性价比: '圧倒的なコストパフォーマンス',
  '提供比阿里巴巴价格低一半以下的商品。通过直接采购，大幅降低中间成本。': 'アリババ価格の半額以下でご提供可能。直接仕入れにより、中間コストを大幅に削減しています。',
  独特的商品: '独自性の高い商品',
  '大量未在网上销售的独家商品，提供与众不同的独特商品选择。': 'オンライン未発売の商品を多数取り扱っており、他にはないユニークなラインナップをお楽しみいただけます。',
  常见问题: 'よくあるご質問',
  '以下是一些常见问题，看能不能帮您解决问题': '',
  了解详情: '詳細を見る',
  '您的浏览器未安装商品导入插件，安装插件后，您才可以把找到的商品一键导入到CKB。': 'THE CKBの拡張機能：「KAERUツール」がインストールされていません。導入後、自社サイトへお気に入りの商品を一括登録できます',
  搜款网小技巧: 'VVIC使い方ヒント',
  用户当天下午2点前下单: '15時前に注文',
  当天线下采购并检品出库: '仕入れ部門が卸売市場から直接商品を仕入れ、最短即日出荷',
  商品送达: '商品到着',
  '根据商品上款量、收藏量、销量等数据计算': '在庫点数、販売数量、売上のデータに基づいた人気商品ランキング',
  '网商园商品涵盖男装全品类，款式多更新快，为商家和买家提供了极大的便利。': '中国杭州市に拠点を置く、ネット通販事業者向けの卸売プラットフォームです。淘宝（タオバオ）の公式提携先として、幅広い商品を提供しています',
  找商品: '商品を探す',
  找档口: '店舗を探す',
  热卖商品: '人気商品',
  商品丰富: '豊富な品揃え',
  档口排序: '並び順',
  默认排序: 'デフォルト順',
  今日新品: '新作商品',
  每周爆款: 'ランキング',
  七日爆款: '週間ランキング',
  热销榜单: '総合ランキング',
  行业精品: 'WSY厳選',
  平台销售额: '売上高い順',
  实力档口: '優良店舗',
  '根据档口的缺货率、次品率、发货到仓及时率得出的评分较高的档口': '在庫切れ、不良品、出荷遅延などが少なく、総合的に高い評価を得ている店舗です',
  一级分类: 'メインカテゴリー',
  二级分类: 'サブカテゴリー',
  排序方式: '並び順',
  价格排序: '価格安い順',
  现货专区: '在庫保証商品',
  '搜款网聚焦女装潮流，针对年轻都市丽人，提供性价比高、款式前沿的优质服装配饰。': '衣料品の専門卸売に特化しており、600万軒以上の実店舗やオンラインショップの販売者に向けて商品を提供しています',
  每日新品: '新作商品',
  七日热卖: '週間ランキング',
  商品榜: 'カテゴリー別',
  爆款分类: '種類',
  筛选: '検索',
  a: '',
  '已经API连接完成的店铺，在我司系统制作纳品计划就不需要在亚马逊店铺后台再次制作了。': 'Amazon店舗とのAPI連携が済んでいる場合、納品プランは直接THE CKBで作成し、Amazonと同期できます。',
  轻度: '軽度不良',
  中度: '中程度不良',
  重度: '重度不良',
  '10cm以上': '10cm以上',
  自动处理剩余时间: '自動返品まで残り',
  最新问题时间: '連絡日',
  自动处理时间: '自動返品時間',
  异常情形: '不良箇所',
  异常图片: '不良品写真',
  异常数量: '数量',
  '遇到需要选择良品入库或次品退货异常需要您确认时，请在72小时内确认，超过72小时系统将自动选择次品退货': '※不良品に関する対応期限は72時間です。72時間以内にご対応いただけない場合、自動的に返品となり、メーカーへの返品手続きを進めさせていただきます。',
  $通电不良$9: '通電不良',
  '$材质、面料差异$9': '生地が違い',
  $设计差异$9: 'デザインが違い',
  $尺码差异$9: 'サイズが違い',
  $logo差异$9: 'Logoが違い',
  $配件差异$9: '付属品が違い',
  $商品上有中文$9: '中国語表記',
  $颜色差异$9: '商品の色差あり',
  '※多次更换变成了同样的不良品。即使重新更换也没有改善不良品的可能性(因为是批量生产)。不良在容许范围内的情况下，建议允许入库': '※何度も交換して同じ不良品になりました。再交換しても不良品改善の可能性なし（ロット生産のため）。不良が許容範囲内の場合、入庫許可を推奨',
  '※问题商品数量多，交货期延迟的可能性大。不良在容许范围内的情况下，建议允许入库': '※問題商品数が多く、納期遅延の可能性大。不良が許容範囲内の場合、入庫許可を推奨',
  自动退货: '自動返品',
  'Paypal入金后，如果返金情况，手续费扣除不能返还': 'PayPalで支払いを返金する場合、受取手数料が返金されませんのでご了承ください',
  总发货数量: '配送依頼の合計点数',
  修改手机号: '電話番号の変更',
  注意4: '※ご注意ください',
  重新上传: '修正',
  继续上传: 'アップロード',
  重复信息: '重複内容',
  行目: '行目',
  '请确认重复信息，若确认请点击继续上传，否则请重新上传修改后的文件。': '重複したデータが存在します。内容をご確認の上、そのままアップロードするか、修正して再度アップロードしてください',
  存在重复的乐天SKU: '追加した楽天SKUは既に存在しています',
  存在重复JANcode: '追加したJANコードは既に存在しています',
  存在重复商品SKU: '追加した商品管理コードは既に存在しています',
  去原网站选品2: 'VVIC公式サイトへ',
  去原网站选品: 'WSY公式サイトへ',
  '您下单的商品和利用的仓库不在一个城市，需要中国国内转运。商品从寄出到仓库通常需要3天时间，请耐心等待。': '商品の出荷先とお客様の倉庫の所在地が異なるため、中国国内での転送が必要です。倉庫に到着するまで通常3日ほどかかりますので、少々お待ちください',
  '补货计划已创建超过48h，请取消该条补货计划，并重新创建一条': '納品プランの有効期間が48時間を超過したため、キャンセルして再作成をお願いします',
  费用说明: '費用明細',
  结算金额: '合計額（清算後)',
  此费用不包含国际运费: '※国際送料は含まれません',
  'THECKB系统默认入金领收书和领收书上的抬头为您的账户名称，前述文件仅证明与该账户相关的入金和订单情况。如您有正当理由需要将抬头修改为个人名称或法人名称，请您自行修改。修改之前，请您仔细阅读并确认以下内容：': 'THE CKBシステムの入金確認書と領収書の宛名は、通常お客様のアカウント名となります。これらは、お客様の入金とご注文の状況を確認するための書類です。宛名を個人名または会社名に変更したい場合は、お客様ご自身で変更手続きを行ってください。変更に際しては、以下の点にご注意ください。',
  '本公司和THE CKB因信息保护原因无权对您提供的个人名称或法人名称进行审查。': 'THE CKBは、お客様のプライバシー保護のため、個人名または会社名の確認を行うことはできません。',
  '您承诺您提供的抬头内容（个人名称或法人名称）准确无误，并符合相关法律法规的规定。': 'お客様は、入力された宛名（個人名または会社名）が正確であり、法律や規則に違反していないことを保証するものとします。',
  '您承诺更改抬头后的领收书和入金领收书不会用于任何虚假计账、逃税或其他违法行为。': 'お客様は、変更後の領収書や入金確認書を不正な会計処理、脱税、その他の違法行為に使用しないことを約束するものとします。',
  '因由您自行更改抬头的入金领收书和领收书导致的任何法律、税务或其他相关问题，均由您自行承担全部贵任。本公司对由您自行更改抬头的入金领收书和领收书引发的任何直接或间接损失概不负责。': '宛名変更後の領収書や入金確認書に関して発生する、法律、税務、その他すべての問題について、お客様が全責任を負うものとします。当社は、宛名変更後の領収書や入金確認書に起因するいかなる直接的または間接的な損害についても、一切責任を負いません。',
  '因由您自行更改抬头的入金领收书和领收书导致本公司受到任何形式的税务检查、法律追诉、罚款或其他损失，您将承担所有赔偿责任（包括直接损失和预期利益损失）。': '宛名変更後の領収書や入金確認書により、当社が税務調査、訴訟、罰金などの損害を被った場合、お客様はすべての損害（直接的な損失および逸失利益を含む）を賠償する責任を負うものとします。',
  '请在继续操作前，勾选以下选项以确认您已阅读并同意上述免责声明': '操作を続ける前に、以下の項目にチェックを入れ、上記の免責事項を読み、同意したことを確認してください。',
  '我已阅读并同意上述免责声明的内容，并确认由我自行承担更改领收书抬头所引发的所有法律和财务责任。': '上記の利用規約に同意します。',
  '设置完后，每次下载都使用该抬头，不再询问': 'デフォルトの宛名を設定すると、次回からは入力を省略できます',
  领受书抬头设定: '領収書の宛名設定',
  同意免责声明并保存: '利用規約に同意する',
  免责声明: '利用規約',
  保存前请先阅读免责声明: '※利用規約を確認してから保存してください',
  不询问: 'デフォルトの宛名を設定',
  请输入内容: '領収書の宛名を入力してください',
  领授书抬头: '領収書の宛名設定',
  请输入领授书抬头: '領収書の宛名を入力してください',
  同意免责声明: '同意免责声明',
  免责声明标题: '利用規約と免責事項',
  '口每次下载都使用该抬头，下次不再询问。': '該当の宛名をデフォルトとして設定（次回から入力を省略）します',
  稍后查看: '閉じる',
  立即查看: '今すぐ確認',
  '如有sku被取消，会实时通知在这里': '商品の買付がキャンセルされた場合、こちらに表示されます',
  领受书抬头设定每次询问: '毎回編集を有効にする',
  通知: '【※ご注意ください】',
  //   韩国仓
  品牌所在地: 'ブランド所在地',
  '提示：审核通过后，默认开通韩元钱包': '※審査が完了した時点で、韓国ウォン（KRW）の親口座が自動的に有効になります',
  韩元: '韓国ウォン',
  '(韩元)': '(韓国ウォン)',
  全部国家: 'すべて',
  商品所属国家: '仕入れ元国',
  商品所在仓: '商品所在地',
  '预计到账KRW：X韩元': '見込入金額KRW: X韓国ウォン',
  中国商品: '中国商品',
  韩国商品: '韓国商品',
  品牌国家: 'ブランド所在地',
  品牌国家1: '国・地域',
  中国商品附加项: '中国商品オプション',
  韩国商品附加项: '韓国商品オプション',
  请选择要批量设置的商品: '編集したい商品を選択してください',
  采购国家: '仕入先国',
  发货国家: '発送元の国',
  发货仓库: '出荷倉庫',
  中国: '中国',
  韩国: '韓国',
  异常提示: 'エラーが発生しました',
  不能添加不同国家的货品: '異なる国からの商品を同時に注文することはできません。各国の商品は別々のカートからご注文ください',
  请选择发货仓库: '発送元の倉庫を選択してください',
  货品仓库: '倉庫',
  人民币钱包: '親アカウント管理口座（共通残高）（CNY）',
  韩元钱包: '親アカウント管理口座（共通残高）（KRW）',
  人民币账单: '支払依頼書（CNY）',
  韩元账单: '支払依頼書（KRW）',
  多个仓库的商品无法创建一个国际发货单: 'エラーが発生しました。異なる国からの商品を同時に発送することはできません',
  中国仓: '中国倉庫',
  韩国仓: '韩国倉庫',
  '您本月的库存保管费和包裹滞留费账单已生成（合计XX人民币、YY韩元），请前往“资金管理”进行查看': '今月分の保管料明細書が発行されました（合計XX元（CNY）、YYウォン（KRW））。詳細は「資金管理」画面でご確認下さい',
  '您本月的库存保管费和包裹滞留费账单已生成（合计XX人民币），请前往“资金管理”进行查看': '今月分の保管料明細書が発行されました（合計XX元（CNY））。詳細は「資金管理」画面でご確認下さい',
  '您本月的库存保管费和包裹滞留费账单已生成（合计XX韩元），请前往“资金管理”进行查看': '今月分の保管料明細書が発行されました（合計XXウォン（KRW））。詳細は「資金管理」画面でご確認下さい',
  '点击【确定】按钮，系统将自动从余额扣除当前账单<br />应付总额XX韩元，确定支付吗': '「確定」ボタンをクリックすると、システム口座からXX韓国ウォンを引き落としいたしますよろしいでしょうか',
  国家筛选: '所在地',
  不同国家的商品无法组合: '異なる国からの商品を組み合わせることができません',
  出口国家: '輸入国',
  发货地: '発送元',
  订单发货国家: '発送元',
  '请注意：关联的商品来自多个国家，会拆成多个订单': '異なる国からの商品を発注する場合、注文は分割して発送されることがあります',
  包裹滞留费账单已生成: '出荷保留荷物保管料請求のお知らせ',
  查看资金流水: '詳細を見る',
  辅料不足预警: '資材在庫不足のお知らせ',
  '您有X个辅料库存不足，请及时补货！': '以下のX件の資材のフリー在庫数が設定された閾値以下になりました。',
  稍后处理: '閉じる',
  设置辅料不足提醒: '資材在庫不足アラートの有効化',
  辅料不足提醒设置: '資材在庫不足アラートの有効化',
  '建议设置在20%~50%之间': '推奨値：20%～50%',
  当单个辅料的良品数低于总数的: '良品数が在庫数（良品数＋処理中＋利用予定）の',
  '时,进行提醒': '未満の場合、お知らせで通知します',
  您获得X笔返金: 'お預かり金が返金されました',
  金额1: '金額',
  请选择相同发货国家的订单: 'エラーが発生しました 異なる国からの商品を含む注文は、一括でお支払いできません。お手数ですが、分けてお支払いください',
  请先选择子商品: '商品をまず追加してください',
  转账金额不能为0KRW: '振替金額は０韓国ウォン以上の金額を入力してください',
  '不同国家商品不可通过一个表格下单，当前请上传中国商品': '現在のページは中国商品注文カートです。異なる国から商品を購入する場合は、各国のカートからエクセルファイルをアップロードしてください。',
  '不同国家商品不可通过一个表格下单，当前请上传韩国商品': '現在のページは韓国商品注文カートです。異なる国から商品を購入する場合は、各国のカートからエクセルファイルをアップロードしてください。',
  '韩元/个/天': '韓国ウォン/点/日',
  '韩元/m³/天': '韓国ウォン/m³/日',
  商品国家: '仕入れ元国',
  中国仓商品物流配置: '中国倉庫商品',
  韩国仓商品物流配置: '韩国倉庫商品',
  日本仓商品物流配置: '日本倉庫商品',
  中国发货附加项: '中国倉庫発送オプション',
  韩国发货附加项: '韩国倉庫発送オプション',
  中国仓库商品: '中国倉庫商品',
  韩国仓库商品: '韩国倉庫商品',
  中国商品购物车: 'カート（中国商品）',
  韩国商品购物车: 'カート（韓国商品）',
  主商品国家: 'メイン商品仕入国',
  售后补偿标准: 'アフターサービス基準',
  导出商品标签PDF: '商品ラベルをダウンロード',
  '无法导出，至少有一个商品标签': 'エラーが発生しました，商品ラベルが存在しません',
  PDF导出成功: 'PDFファィルをダウンロードしました',
  国際配送商品のラベルデータ: '国際配送商品のラベルデータ',
  '合计：': '合計',
  '超过60天用户未处理，系统已自动处理': '対応期限の60日間が過ぎたため、自動的にキャンセルになりました',
  '采购中发起异常，请在60个自然日处理，超时系统将自动处理为取消。': '仕入れ処理中にエラーが発生しました。60日以内にご対応ください。ご対応がない場合は、システムにより自動的にキャンセルとなりますのでご注意ください',
  系统异常: 'エラーあり カスタマーサービスへご連絡下さい',
  重新加购: 'カートに追加',
  不支持发送当前国家: 'この国への発送はサポートされていません。',
  导入常用地址: 'よく使う住所をインポート',
  新增地址: '新しい住所を追加',
  请选择要导入的地址: '住所を選択してください',
  目的地国家: 'お届け先国',
  '您有X个sku被取消，请及时查看': '以下の理由により、X件の商品の買付がキャンセルされました',
  原商品尺码: '現在のサイズ',
  设置成功: '設定が成功しました。',
  '设置成功，下次该辅料不再提醒': '設定が成功しました。次回は通知されません。',
  是否提醒: '通知アラート',
  商品链接: '商品URL',
  购买链接: '商品URL',
  工单历史1: 'お問い合わせ履歴',
  暂无工单历史记录: 'お問い合わせ履歴はありません',
  'CKB对于高级会员一对一定制化选品提案。将喜欢的商品加入心愿清单，CKB会为您快速创建商品。': 'ビジネス会員様以上のお客様向けに、1対1の商品提案を提供しています。お好みの商品画像を「お気に入り」に追加いただくと、CKBが該当商品の購入リンクを作成します。',
  我的心愿单: '選定商品リスト',
  当前可购买: '仕入れリンク作成完了',
  立即购买: '今すぐ購入',
  商品编码: '商品コード',
  加入心愿单: '選定商品リストに追加',
  所有选品图集: 'すべて',
  '加入心愿单成功！': '選定商品リストに追加しました！',
  一对一专属选品提案: '1対1専属商品提案',
  成功取消添加心愿单: 'キャンセル済',
  取消加入心愿单: '選定商品リストから削除',
  心愿清单: '選定商品リスト',
  '你的心愿单商品可以购买啦！': '選定商品リストにある商品の仕入れリンクが作成されました！',
  '登录后可查看内容，请先登录！': 'ログイン後に提案をご覧ください',
  查看提案: '提案を見る',
  '本次推荐包含：X件商品': '本次推荐包含：X件商品',
  采购链接制作中: '仕入れリンク作成中',
  可购买: '仕入れリンク作成完了',
  共X件商品: '合計X点',
  详细地址不能超过40个字符: '詳細住所は40文字以内で入力してください',
  关税报销: '税金立替',
  '出库(含国际运费)': '出荷作業（国際送料含め）',
  '剩余可新增子店铺数量：X个': '作成可能な店舗数：残りX点',
  '您的会员仓位可创建的店铺个数上限为{x}个': '現在の会員プランでは、作成可能な店舗数は{x}個までです。',
  '您的会员仓位可创建的店铺个数上限为{x}个，如需新增，请升级会员等级。': '現在の会員プランでは、作成可能な店舗数は{x}個までです。\n新規店舗を追加するには、会員プランのアップグレードが必要です',
  '您的会员仓位可创建的店铺个数上限为{x}个(2b+2c)': '現在の会員プランでは、作成可能な店舗数（B2B・D2C合計）は{x}件までです。',
  '正在创建补货计划中，请耐心等待...': 'FBA納品を作成中です。しばらくお待ちください',
  '如果取消当发货单，将会取消以下发货单，是否确定': '現在の配送注文をキャンセルすると、次の配送注文もキャンセルされますか?',
  '如果取消当前补货计划，将会取消以下补货计划，是否确定': '現在の補充計画をキャンセルすると、次の補充計画もキャンセルされます。よろしいですか?',
  '待支付的订单才能重新支付，请确认后重新选择': '再度支払いをしないでください。',
  商品材质: '商品素材',
  全包价成本计算器: '着地コスト計算',
  全包价单价: 'オールイン単価（税込）',
  '该商品可计算全包价，价格仅供参考，实际价格以下单为准': '※こちらの着地コスト価格は参考価格です。実際の価格はご注文時に確定いたしますので、あらかじめご了承ください',
  冬款: '冬向け',
  夏款: '夏向け',
  春秋款: '春秋向け',
  一价全包: '着地コスト専用',
  一价全包商品附加项套餐: '着地コストオプションセット',
  服装以外: 'アパレル以外',
  春节前纳品oem商品截单日: '＜旧正月前納品を希望するOEM注文のお勧め発注期間＞',
  服装杂货: 'アパレル・雑貨',
  '★12/25（水）': '１２月２５日　(水）前',
  '辅料（纸盒，特殊纸袋，opp袋）': '資材（opp袋、自社箱、包装など）',
  '★1/5（日）': '１月５日　(日）前',
  '★1/15（水）': '１月１５日　(水）前',
  '辅料（布标，纸标，说明书）': '資材（布タグ、紙タグ、説明書、付属品など）',
  'oem订单请尽快下单！': '',
  '※oem工厂春节休息时间：约1月初~2月中旬': '',
  '※截单日之后也可以下单，但是工厂发货基本会延迟到2月下旬及以后~2月中旬': '※お勧め発注期間を過ぎてもOEM発注は可能ですが、発送は２月下旬以降に遅延する可能性があります。',
  '※每个工厂的情况不同，截单日之前的订单也会有春节后发货的可能性': '※工場によりますので、お勧め発注期間前のOEM注文でも春節後に発送される場合があります。',
  成品采购春节停止下单时间: '＜旧正月 既製品買付休業の予告＞',
  '１月２２日（水）~２月４日（火）': '１月２２日（水）~２月４日（火）まで',
  建议春节前尽快囤货: '※ショップによりますので、休業期間前のご注文でも春節後に発送される場合があります。',
  '※由于部分店铺已经开始休业，1月22日之前下单的商品也有节前发不出货的可能，商品状态会停滞在：***，请谅解！有需要取消的可以联系客服确认': '※買付休業期間内の注文も受付可能ですが、２月４日以降順次対応させていただきます。',
  '※１月２２日（水）~２月４日（火）的订单我们也受理，统一在2月4日之后采购': '※ショップ側の商品在庫切れを避けるために、1月中旬前に2ヶ月分の商品在庫を事前に確保するのをお勧めします。 ',
  春节前希望发货的发货委托制作的推荐期间: '＜旧正月前 発送依頼締切の予告＞',
  船运节前出货发货依赖截单时间: '船便',
  空运节前出货发货依赖截单时间: '航空便',
  '1月20日（月）18时': '１月２０日（月）18時 まで',
  '1月24日（金）12时': '１月２４日（金）12時 まで',
  请提前安排发货: '※発送依頼締切期限前に発送依頼を行ってください。',
  市场购春节停止拿货时间: '＜旧正月 市場直買付休業の予告＞',
  '1月18日（土）~2月4日（火）': '１月１８日（土）~２月４日（火）まで',
  市场购商品请在1月27日之前囤货: '',
  '※由于部分市场已经开始休业，1月18日之前下单的市场购商品也有拿不到货的可能，商品状态会停滞在：***，请谅解！有需要取消的可以联系客服确认': '※休暇時間はショップによりますので、休業期間前の注文でも買付できない場合があります。',
  '※1月18日（金）~2月4日（火）休的市场购订单，统一在2月4日之后拿货': '※買付休業期間内の注文も受付可能ですが、２月４日以降順次対応させていただきます。',
  '（注文，寻源）工厂停止生产': '＜旧正月　OEM発注・見積依頼休業のお知らせ＞',
  '1月16日（水）~2月4日（火）休': '１月１６日（水）~２月４日（火）まで',
  '由于OEM商家基本已经开始休业，1月16日（水）~2月4日（火）休的oem寻源和订单，基本会在2月4日之后出货': '',
  '承接订单，提前咨询，提前沟通，锁定库存，准备材料': '※休業期間中でもOEM発注や見積依頼を受け付けております。',
  '商家提前排期，先下单先出货': '旧正月明けに順次対応させていただきますので、発注希望の商品はは早めにご提出いただくことをお勧めいたします。',
  '成品订单 停止采购！': '＜ 旧正月 既製品買付休業のお知らせ＞',
  '※由于商家已经开始休业，１月２２日（水）~２月４日（火）的订单，统一在2月4日之后采购。': '※休業期間中でも注文を受け付けております。',
  '※由于商家恢复营业的时间不同，2月4日营业再开后，部分商品也有可能在2月中旬才能发货，请谅解': '旧正月明けに順次対応させていただきますので、発注希望の商品はは早めにご提出いただくことをお勧めいたします。',
  '不能采购，但是承接订单，提前咨询，提前沟通，锁定库存': '',
  直行便仓库休息时间: '＜旧正月　倉庫休業のお知らせ＞',
  'D2C（仓库发货停止）': 'Ｄ２Ｃ（倉庫出荷停止）',
  '1月28日（火）~2月2日（日）': '1月28日（火）~2月2日（日）まで',
  'B2B（仓库发货停止）': 'Ｂ２Ｂ（倉庫出荷停止）',
  '1月27日（水）~2月4日（火）': '1月27日（水）~2月4日（火）まで',
  '发货依赖正常受理，节后顺次发货': '※休業期間内でも発送依頼作成が可能ですが、営業再開降順次対応させていただきます。',
  '订单正常受理，采购和发货在2月中旬顺时恢复': '',
  套餐类型: 'オプションセット種類',
  预处理分类: '梱包カテゴリー',
  预处理方: '梱包の担当者',
  未设置: '未設定',
  无需更改: '変更なし',
  由亚马逊处理: 'Amazon',
  由卖家处理: '出品者',
  贴标方: 'ラベルの担当者',
  失效2: '無効',
  有效: '有効',
  '正在校验Amazon商品信息中，请勿退出': 'Amazonの商品情報を読み込み中です。ページを閉じないでください',
  Amazon校验结果: 'Amazon検証結果',
  失败: '失敗',
  成功: '成功',
  预处理分类未设置: '梱包カテゴリー未設定',
  '预处理方/贴标方与amazon后台不一致': '梱包の担当者またはラベルの担当者がAmazonセラーセントラルの設定と一致しません',
  该amazon商品失效: '該当Amazon商品は無効です',
  建议处理方案: '推奨アクション',
  '请先去amazon后台补充信息，并获取最新商品信息': 'Amazonセラーセントラルで情報を補足し、最新の商品情報を取得してください。',
  '请先在amazon后台确认信息是否正确，并获取最新商品信息': 'Amazonセラーセントラルで情報が正しいか確認し、最新の商品情報を取得してください',
  '该amazon商品失效，请删除后重试': 'このAmazon商品は無効です。削除して再試行してください',
  '创建补货计划失败，请检查更新后重新创建': '納品プランの作成に失敗しました。内容を確認し、再度作成してください。',
  '预处理分类/预处理方/贴标方字段缺失或错误，需在amazon后台补齐信息。': '梱包カテゴリー、梱包の担当者、またはラベルの担当者の情報に不備があります。Amazonセラーセントラルで情報を確認してください。',
  删除商品: '商品を削除',
  '商品校验通过，FBA补货计划创建中，请勿退出': 'データーの読み込みが完了しました。FBA納品プランを作成中です。ページを閉じないでください',
  '可能需要几分钟，请耐心等待！': '処理には数分かかる場合がありますので、しばらくお待ちください。',
  补货计划创建成功: '納品プランが正常に作成されました',
  去查看: '詳細',
  '商品失效，请先在添加商品中删除该商品。': 'この商品は無効です。削除し改めてお試しください。',
  '根据Amazon的规定，建发货时需要建立好预处理分类、预处理方和贴标方，请及时去Amazon后台更新信息，并重新更新商品': 'Amazonの出品規制に基づき、納品プランを作成する際には、梱包カテゴリー、梱包の担当者、およびラベルの担当者を設定する必要があります。Amazonセラーセントラルで最新情報を取得し、商品の情報を更新してください。',
  创建发货单: '納品プランを作成',
  '发生错误。以下情报需要修改或者补充': '「梱包カテゴリー」や「担当者」の情報に不備があるか、特定の商品が無効です。情報を確認し、必要に応じて削除後に再試行してください。',
  重新创建国际发货单: '納品プランを再作成',
  '根据Amazon的最新规定，建发货时需要维护好每个商品上的预处理分类、预处理方和贴标方，请及时去amazon后台进行维护。': 'Amazonの出品規制に基づき、納品プランを作成する際には、梱包カテゴリー、梱包の担当者、およびラベルの担当者を設定する必要があります。設定内容はAmazonセラーセントラルで確認し、最新情報を反映してください。',
  公告: 'お知らせ',
  /** 新会员 */
  '限时首月免费体验标准仓会员！': '【期間限定！】初月無料でスタンダード会員（通常価格：月額9,800円）をご体験いただけます！',
  '感谢您注册会员！让我们进入下一步吧': `会員登録ありがとうございます！
次のステップに進みましょう`,
  '会员注册已成功完成。本页面将为您提供CKB的下一步指引以及实用信息，请务必充分利用这些资源。': '会員登録が無事に完了しました。このページでは、THE CKB（直行便）の次のステップや便利な情報を提供します。ぜひご活用ください。',
  'CKB（直行便）与下单系统': 'THE CKB（直行便）と注文システムについて',
  '感谢您加入ckb直行便，我们是一个会员制电商采购平台，帮助您在日本采购中国主要电商平台的低价格，高品质商品。': 'THE CKB（直行便）へのご登録ありがとうございます。弊社は会員制のEC仕入れプラットフォームであり、中国主要ECサイトの商品を日本から低価格で高品質に仕入れられます。',
  CKB主要服务: 'THE CKB（直行便）の主なサービス',
  '我们提供以下主要服务：商品种类繁多的ec网站采购，价格优势巨大的批发市场采购，助力成立您自主品牌的oem，帮助差异化的品牌代理,以及日本标准质检服务，和提升品牌影响力的追加option等等。': 'THE CKB（直行便）では、豊富な商品を扱うEC仕入れ、卸売市場での低価格仕入れ、OEM支援、ブランド代理販売、日本基準の検品サービス、さらにはブランド価値を高めるオプションなど、多彩なサービスをご提供しています。',
  CKB的自主研发采购系统: 'THE CKB（直行便）独自開発の調達システム',
  '可以不用登录中国网站，在ckb，享受和日本购物网站同等的体验，一键日语搜索，加购，下单！': '中国サイトにアカウントを持たなくても、THE CKB（直行便）上で日本のショッピングサイトと同じように、簡単に日本語で商品検索、カート追加、注文が可能です！',
  'CKB（直行便）で利用可能なサービス': 'THE CKB（直行便）で利用可能なサービス',
  '您在CKB（直行便）的使用权益': `現在、フリー会員として
以下の特典をご利用いただけます`,
  免费会员: 'フリープラン',
  已失去会員: 'フリープラン',
  已失去会员: 'フリープラン',
  未入会: 'フリープラン',
  '参考购买金额：每月不超过2万日元': '推奨仕入れ金額：月2万円以下',
  免费: '無料',
  'EC 网站商品采购': 'ECサイト＆問屋商品仕入れ',
  '2次/月': '毎月2回まで',
  '2次/月2': '月2回',
  类似图片搜索: '類似画像検索',
  类似图片搜索2: '類似画像検索使い放題',
  '3次/天': '毎日3回まで',
  日本标准质检: '日本基準検品',
  品牌代理销售权: 'ブランド代理販売',
  '与日本 EC 网站系统联动和代发货服务': '日本ECサイトとのシステム連携&ドロップシッピング',
  自定义选项和材料使用: 'カスタムオプション＆資材利用',
  '简单 OEM 支持': '',
  系统聊天支持: 'システムチャット',
  '如果需要体验更多特典，可以在这里升舱为': 'さらに多くの特典を体験するには',
  推荐: 'おすすめ！',
  '参考购买金额：30万～100万日元/月': '推奨仕入れ金額：月100万円以下',
  首月0元: '初月無料！',
  '原价9800元/月': '通常：月額9800円',
  '系统聊天和 LINE 专属支持': 'システムチャットとLINE専属サポート',
  试用1个月免费: '1ヶ月間無料で試す',
  '想要扩大商业规模的企业客户，': 'ビジネス規模を拡大したい方には、 ',
  企业版会员: '法人さま向け会員プラン',
  建议您升级为: 'をおすすめします',
  查看企业版会员权益: '法人様向けプランを見る',
  '接下来的步骤（使用流程）': '次のステップ（ご利用の流れ）',
  '以下是接下来您可以做的事情，按照步骤来做做看吧。': '以下は次に行うべき手順です。ぜひステップに従って進めてみてください。',
  修改店铺: '店舗の作成',
  'ckb采购需要绑定店铺，我们已为您自动创建默认店铺，您可点击上方“店铺“入口，修改店铺信息或新建店铺。': 'CKBでの仕入れには、独立した子アカウントおよび店舗の作成が必要です。簡単な情報入力で店舗を作成しましょう。',
  去修改: '店舗を作成する',
  充值系统: 'システムへのチャージ',
  'ckb是预先充值模式，因此需要预充到系统后，选择余额付款。※根据选择的充值方式，到账可能有1～3个工作日不等。': `CKBは事前チャージ方式を採用しています。システムにチャージしてから残高でお支払いください。
※チャージ方法によって、反映に1～3営業日かかる場合があります。`,
  去选择商品并加购充值: '商品を選択してカートに追加',
  '可以通过日语直接检索，或者上传商品图片，在ckb网站一键搜索中国采购网站全网。您想要的商品。': '日本語で商品を検索したり、商品画像をアップロードして、中国の全ECサイトから簡単に商品を見つけられます。',
  马上去选品加购: '商品を選んでカートに追加する',
  '提出订单，付款后等待发货': '支払い後に発送を待つ',
  '需要货物达到ckb仓库后，手动添加地址做发货手续；若采用d2c功能，可以通过api绑定您的日本店铺，实现自动下单发货到终端客户。': '※商品がCKB倉庫に到着後、発送先を手動で登録して発送手続きを行う必要があります。ただし、ドロップシッピング機能（スタンダード会員以上限定）を利用する場合、日本のショップとAPI連携し、エンドユーザーへの自動発送が可能です。',
  访问CKB支持: 'THE CKB（直行便）サポートへアクセス',
  '有疑问吗？': 'ご不明な点はありませんか？',
  '以下是我们提供的常见问题页面和教程中心，确保您的问题能迅速得到解答。': 'よくある質問ページとチュートリアルセンターをご利用いただければ、疑問点を迅速に解決できます。',
  跳转帮助中心: 'ヘルプセンターへ移動',
  试试聊天支持: 'チャットサポートを試してみてください',
  '我们提供系统在线聊天功能，帮助您获得即时支持。': 'システム内のオンラインチャット機能を利用して、即時サポートを受けることができます。',
  在线咨询: 'お問い合わせ',
  '暂不开通，去体验免费2次采购': '今はアップグレードせずに、商品仕入れへ進む',
  首月0元成为9800会员: '初月０円でスタンダード会員を体験',
  会员体系变动提示: '会員プラン調整のご案内',
  '尊敬的用户，THE CKB进行了会员体系变更，即日起，非会员每月享有{x}次采购机会。但我们还是真诚地建议您加入会员，享受更多优质的服务和权益，标准仓会员首月开通仅需0円（原价 9800円/月）。': '会員システムを調整しました。本日より、未入会の方は毎月{x}回まで仕入れが可能になります。さらに、初月無料でスタンダード会員（通常価格9,800円/月）に入会できるキャンペーンを実施中です。ぜひご検討ください！',
  '尊敬的用户，我们针对会员体系进行了一系列优化。从今天起1980円经济仓不再对外开通。鉴于您是THE CKB的资深用户，您仍然可以进行使用和续费。': '会員システムを調整しました。本日より、月額1,980円のエコノミープランの新規申し込みを終了します。既存のユーザー様は引き続きご利用やプラン延長が可能です。',
  '最后，若您的每月采购额在30万-100万日元之间，我们推荐您升级标准仓，权益更丰富，首月只需0円（原价9800円/月）！': '※月間仕入額が30万～100万円の方には、スタンダード会員へのアップグレードがおすすめです。特典が充実しており、初月は無料（通常価格9,800円/月）でご利用いただけます！',
  不再提示此消息: '次回から表示しない',
  不再提示: '次回から表示しない',
  暂不开通: '閉じる',
  立即0元升舱: 'スタンダードプランをお申し込み',
  '已为您自动创建店铺，如有需要，您可自行修改店铺信息': '店舗が自動的に作成されました。必要に応じて店舗情報を変更できます',
  下单成功2: '注文完了',
  '请及时留意订单发货情况。商品到达仓库后，您可创建国际发货单，将商品发送至您的地址。': '商品が弊社倉庫に到着後、国際配送伝票を作成し、指定の住所に発送することができます',
  CKB执行: 'THE CKB',
  采购: '仕入れ',
  CKB仓库: 'THE CKB倉庫',
  检品上架: '入荷・検品',
  用户执行: 'お客様',
  创建国际发货单: '国際配送伝票の作成',
  运输: '出荷',
  收货: '納品',
  查看订单: '注文履歴を見る',
  '如何创建国际发货单？': '国際配送の依頼方法について',
  '很抱歉，本月采购次数已用完': '申し訳ございませんが、今月の仕入れ回数を使い切りました',
  '非会员每月仅限2次采购机会，升级会员后不限次数。': 'フリー会員様は月2回まで仕入れが可能です。会員アップグレード後は無制限でご利用いただけます。',
  '非会员首次开通9800标准仓会员，首月仅需0元。': '※初月無料でスタンダード会員（通常価格9,800円/月）に入会できるキャンペーン実施中！ぜひご検討ください！',
  免费寻源: '無料見積もり依頼',
  报价请求: '报价请求',
  报价管理: '报价管理',
  业务模式选择: '業務モードの選択',
  店铺设置: '店舗設定',
  '请选择您首先要尝试的业务模式，后续可切换': '試してみたい業務モードをお選びください。後から変更可能です',
  'b2b 我们支持持有库存并将其运送到您的家庭、内部仓库或国内电子商务仓库的操作。': 'B2B：商品をCKB社内倉庫、ご自宅、または日本国内の倉庫に配送・保管できます',
  'd2c 支持从一点到直接交付给最终用户的操作': 'D2C：1点から直接エンドユーザーに届けることが可能です',
  'THE CKB（直行便）标准会员计划.随心采购': 'THE CKB（直行便）で選べる個人会員プランと特典',
  '为个人到法人寻找符合需求的采购服务的最佳选择。从免费计划到免手续费的标准会员计划，提供丰富的福利以支持业务发展。': '個人から法人まで、ニーズに合った仕入れサービスをお探しの方に最適。無料プランから手数料無料のスタンダード会員プランまで、ビジネスを支える豊富な特典をご提供。',
  当前等级: 'ご利用中のプラン',
  个人客户: '個人プラン',
  企业客户: '法人プラン',
  '个人客户（主要是个体工商户）的费率计划': '個人のお客さま（主に個人事業主さま）向け料金プラン',
  '免费计划和付费标准计划中提供的服务和福利的详细比较，': '無料プランと有料のスタンダードプランで利用できるサービスと特典を詳しく比較し、',
  '找到支持您业务增长的最佳计划。': 'ビジネスの成長をサポートする最適なプランを見つけましょう。',
  基本功能: '基本機能',
  去升舱: 'アップグレードする',
  免费与标准会员的比较: 'サービス・特典比較：\nフリー会員 vs スタンダード会員',
  开始采购: '商品仕入れへ',
  采购业务: '仕入れ業務（商品発注＆検品）',
  '中国 EC 网站（淘宝、1688、TMALL 等）商品采购': 'ECサイト＆問屋商品仕入れ',
  批发市场商品采购: '',
  日本标准质检服务: '日本基準検品',
  客服支持: 'カスタマーサポート',
  品牌化扶持: 'ブランド化サポート',
  'OEM 和 ODM': 'OEM＆ODM',
  中国和韩国品牌代理: '中国・韓国ブランド代理販売',
  自定义附加项和辅料使用: 'カスタムオプション＆資材利用',
  'KAERU MEDIA（进口知识、新产品信息等）': 'KAERU MEDIA（輸入ノウハオ、新製品情報など）',
  'Line 特别推荐商品（线下商品和优质商品）': 'Line特別商品おすすめ（オフライン限定商品・優良商品）',
  '效率化扶持（API 联动和便捷工具）': '作業効率化（API連携＆便利ツール）',
  'D2C代发货（与 base/shopify/stores 等 API 联动和自动订单处理）': 'ドロップシッピング\n（base/shopify/stores等のAPI連携＆自動発注）',
  'KAERU 工具（日语搜索和类似画像搜索）': 'KAERUツール（日本語検索・類似画像検索）',
  成本计算工具: '原価計算ツール',
  '现有产品简单 OEM 和辅料 OEM': '資材OEM',
  具备销售许可: '販売許可',
  无限制: '無制限',
  商业和企业客户的费率计划: 'ビジネス・法人のお客さま向け料金プラン',
  '商业计划和付费的第一计划提供的服务没有太大区别，但根据购买金额的不同，费用差异很大。 查看这两个计划的基本费用和成本，以找到更有效地支持您的业务的最佳计划。': 'ビジネスプランと有料のファーストプランは、提供するサービスはそれほど差がないが、仕入れ量によって費用が大きく変わります。\n 二つのプランの基本手数料と費用をチェックして、ビジネスをより効果的に支援する最適なプランを見つけましょう。',
  '参考购买金额：每月100万~300万日元': '推奨仕入れ金額：月100~300万円',
  '参考购买金额：每月300万日元以上': '推奨仕入れ金額：月300万円~',
  包含标准计划的所有服务: 'スタンダードプランのサービス全て',
  '完全支持OEM/ODM': 'OEM・ODM完全対応',
  免费样品提供: '無料サンプル提供',
  '1对1特别商品提案': '１対１の特別商品提案',
  系统聊天及专属Chatwork群组: 'システムチャット＆専属Chatworkグループ',
  品牌独占销售权及优惠价格采购: 'ブランド独占販売権＆割引価格仕入れ',
  '4次/月': '月4回の無料見積り',
  '400万元/年': '年400万円以内',
  '1次/月': '月1回',
  '6次/月': '月6回の無料見積り',
  '1000万元/年': '年1000万円以内',
  首月免费: '初月無料',
  基本手续费: '基本手数料',
  '采购手续费（市場购商品）': '仕入れ手数料（問屋商品）',
  '次品自动再次购买（市場购商品）': '不良品自動再発注（問屋商品）',
  OEM采样费用: 'OEMサンプル製作手数料',
  検品附加项: '検品オプション',
  '去布标・去水洗标・去吊牌': '布タグ・洗濯タグ・吊り札タグ外し',
  制作并缝制水洗标: '専用洗濯タグ作成＋付替',
  普通发货袋: '通常発送袋差し替え',
  成为标准会员的三大优势: 'スタンダード会員になる3つのメリット',
  '作为标准会员，您将享受加速业务发展的三大主要优势：节省成本、差异化竞争和独特的产品开发。': 'スタンダード会員なら、コスト削減、競合との差別化、独自商品展開など、ビジネスを加速させる3つの主なメリットが得られます。',
  免手续费和采购次数无限制: '仕入れ手数料の優遇＆コスト削減',
  '可无限次采购 EC 网站商品，免手续费，降低采购成本，最大化利润率。': 'スタンダード会員なら、ECサイト商品をより低い手数料で仕入れ可能。仕入れコストを抑え、利益率を最大化できます。',
  独特产品开发和竞争差异化: '独自商品展開＆競合との差別化',
  '批发商专属商品和品牌代理销售，加上简单 OEM 支持，帮助您与竞争对手区别开来，强化自有品牌。': '問屋限定商品やブランド代理販売対応で、他社との差別化が可能。自社ブランドの強化に役立ちます。',
  过代发货实现业务自动化: 'ドロップシッピングで業務自動化',
  '与日本电商网站（如 Amazon、BASE、Shopify 等）系统联动，无需库存管理，实现业务自动化。通过自动同步商品信息和自动订单处理，大大节省时间和精力。': '日本ECサイト（Amazon、BASE、Shopifyなど）とのシステム連携により、在庫管理不要で業務の自動化が実現！商品情報の自動同期や自動発注により、時間と労力を大幅に節約できます。',
  企业会员计划的四大优势: '法人プランでビジネスを加速する4つの理由',
  '商务会员和头等会员提供个人计划无法享受的特别支持和丰富特权，为业务扩展和增长提供助力。以下是三个主要优势，请根据需求选择适合您的计划。': 'ビジネス会員やファースト会員プランは、個人向けプランにはない特別なサポートと豊富な特典が揃っており、ビジネスの拡大と成長に貢献します。以下の4つのメリットをチェックし、最適なプランをお選びください。',
  '高效管理，减轻工作负担': '店舗運営を効率化するサービス体制',
  '商务会员最多支持10家店铺，头等会员则可不限店铺数量使用！通过优化采购到销售的业务流程，帮助您以更少的精力扩大业务。': 'ビジネス会員は最大10店舗まで、ファースト会員は店舗数無制限で利用可能！仕入れから販売までの業務フローを効率化し、より少ない労力でビジネスを拡大できます。',
  专业支持体系: '専属スタッフによる迅速なサポート',
  '提供在线聊天支持，以及由专业负责人提供的Chatwork支持，确保高效、快速的业务运营。': 'オンラインチャットサポートに加え、専門知識を持つ業務リーダーによる専門のChatworkサポートが提供され、効率的で迅速な業務運営が実現します。',
  全面支持品牌成长: 'OEM対応とブランド独占販売で差別化',
  '通过OEM/ODM的全面支持，轻松开发定制商品或自主品牌。品牌独占销售权和优惠价格商品助力差异化竞争，提升品牌价值。': 'OEM・ODM完全対応により、カスタム商品や自社ブランドの開発がスムーズに行えます。また、ブランド独占販売権や割引価格での商品提供を通じて、他社との差別化を実現し、ブランド価値を高めることができます。',
  '根据您的品牌和需求，专属采购员1对1推荐特殊商品。此外，每月可免费获得⚪︎万日元以内的样品，帮助您在低风险下把握市场机会。': '貴社の取り扱いカテゴリーやブランドイメージ、ご希望の価格帯に合わせて、専属バイヤーが1対1で特別な商品を提案します。',
  面向法人的收费计划: '法人さまに最適な料金プランのご案内',
  '我们不仅提供个体经营者，也为法人提供收费计划。提供 OEM 和 ODM 支持及周末客户服务，选择适合您业务规模和需求的最佳计划': '個人事業主の方だけでなく、法人向けの料金プランもご用意しています。\nOEM・ODM対応プランや週末カスタマーサポートに対応しますので、ビジネスの規模やニーズに応じた最適なプランをお選びください。',
  '法人和企业客户请点此 >': '法人・ビジネスのお客様はこちら >',
  个人及个体户的收费计划: '個人・個人事業主に最適な料金プランのご案内',
  '我们还为个体户和个人用户提供会员计划。适合业务起步阶段的新人或希望尝试新挑战的人群，助力他们迈向更高的业务台阶。': '法人だけでなく、個人事業主や個人利用の方向けの料金プランもご用意しています。\nビジネス初心者や新たなチャレンジを目指す方に最適なサポートと特典が充実しており、ビジネスのステップアップをしっかりとサポートします。',
  '个人用户请点击此处 >': '個人利用のお客様はこちら >',
  常见的问题: 'よくある質問：料金プラン選びのポイント',
  免费咨询2: '無料相談で最適なプランをご提案！',
  '若对选择合适的计划有疑问，请随时联系我们。THECKB（直行便）的专业人员将根据您的业务需求为您提供免费咨询。': 'プラン選びに迷っている方は、ぜひお気軽にお問い合わせください。\nTHECKB（直行便）の専門スタッフが、お客様のビジネスニーズに合わせた最適なプランを無料でご案内いたします。',
  免费咨询: '無料で相談する',
  上一步: '前へ',
  仅限在线聊天: 'オンラインチャットのみ',
  '很抱歉，您无法申请该品牌': '申し訳ございませんが、このブランドを申請することはできません',
  '申请前，请先升级至商务舱会员及以上。': '申請するには、 ビジネスプラン以上のご契約が必要です。',
  '申请前，请先升级至标准会员及以上。': '申請するには、スタンダードプラン以上のご契約が必要です。',
  月1回: '月1回',
  商务舱和头等舱的比较: '料金・手数料比較：\nビジネス会員 vs ファースト会員',
  '下单次数超出限制，请升级会员': 'ご注文回数が上限に達しました。会員プランのアップグレードをご検討ください。',
  '非会员只能下单普通商品，请升级会员': '現在の会員プラン（フリー会員）では、ECサイト商品と市場・問屋商品のみ注文可能です。アップグレード後に再度お試しください。',
  包含商务计划的所有服务: 'ビジネスプランのサービス全て',
  会员功能限定去升级: '有料会員限定の機能となります。スタンダード会員に変更後、ご利用いただけます。\n現在、スタンダード会員初月0円キャンペーンを実施中ですので、ぜひご利用ください。',
  您的店铺数量已达上限: '作成可能な店舗数が上限に達しました',
  '{x}件以上（包含{x}件）': '{x}点以上（{x}点も含めて）',
  物流收费规则: '送料計算方法',
  料金ルール: '料金ルール',
  '订单低于15万日元，只能选择空运，订单高于15万日元，可选择空运或者海运。': '注文金額が15万円未満の場合、航空便のみの選択が可能です。15万円以上の場合は、航空便または船便を選択できます',
  '{x}-{y}点': '{x}-{y}点',
  '{x}元/件': '{x}元/点',
  一口价商品账单: '日本円商品（オールイン価格）注文明細書',
  '最终优惠折扣，以通过审核后为准。': '最終的な割引額は、審査完了後に確定されます。',
  '该商品一价全包，单价固定，最终以实际上架数量进行收费，多退少补，请及时关注资金变化。': '日本円価格の商品は単価が固定されています。最終的な料金は実際出荷の数量に基づいて決定され、過不足の分は返金し、もしくは請求されます。注文後は金額の変動にご注意ください',
  海运: '船便',
  空运: '航空便',
  '订单已经生成，请关注订单状态': 'ご注文ありがとうございます',
  'Choice商品订单为一口价订单，商品单价固定，最终以实际上架数量进行收费，多退少补，请及时关注资金变化。': '日本円価格の商品は単価が固定されています。最終的な料金は実際出荷の数量に基づいて決定され、過不足の分は返金し、もしくは請求されます。注文後は金額の変動にご注意ください',
  计价规格: '計算仕様',
  '全包价(JPY)': 'オールイン価格（JPY）',
  '小计(JPY)': '小計（JPY）',
  订单总价: '注文合計額',
  子账户余额可支付: '子アカウントの利用可能残高',
  '主账户可用余额：JPY A CNY B,可转账至子店铺': '親アカウントの利用可能残高：JPY A / CNY B（子店舗への振替が可能）',
  剩余需支付: '残りの支払額',
  '余额可支付JPYX，剩余需支付:': '残高で支払可能な額：JPY X、残りの支払額：',
  '另需paypal手续费（由paypal收取）': 'PayPal手数料（PayPalにより徴収）',
  Choice商品: 'カート（日本円価格商品）',
  代采商品: 'カート（人民元価格商品）',
  一口价: 'オールイン価格',
  设置余额不足提醒: '残高アラート設定',
  请设置提醒金额: '金額は0より大きい値を入力してください',
  请添加子账号: '',
  主账户余额不足提醒: '残高アラート（{x}親口座）',
  '低于该金额（元）时，通知我': '設定した金額（元）を下回ると通知されます',
  子账户余额不足提醒: '残高アラート（{x}店舗口座）',
  选择需提醒的子账号: '店舗選択',
  '您的订单金额大于15万日元，选择船运物流方式更优惠': '現在の注文金額は15万円を超えているため、よりお得な船便を選択可能です',
  需X件起批或搭配其他品类购买: 'カテゴリ：X点から、または他のカテゴリ商品と一緒に注文可',
  一口价无法计算: 'オールイン価格の計算不可',
  '计价规格缺失，如需按照一口价购买商品，请联系业务补充': '商品情報不足のため、オールイン価格の計算ができません。購入ご希望の場合は担当者またはカスタマーサービスまで不足情報を補足の旨ご連絡ください。',
  '购物车代采商品和一口价商品不支持一起递交订单付款，请您按照商品类型依次提交订单完成付款操作': 'カート内の人民元価格商品と日本円価格商品は、まとめて支払うことができません。商品ごとに分けてご注文ください',
  禁用商品无法进行组合: '※無効な商品は組み合わせできません',
  实际清算数量: '実際清算数量',
  全包单价: 'オールイン単価（税込）',
  '合计金额（清算后）': '合計金額（清算後）',
  待清算: '清算待ち',
  '直发订单(一口价)': '直送注文(オールイン価格)',
  '囤货订单(一口价)': '在庫保管注文(オールイン価格)',
  '合计额（清算后）=实际清算数量*全包单价': '合計額（清算後）＝実際の清算数量×オールイン単価',
  一价全包商品发货: '日本円価格商品',
  普通商品发货: '人民元価格商品',
  代采商品良品数: '良品数（人民元商品）',
  一口价良品数: '良品数（日本円商品）',
  账单导出: 'ダウンロード（日本円商品注文）',
  导出账单: '明細書のダウンロード',
  当前支持导出一口价商品的账单: '日本円商品注文の支払い明細をダウンロードできます',
  商品上架时间: '商品入庫日（良品となる日）',
  支付总金额: '支払い総額',
  补扣总金额: '不足分請求総額',
  退款总金额2: '過剰分返金総額',
  退款数量: '過剰分返金数',
  补扣数量: '不足分請求数',
  全包价: 'オールイン価格',
  全包价明细: 'オールイン単価明細',
  '此物流线路只对代采商品生效，choice商品无法选定物流线路': '※運送会社の設定は人民元価格の商品にのみ適用され、日本円価格の商品には適用されません。',
  表格下单暂不支持一口价商品下单: 'エクセル形式での注文は、オールイン価格商品の購入には対応していません。',
  '重量不足，无可用物流': '重量が不足しているため、利用可能な運送会社がありません。',
  '一口价订单汇率已更新，请确认支付': 'オールイン価格注文の為替レートが更新されました。ご確認の上、お支払いください。',
  国际运费已在下单时收取: '国際送料支払い済み（オールイン価格に含む）',
  '发货附加项只对代采商品生效，choice商品无法编辑发货附加项': '※発送オプションは人民元価格の商品にのみ適用され、日本円価格の商品には適用されません。',
  此设置只针对代采商品生效: '※この設定は人民元価格の商品にのみ適用され、日本円価格の商品には適用されません。',
  '提示：一口价商品，单价固定，下单时一次性扣除所有费用，实际费用将在商品上架时按最终上架数量进行收取，多退少补。': '日本円価格の商品は単価が固定されています。最終的な料金は実際出荷の数量に基づいて決定され、過不足の分は返金し、もしくは請求されます。注文後は金額の変動にご注意ください',
  '已为您自动切换物流，订单低于15万日元，只能选择空运，订单高于15万日元，可选择海运或空运': 'ご注文金額に応じて運送方法を自動切替しました。15万円未満は航空便のみ、15万円以上は航空便または船便を選択できます。',
  计价规格缺失商品: '情報不足商品',
  清空失效商品: 'カートから削除',
  失效商品: '失効商品',
  是否清空失效商品: 'カートから失効商品を削除しますか？',
  交易金额: '支払額',
  'choice商品目前仅支持日本，已为你自动切换': '日本円価格の商品は現在、日本へのみ配送対応しています。配送先を日本に自動切り替えました。',
  '购物车空空如也～': 'カートに商品がありません',
  '一口价订单金额发生变化，请重新确认': 'オールイン価格注文の金額が変更されました。再度ご確認ください。',
  '加购成功。其中有商品没有计价规格，请联系业务补充。': 'カートに追加されました。ただし、一部の商品はオールイン価格の計算に必要な情報が不足しています。担当者またはカスタマーサービスまでご連絡のうえ、不足情報をご提供ください。',
  'FaW Tokyo展会专属订单': 'FaW Tokyo展示会専用クーポン',
  请填写展会优惠码: 'クーポンコードを入力',
  裤长: '総丈',
  肩带长: 'ショルダー',
  鞋长: '鞋长',
  '*品牌商品可享更低物流价格': '※ ブランド代理商品の場合、より安い国際送料が適用されます。',
  实物视频: '実物動画',
  下载视频: 'ダウンロード',
  表面: '表面',
  内里: '内側',
  X行: 'X行目',
  商品重复: 'に同じ商品が重複しています',
  '3.导入成功后，请在发货列表查看并核对发货数量': '3.アップロード完了後、「国際発送依頼作成」画面で出荷数量を確認し、依頼を提出してください。',
  发货数量2: '発送数',
  '以下附加项已失效，请重新编辑附加项': `以下の追加オプションは無効です。
「オプション必要なし」を選択してリセット後、必要なオプションを再設定してください。`,
  店舗商品名: '店舗商品名',
  'X品类同一商品起批为Y件（支持不同规格组合）': 'Xは同一商品Y点以上で注文可（色・サイズ違いOK） ',
  '无法批量操作，请去单个商品上维护': '一括操作はできません。各商品ごとに設定してください。',
  '注意：批量水洗标模版功能，只对未下过单的商品生效': '※洗濯タグテンプレートの一括適用は、これまでにテンプレートを設定していない商品にのみ有効です。',
  批量编辑子商品附加项: '子商品オプション一括編集',
  请选择相同国家商品: '異なる国の商品は一括編集できません。国ごとに編集してください。',
  '注意：如需修改水洗标模版，请加入购物车后修改': '※洗濯タグテンプレートの変更は、カート追加後にカート内で行ってください。',
  导入发货数量: '出荷商品を一括インポート',
  发送数大于良品数: '出荷数は良品数を超えることはできません',
  正品: '良品',
  tiktok订单号: '注文番号（TikTok）',
  tiktok订单状态: '注文ステータス（TikTok）',
  tiktok商品状态: '商品ステータス（TikTok）',
  tiktok库存: '在庫数（TikTok）',
  更新tiktok库存: 'TikTok在庫数を更新',
  '将商品库存更新到tiktok商品“总在库数”上': '商品在庫をTikTokの総在庫数に反映',
  'tiktok sku': 'TikTok SKU',
  总在库数: '総在庫数',
  确认更新: '在庫を反映',
  请先在tiktok设置仓库信息: 'TikTokショップに倉庫が未設定です。まずはTikTokセールセンターで設定してください',
  '{x}授权将过期': '{x}で有効期限切れ',
  '解绑后会解除系统内的TikTokshop数据，是否要继续解绑': '連携を解除すると、THE CKBに保存されているTikTokショップのデータがすべて削除されます。',
  解绑提醒: '連携解除のご確認',
  必须为数字: '０より大きい数字を入力してください',
  必须大于0: '０より大きい数字を入力してください',
  '等待上传中，请稍候...': 'アップロード待機中です…',
  '已上传{x}%': '進行状況：{x}％',
  '已完成上传，感谢你的耐心等待！': 'アップロードが完了しました。',
  '正在上传中，请稍候...': 'アップロードしています。しばらくお待ち下さい…',
  上传商品信息: '商品データの更新',
  草稿: '下書き',
  待审核: '規約違反',
  已禁用: '無効',
  在售: '出品中',
  停止中: '停止中',
  已冻结: '無効',
  已删除: '削除済み',
  组合单: 'セット組',
  同一订单X件起批或搭配其他类购买: 'はX点以上で注文可',
  '※同一笔订单任意商品满足起订数量后，其他商品也可一并购买。': '※同じ注文内で、いずれかのカテゴリがロットを満たせば、他のカテゴリの商品も一緒に購入できます。',
  客户shopify销售图: '販売サイトに載せた画像',
  导出发货数量: '​出荷数量をエクスポート​',
  查看活动细则: '特典詳細を見る',
  我的优惠券: 'クーポン一覧',
  待使用: '利用可能',
  已使用: '使用済み',
  去使用: '今すぐ使う',
  优惠券: 'クーポン',
  暂无优惠券: '現在ご利用いただけるクーポンはありません',
  '已优惠{x}元': '割引額：{x}元',
  '国际送料（含远方送料手续费）': '国際送料（長距離料金込み）',
  请确认采购商品信息: '購入商品情報の確認をお願いします。',
  兑换优惠券: 'クーポンを引き換える',
  请输入兑换码: '引き換えコードを入力してください',
  确认兑换: '引き換えを確定',
  优惠券兑换成功: 'クーポンの引き換えが完了しました',
  '国际物流费用(含偏远地区附加费)退回': '国際送料（長距離料金込み）の返金',
  尺码差异2: '不良理由：仕様相違<br/>ロット全体に不良が見られるため、キャンセルを推奨します。<br/>再買付しても改善は見込めず、納期遅延の恐れがあります。',
  配件差异2: '不良理由：付属品違い<br/>ロット全体に不良が見られるため、キャンセルを推奨します。<br/>再買付しても改善は見込めず、納期遅延の恐れがあります。',
  设计差异2: '不良理由：デザイン違い<br/>ロット全体に不良が見られるため、キャンセルを推奨します。<br/>再買付しても改善は見込めず、納期遅延の恐れがあります。',
  染色不良: '不良理由：色移り／染めムラ<br/>検品基準により、不良品と判断されました。',
  抽绳不良: '不良理由：紐不良（欠品・破損・仕様不備など）<br/>検品基準により、不良品と判断されました。',
  '从策划提案到采购、OEM/ODM、质量管理、物流等全流程，提供一站式全方位支持。': '＼企画提案から仕入れ・OEM＆ODM・品質管理・物流まで、ワンストップで徹底サポート！／',
  '海外からの輸入・仕入れ・OEMならTHE CKB（直行便）': '海外からの輸入・仕入れ・<br/>OEMならTHE CKB（直行便）',
  用户数: '利用者数',
  商品数: '商品数',
  什么是直行便: 'THE CKB（直行便）とは？',
  '专注于海外商品批发采购及OEM生产的全方位采购服务。': '海外商品の卸・仕入れ＆OEM生産に特化したワンストップ調達サービスです。',
  '通过线上线下双渠道确保高质量且低成本的采购渠道，依托自有OEM工厂、物流网络及专有系统，实现从订单下达至交付的全流程高效运作。': 'オンライン・オフライン双方で高品質×低コストの仕入れルートを確保し、自社OEM工場・物流ネットワーク・独自システムにより発注〜納品を効率化。',
  '不仅优化日常采购流程，更全程支持原创品牌创建，致力于为客户实现利益最大化。': ' 日々の仕入れ業務の最適化はもちろん、オリジナルブランドの立ち上げまでを一貫して支援し、お客様の利益最大化を目指します。',
  选择CKB的理由: 'THE CKB（直行便）が選ばれる理由',

  '通过多样化的采购渠道，提供丰富多样的商品阵容。': '多彩な仕入れルートで、豊富な商品ラインナップを提供',
  '日本标准的严格检验，品质有保障。': '日本基準の厳格な検品で品質も安心',
  通过自有OEM工厂支持品牌创建: '自社OEM工場でブランド立ち上げをサポート',
  '独自開発のシステムで仕入れ〜出荷を効率化': '独自開発のシステムで仕入れ〜出荷を効率化',
  电话联系时间: 'お気軽にメールまたはお電話にてご相談ください。平日10:30-19:30（13:00-14:15は除きます）',
  其他登录方法: 'その他のログイン方法',
  品牌成长的全方位支持: 'ブランド成長をトータルサポート',
  'THE CKB（直航）付费会员': 'THE CKB（直行便）有料会員',
  '【专属的商品提案】': '商品企画・独自商品のご提案',
  '通过提出差异化产品及未在阿里巴巴平台上架的商品，实现摆脱低价竞争的战略。': '差別化商品・アリババ未掲載商品の提案で、低価格競争から脱却',
  '【品牌代理销售权及折扣价采购】': 'ブランド代理販売権＆割引価格仕入れ',
  '付费会员专享！通过品牌代理销售或独家销售实现与竞争对手的差异化，获得品牌代理销售权及折扣价采购。': '有料会員限定！ブランド代理販売または独占販売で競合との差別化を実現',
  '【OEM/ODM服务及产品选项】': 'OEM・ODM対応＆商品オプション',
  '丰富的定制选项和OEM服务，助力您打造自有品牌。': '豊富なカスタムオプションとOEMでオリジナルブランド展開を支援',
  '【通过dropshipping实现效率化】': 'ドロップシッピングで効率化',
  '日本のECサイトと連携し、在庫なしで自動発注・発送が可能！': '日本のECサイトと連携し、在庫なしで自動発注・発送が可能！',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  // '': '',
  /** 新会员end */
  下单失败2: '注文に失敗しました',
  '您的订单需要“子店铺口座”的余额支付': 'ご注文には「店舗口座」の残高が必要です。',
  '目前，主账户中有余额，但尚未转入子店铺口座。': '現在、親口座に残高がありますが、店舗口座に振替されていません。',
  '主账户余额：X元（可转账）': '親口座残高：X（振替可能）',
  '主账户余额：X元': '親口座残高：X',
  '请先从以下按钮进行转账，然后再下单。': '下記より振替を行ってから、再度ご注文ください。',
  转账方法: '残高の移動方法は',
  点这里: 'こちら',
  去转账给子店铺: '店舗口座に振替する',
  确认账户余额: '口座残高を確認',
  '目前，主账户中有审核中的余额，但是还不能转账。': '現在、親口座にチャージ申請中の残高がありますが、まだ振替できません。',
  审核结束后可以转账: '※審査完了後に振替可能となります。しばらくお待ちください。',
  该商品不支持成本计算: 'すみません、この商品は原価計算に対応しておりません。',
  '当前商品价格发生变化，请确认后决定是否下单': '商品の価格が更新されました。ご確認のうえご注文ください',
  日元: '円',
  日本发货附加项: '日本倉庫発送オプション',
  日本仓已锁定: '日本倉庫はロックされています',
  中国仓已锁定: '中国倉庫はロックされています',
  日本仓可用库存: '日本倉庫の使用可能在庫',
  中国仓可用库存: '中国倉庫の使用可能在庫',
  全部仓: '全倉庫',
  '【重要】当前为到中国仓的囤货单，为了尽快履约tiktok的订单，请联系担当进行日本仓的备货后，再进行直发。': '【※重要】現在は中国倉庫への補充注文です。TikTokの注文を早急に履行するため、日本倉庫に商品の準備を行い、その後直送してください。',
  '【重要】直发订单仅支持有库存的商品，我们不处理无{X}库存状态下的直发订单，因此务必先完成商品囤货之后，再进行直发。': '【※重要】直送注文は在庫がある商品のみ対応しています。在庫がない商品については直送注文を処理しませんので、必ず商品を先に{X}倉庫に準備してから直送を行ってください。',
  '超出库存，无法下单，请先提前备货到中国仓': '在庫不足のため、注文できません。まず中国倉庫に商品を補充してください。',
  '超出库存，无法下单，请先提前备货到日本仓': '在庫が不足しているため、注文できません。事前に日本倉庫に商品を補充してください。',
  '超出库存，无法下单': '在庫不足のため、注文できません。',
  日本仓: '日本倉庫',
  choice商品暂不支持tiktok店铺: 'choice商品は現在titok店舗に対応していません',
  发往的国家: 'お届け先の国',
  实际尺寸: 'THE CKB倉庫実測サイズ',
  '计费尺寸(cm)': '課金サイズ（cm）​​',
  谷歌登录: 'Googleで登録',
  Line登录: 'LINEで登録',
  备货到日本: '日本倉庫への搬送手配',
  常用清关地址导入: '通関先住所を読み込み',
  发到日本的备货单创建成功: '日本倉庫向けの搬送依頼を作成しました',
  留在当前页: '閉じる',
  查看备货单详情: '詳細を見る',
  备货到日本仓: '日本倉庫への搬送手配',
  发货仓库2: '移動元',
  配送到: '移動先',
  '不能接受该不良，希望同商品换货（该换货无需重新冻结费用，如供应商无货，则系统会自动取消）': '上記の商品問題を許容できず不良品として返品し、同ショップで交換を希望します（追加費用の再凍結は不要。仕入先に在庫がない場合は自動キャンセルされます）',
  换货中: '交換手配中',
  换货记录: '交換履歴',
  换货时间: '交換時間',
  换货数量: '交換数量',
  日本仓已锁定数: '日本倉庫利用予定',
  中国仓已锁定数: '中国倉庫利用予定',
  日本仓可用库存数: '日本倉庫良品数',
  中国仓可用库存数: '中国倉庫良品数',
  待补货: '引当待ち',
  当前无需补货: '現時点では引き当ては不要です。',
  智能补货计划: '自動在庫引当機能',
  '每天定时计算api订单中待补货的数量，汇总生成一笔待支付囤货单，无需单笔订单直接去采购，可以根据销量辅助决策做囤货计划。': '毎日指定時刻に、API注文の在庫不足商品を自動集計し、中国：支払い待ちリスト、日本：仕入れ予定リスト をそれぞれ引当用リストとして作成します。  個別仕入れの手間を省き、販売状況に応じて効率よく在庫補充が可能です。',
  '已为您自动生成最新补货订单, 合计待补货商品数X件，': '引当が必要な商品X件を自動でまとめました ▶ 詳細を見る',
  查看并支付待补货订单: '内容を確認して支払い手続きへ',
  建议补货数量: '補充推奨数（合計）',
  历史需补货数: '補充必要数',
  被取消需补货数: '補充キャンセル数',
  开启集成采购计划: '仕入れ集計計画を有効にする',
  多仓发货: '複数倉庫出荷設定',
  当前为仅从中国仓发货: '現在：中国倉庫からのみ発送',
  当前为仅从日本仓发货: '現在：日本倉庫からのみ発送',
  当前为中国仓库优先发货: '現在：中国倉庫を優先して発送',
  当前为日本仓库优先发货: '現在：日本倉庫を優先して発送',
  仅从中国仓发货: '中国倉庫からのみ発送',
  仅从日本仓发货: '日本倉庫からのみ発送',
  '日本仓库优先，不足再取中国仓库存': '日本倉庫を優先し、在庫不足時は中国倉庫から発送',
  '中国仓库优先，不足再取日本仓库存': '中国倉庫を優先し、在庫不足時は日本倉庫から発送',
  '如同一个三方店铺商品关联了多个商品，则会优先取{X}所有关联商品的库存发货，再取{Y}的库存发货，tiktok店铺库存不足不走采购': '※同一商品が複数の商品に紐づいている場合は、{X}から優先出荷され、不足分は{Y}から出荷されます。<br/>※TikTok店舗は在庫がないと発注されないため、事前に在庫をご用意ください。',
  '如同一个三方店铺商品关联了多个商品，则会优先取{X}所有关联商品的库存发货，再取{Y}的库存发货，库存不足走中国采购': '※同一商品が複数の商品に紐づいている場合は、{X}から優先出荷され、不足分は{Y}から出荷されます。<br/>※在庫がすべて不足している場合は、中国倉庫へ自動的に発注されます。',
  '如同一个三方店铺商品关联了多个商品，则会优先取{X}所有关联商品的库存发货，再取{Y}的库存发货，当库存不足时，我们将根据商品的原产国采购并补货至对应的目的地仓库后再发货。': '※同一商品が複数の商品に紐づいている場合は、{X}から優先出荷され、不足分は{Y}から出荷されます。<br/>※在庫が不足している場合は、商品の調達元（中国または日本）に応じて補充手配が行われます。',
  关闭多仓发货: '複数倉庫出荷設定（オフ）',
  开启多仓发货: '複数倉庫出荷設定（オン）',
  多仓发货协议: '「複数倉庫から発送」規約',
  同意开通: 'に同意する',
  仅从日本仓发库存: '日本倉庫からのみ発送',
  库存发货优先级设定: '複数倉庫出荷設定',
  允许多仓发库存: 'ON（オン）',
  不允许多仓发库存: 'OFF（オフ）',
  请先勾选协议: 'ご利用には規約への同意が必要です',
  仅从中国仓发库存: '中国倉庫からのみ発送',
  '仅从中国仓发库存，库存不足走采购从中国仓发': '中国倉庫からのみ発送,在庫不足時は中国倉庫から発送',
  该附加项对于日本仓发货商品不生效: 'このオプションは日本倉庫出荷商品には適用外です。',
  '请注意：关联的商品来自多个国家或多个仓库，会拆成多个订单': '※ご注意：複数倉庫設定により、ご注文が分割される場合があります。',
  日本仓收货地址: '日本倉庫納品先',
  中国仓库: '中国倉庫',
  日本仓库: '日本倉庫(THE CKB)',
  纯电商品: 'バッテリー付き商品',
  带磁商品: '磁気商品',
  玩具: 'おもちゃ',
  会在每日X定时生成: '毎日Xに自動で在庫引当リストが作成されます',
  X点: 'X時',
  采购管理: '引当管理',
  日本商品采购计划: '引当予定リスト',
  待补货计划编码: '引当伝票番号',
  待采购2: '引当待ち',
  已采购2: '引当済み',
  供应商信息: '仕入先',
  建议待采购数量: '引当推奨数（合計）',
  api订单需补货数量: 'API注文に必要な引当数',
  历史采购未使用数量: '未使用の過去引当数',
  实际采购数量: '実際引当数',
  '开启后，每天将会定时生成补货计划，包含所有API订单商品中，未匹配上良品数、未匹配上在途数、已匹配但被取消的商品明细和数量。同时也会为您自动生成对应的待支付囤货单和开启使用在途库存，这样支付完成后api订单将自动进行库存匹配，不完成会影响订单时效，请尽快完成。': 'この機能を有効にすると、毎日指定した時刻に未補充の商品をもとに発注リストが自動作成されます。併せて、未決済の在庫保管注文が自動生成され、「処理中在庫の利用」機能も自動的に有効になります。支払い完了後は、API注文と在庫が自動で紐づけられます。',
  '开启后，每天将会定时生成补货计划，包含所有API订单商品中，未匹配上良品数、未匹配上在途数、已匹配但被取消的商品明细和数量。': 'この機能を有効にすると、毎日指定した時刻に未補充の商品をもとに発注リストが自動作成されます。',
  '同时也会为您自动生成对应的待支付囤货单和开启使用在途库存，这样支付完成后api订单将自动进行库存匹配，不完成会影响订单时效，请尽快完成。': '併せて、未決済の在庫保管注文が自動生成され、「処理中在庫の利用」機能も自動的に有効になります。支払い完了後は、API注文と在庫が自動で紐づけられます。',
  '注意：开启后，如未完成补货，API订单无法走自动采购和发货流程。': '有効化後、引当が未完了のままの場合は、API注文が自動仕入れ・出荷処理に進みません。お早めにご対応ください。',
  定时节点: '時刻の設定',
  新增定时: '追加する',
  关闭智能补货计划: '仕入れ集計計画の停止',
  '关闭后，会为您更新一条补货计划，后续的订单将不计入到补货计划，API订单没有匹配到库存将自动走采购流程。': 'この機能を停止すると、設定時点で引当が未完了の商品をまとめて、一度だけ在庫引当リストが自動生成されます。以降の注文はリストに含まれません。API注文については、在庫がない場合、自動的に発注処理に切り替わります。',
  '您是否要关闭使用在途库存？关闭后则囤货单支付后不会自动匹配直发单，当囤货单商品采购完成上架后才可以匹配直发单。': '処理中在庫の利用も停止しますか？停止すると、在庫保管注文の商品は「検品済み」になるまで、エンドユーザー直送注文に自動紐付けされませんのでご注意ください。',
  确认关闭并生成最新补货计划: '自動在庫引当機能を停止する',
  商品采购状态: '商品仕入状況',
  商品发货状态: '商品出荷状況',
  API自动补货订单: 'API自動引当発注',
  '以下商品需要补货，请及时支付补货囤货单，如不处理会影响API订单时效': '以下の商品は引当が必要です。未払いの場合、API注文の出荷に影響する可能性がありますので、お早めにご対応ください。',
  查看补货明细: '引当明細を確認',
  编辑补货数量: '数量を編集',
  新增商品: '自社仕入商品を登録',
  中国采购: '中国仕入分',
  日本采购: '日本仕入分',
  商品采购国家: '仕入国',
  供应商是否为空: '仕入先情報の有無',
  组合商品2: 'セット作成',
  每日X生成: '毎日Xに自動で在庫引当リストが作成されます',
  '该商品是私域商品，您无法下单': 'この商品はプライベート設定されているため、購入できません。',
  确认开启: '有効化する',
  '已为您自动生成最新的采购计划，合计商品数10件，': '引当が必要な商品X件を自動でまとめました',
  查看采购计划: '▶ 詳細を見る',
  '商品附加项是取店铺默认配置，请重新确认是否调整': '初期設定が適用されています。必要に応じてご確認ください。',
  待匹配: '引当待ち',
  匹配良品: '引当済み',
  '商品信息绑定中，请耐心等待...': '連携処理を実行中です。<br/>しばらくお待ちください...',
  X时: 'X時',
  '已生成最新的补货计划（待支付）': '最新の在庫補充リストが作成されました（未決済）',
  暂不支付: '閉じる',
  支付补货订单: '支払いをする',
  定时节点不能同一时间: '指定された時刻は既に登録されています',
  请选择定时节点: '自動在庫引当機能を有効にしているため、処理中在庫の使用が必須です。',
  '您已经开启智能补货计划，必须使用在途库存': '自動在庫引当機能を有効にしているため、処理中在庫の使用が必須です。',
  实际采购数量不能小于api订单需补货数量: '実際の仕入数は、API注文に必要な引当数より少なくできません。',
  '该商品已经新增成功，无法二次新增，请选择商品进行关联': 'この商品はすでに自社仕入商品に登録済みです。バリエーションを選択して連携してください。',
  供应商信息更新成功: '仕入先情報更新しました。',
  需补货明细: '引当推奨数（合計）',
  历史匹配上但被取消的: '引当必要数',
  '超出库存，无法下单，请提前备货': '在庫不足のため注文できません。日本倉庫に事前補充してください。',
  '补货计划手动更新已提交，系统正在处理中，请稍后刷新页面查看结果': '更新処理中です。しばらくしてからページを再読み込みしてください。',
  手动更新补货计划: '引当リストを更新',
  入库中: '入庫作業中',
  '3.导入成功后将更改供应商信息': '3.アップロード後、仕入先情報は自動更新されます',
  批量导入供应商信息: '仕入先情報を一括アップロード',
  修改定时: '時刻の設定',
  确认修改: '確認',
  API订单导出: 'API注文エクスポート',
  '集成采购计划功能上线后，系统将改变原有的逐单采购模式，转为按设定周期自动汇总需求。在指定时间段内生成的API订单将暂不下单，而是由系统整合为集合采购单，用户可对建议补货数量进行调整，以实现更精准的库存管控。该功能有助于企业稳定在库水平，提高订单履约时效，同时避免产生过高库存压力。用户只需设定好补货截止时间，系统将在该节点自动生成优化的采购计划，提升采购效率与库存健康度。': 'この設定を有効にすると、従来の「注文ごとの都度発注」から、一定期間内の注文をまとめて管理・発注する方式に切り替わります。<br/><br/>指定期間内に発生したAPI連携注文は即時発注されず、システム上で一時的に集計されます。その後、自動で補充リストが作成され、推奨補充数の確認・調整が可能です。<br/><br/>この仕組みにより：<br/>・過剰在庫を抑えながら、安定的な在庫運用が可能に<br/>・出荷対応のリードタイムを短縮<br/>・補充業務の効率化と在庫の最適化を同時に実現<br/><br/>補充時刻を事前に設定しておくだけで、最適な仕入れ計画が自動で作成されます。',
  确认采购明细: '引当明細を確認する',
  '暂无商品，请先去搜索商品': '商品がありません。まず商品を検索してください。',
  日本商品有限在此tab下搜索: '日本商品を優先的にこちらで検索・関連付けします',
  '请输入商品名&sku编码': '商品名かSKUコードを入力してください',
  发货完了: '出荷完了',
  '申请取消成功后，系统将自动取消发货，但您需自行处理API关联平台的订单。': '※キャンセル申請完了後、出荷は自動キャンセルされます。<br/>API側の注文処理は自動では行われませんので、お客様ご自身でご対応ください。',
  'THE CKB日本仓功能已上线，提前备货到日本仓享高效履约服务。': 'THE CKB日本倉庫での在庫保管が可能になりました。事前納品でスムーズな配送をサポートします！',
  请切换囤货目的仓库: '保管予定倉庫を日本倉庫に切り替える',
  新手操作引导: 'はじめてご利用の方はこちら ▶ ご利用ガイド',
  囤货仓库: '保管予定倉庫',
  编辑2: '選択する',
  关于出口仓库选择的指引: '保管予定倉庫の選択について',
  '为确保您的商品顺利配送并符合出口申报政策，请根据出口模式合理选择仓库。': '商品をスムーズに出荷・納品するために、注文時はご希望の保管倉庫をあらかじめご選択ください。',
  '若选择中国仓（含杭州仓、广州仓、平湖仓），商品将通过个人直邮（D2C）模式出口，必须直接发往日本的最终消费者，不得转运至其他仓库。': '<b>・【中国倉庫】を選択</b><br/>商品は中国倉庫で検品後、エンドユーザー様へ直送されます。別倉庫への移動はできません。',
  '若选择日本仓，商品需先在中国仓完成质检，再由统一渠道转运至日本仓（B2B模式），最后由日本仓派送给最终消费者。': '<b>・【日本倉庫】を選択</b><br/>商品は中国倉庫で検品・良品登録された後、お客様ご自身による「日本倉庫への搬送依頼」が必要です。THE CKB指定ルートにて日本倉庫へ搬送され、最終的にエンドユーザー様へ出荷されます。<br/>※注文時に日本倉庫を選択していない場合、後から搬送はできません。',
  '请根据您的实际需求谨慎选择。如有任何疑问，请联系平台客服。': '※倉庫の選択は後から変更できません。内容をご確認のうえご選択ください。<br/>ご不明な点がございましたら、お気軽にカスタマーサービスまでお問い合わせください。',
  '良品数(仅可备货)': '良品数（日本倉庫搬送専用）',
  '良品数(仅可直发)': '良品数（直送専用）',
  是否海外备货: '日本倉庫向け注文',
  海外备货: '日本倉庫向け',
  'D2C备货到日本 操作手册': 'D2C日本倉庫向け事前納品ガイド',
  整体流程: '全体の流れ',
  'D2C在库保有，选择日本仓库': '「お客様」D2C在庫保有注文を発注',
  '中国采购，中国仓入库质检': '「THE CKB」中国仕入れ・中国倉庫で検品',
  日本仓搬送申请: '「お客様」良品の日本倉庫搬送を申請',
  日本仓良品上架: '「THE CKB」日本倉庫へ納品',
  '注意：下单成功后，无法修改保管仓库，请谨慎选择': '⚠ご注文確定後の倉庫変更はできませんので、あらかじめご確認のうえご選択ください。',
  海关申报信息: '申告情報',
  待填写: '入力する',
  截止发货时间: '出荷締切日時',
  '[]': ''
}
